import {
    /*CRUDBasicDetailComponent_Template, */ CRUDBasicDetailComponent,
} from "../crud-basic-detail/crud-basic-detail.component";

import {
    Component,
    forwardRef,
    Inject,
    Injector,
    OnInit,
    ViewChild,
} from "@angular/core";
import { Validators } from "@angular/forms";
import { GenericValidator } from "../_helpers/generic-validator";
import { TranslateService } from "../_services/translate.service";
import { AppComponent } from "../app.component";
//import { AutoComplete } from 'primeng/autocomplete';

//import { IKopfdaten } from '../_interfaces/kopfdaten';
import { KopfdatenService } from "../_services/kopfdaten.service";
//import { KopfdatenDetailGuard } from './kopfdaten-detail.guard';
//import { ICheckliste } from '../_interfaces/checkliste';
import { Params } from "@angular/router";
import * as cloneDeep from "lodash/cloneDeep"; // DateTimeOffset-Fix
import * as moment from "moment";
import { Message } from "primeng/api";
import { Checkbox } from "primeng/checkbox";
import { FileUpload } from "primeng/fileupload";
import { TabView } from "primeng/tabview";
import { IAuftragsdaten } from "../_interfaces/auftragsdaten";
import { IBenutzer } from "../_interfaces/benutzer";
import { ICheckliste } from "../_interfaces/checkliste";
import { ILeistungskatalogSpediteur } from "../_interfaces/leistungskatalog-spediteur";
import { IPositionsdatenFelder } from "../_interfaces/positionsdaten-felder";
import { IPositionsdatenFotos } from "../_interfaces/positionsdaten-fotos";
import { AuftragsdatenService } from "../_services/auftragsdaten.service";
import { BehaelterService } from "../_services/behaelter.service";
import { ChecklistePositionService } from "../_services/checkliste-position.service";
import { ChecklistePositionenFeldService } from "../_services/checkliste-positionen-feld.service";
import { ChecklisteService } from "../_services/checkliste.service";
import { DokumenteService } from "../_services/dokumente.service";
import { LeistungRueckgemeldetService } from "../_services/leistung-rueckgemeldet.service";
import { LeistungService } from "../_services/leistung.service";
import { LeistungskatalogSpediteurService } from "../_services/leistungskatalog-spediteur.service";
import { PositionsdatenFelderService } from "../_services/positionsdaten-felder.service";
import { PositionsdatenFotosService } from "../_services/positionsdaten-fotos.service";
import { PositionsdatenService } from "../_services/positionsdaten.service";
import { validateCommaSeparatedEMails } from "../_validators/email-validator";
import { CRUDBasicSignatureComponent } from "../crud-basic-signature/crud-basic-signature.component";
import { AuftragsChecklisteDetailGuard } from "./auftrags-checkliste-detail.guard";

import { SelectButton } from "primeng/selectbutton";
import { Subscription } from "rxjs";
import { IBehaelter } from "../_interfaces/behaelter";
import { IChecklistePositionenFeld } from "../_interfaces/checkliste-positionen-feld";
import { ILeistung } from "../_interfaces/leistung";
import { IPositionsdaten } from "../_interfaces/positionsdaten";
import { DatumOhneZeitPipe } from "../_pipes/datum-ohne-zeit.pipe";
import { _SystemService } from "../_services/_system.service";

import { AuftragsDokumentService } from "../_services/auftrags-dokument.service";
import { CRUDBasicAutocompleteComponent } from "../crud-basic-autocomplete/crud-basic-autocomplete.component";

//import { AuftragsChecklisteDetailComponent_Template } from './auftrags-checkliste-detail.component.include_template';
declare var jquery: any;
declare var $: any;

export interface Image {
    previewImageSrc?;
    thumbnailImageSrc?;
    alt?;
    title?;
}

export interface I_Abhaengigkeit {
    undOder: string;
    operator: string;
    //platzhalterFeld: platzhalterFeld,
    feldwert: any;
    vergleichswert: any;
    summary: string;
}

@Component({
    selector: "app-auftrags-checkliste-detail",
    //template: `${CRUDBasicDetailComponent_Template || ''}${AuftragsChecklisteDetailComponent_Template}`,
    templateUrl: "./auftrags-checkliste-detail.component.html",
    styleUrls: ["./auftrags-checkliste-detail.component.scss"],
    host: {
        "(window:keydown)": "hotkeys($event)",
        "(window:resize)": "resizeFileUpload()",
    },
})
export class AuftragsChecklisteDetailComponent
    extends CRUDBasicDetailComponent
    implements OnInit
{
    @ViewChild("signaturePadKunde")
    public signaturePadKunde: CRUDBasicSignatureComponent;
    @ViewChild("signaturePadPruefer")
    public signaturePadPruefer: CRUDBasicSignatureComponent;

    // CHILD-spezifisch: Konstanten - START
    CRUDItemKurzform: string = "Checkliste";
    CRUDPageTitleNeu: string = this.translate.instant("Neue Checkliste", true);
    CRUDPageTitleBearbeiten: string = this.translate.instant(
        "Checkliste bearbeiten",
        true,
    );
    CRUDItemBezeichnungSingularCapitalized: string = "Kopfdaten";
    CRUDItemBezeichnungPluralCapitalized: string = "Kopfdaten";
    CRUDItemBezeichnungSingular: string = "kopfdaten";
    CRUDItemBezeichnungPlural: string = "kopfdaten";
    CRUDItemRouteSingular: string = "kopfdaten";
    CRUDItemRoutePlural: string = "kopfdaten";
    CRUDItemHelpTopic: string = null;

    CRUDMethodNameGet: string = "getKopfdatenIncludingLeistungen"; // Alternative Methode (im Service), die bei get aufgerufen werden soll

    // CHILD-spezifisch: Konstanten - Ende

    // CHILD-spezifisch: zusätzliche Widgets (ausser Standard Inputs, Autocomplete) - START
    debugMode: boolean = false;
    debug_ProgressbarRefresh: boolean = false;

    offlineMode: boolean = false;

    datumOhneZeitPipe: DatumOhneZeitPipe = new DatumOhneZeitPipe();

    // queryParams
    queryParams: Params = null;

    // benutzer
    benutzer: IBenutzer = null;
    benutzerSubscription: Subscription = null;

    // Tab
    @ViewChild("tabView") tabView: TabView;
    tabSelected = 0;
    tabShowStart = true;
    tabShowAbschluss = false; // tab Abschluss dauerhaft ausblenden!
    // Nummern der Tabs - wird ggf. umnummeriert (alles -1), falls Start ausgeblendet wird - oder keine Unterschrift Kunde (laut Leistung)
    tabNRStart = 0;
    tabNRPos = 1;
    tabNRLeistungen = null; // Standardmässig gar nicht vorhanden. Nur bei Spediteur. Dann direkt nach den Pos.
    tabNRKopf = 2;
    tabNRAbschluss = /*3*/ null; // tab Abschluss dauerhaft ausblenden!
    tabNRUnterschriftKunde = 4 - 1; // tab Abschluss dauerhaft ausblenden!
    tabNRUnterschriftPruefer = 5 - 1; // tab Abschluss dauerhaft ausblenden!

    // Start
    startLastValidationWasInvalid = false; // war die letzte Prüfung der Startseite invalid ? -> nur dann "Überspringen" anzeigen

    // Pos
    posSelected = 0;
    posCountTouchedOrAlreadySavedAndValid = 0;
    posErrors: any = []; // Achtung: die mit checklistePositionenFeldId < 0 bedeuten:
    posErrorChecklistePositionenFeldId_BemerkungDesMangels = -1;
    posErrorChecklistePositionenFeldId_FotoDesMangels = -2;
    posErrorChecklistePositionenFeldId_BemerkungDerBehebung = -3;
    posErrorChecklistePositionenFeldId_FotoDerBehebung = -4;
    posErrorChecklistePositionenFeldId_FotoAllgemein = -5;
    posJaNeinOptions = [
        { label: "Ja", value: "T" },
        { label: "Nein", value: "F" },
    ];
    posLetzteSichtbare: number = null; // hier wird immer die letzte sichtbare (nicht ausgeblendete) PosNr. berechnet

    // Fix für pos-Zeitfelder: wenn soeben geblurrt, und gleich wieder gefocused (macht er automatisch), dann nicht wieder bestücken
    //posFeldTimeLastBlurredField: IPositionsdatenFelder = null;
    //posFeldTimeLastBlurredTime: Date = null;

    // in Ordnung/n.i.O./Behoben
    /*posIO_NIO_BehobenOptions = [
    {label: 'in Ordnung', value: 'IO'},
    {label: 'n.i.O.', value: 'NIO'},
    {label: 'Behoben', value: 'BEHOBEN'},
  ];
  posBewertungValue: string = null;
  */

    posFeldTextMaxLen: number = 1000; // maximal zulässige Länge von string udn text-Eingaben // siehe *TEXT1000

    // Auftragsdaten
    auftragsdaten: IAuftragsdaten = null;

    // Dienstleister
    dienstleister: /*IDienstleister*/ any = null;

    // LeistungskatalogSpediteur
    leistungskatalogSpediteur: ILeistungskatalogSpediteur[] = null;

    // Checkliste
    checkliste: ICheckliste = null;

    // Leistung
    leistung: ILeistung = null;

    // anlagenbeschreibung
    //public anlagenbeschreibungSelected: any = null;
    //public anlagenbeschreibungOptions = [
    //{ id: null, value: null, bezeichnung: '' },
    //{ _id: 1, value: 'A', bezeichnung: 'Autogasanlage' },
    //{ _id: 2, value: 'B', bezeichnung: 'Brenngasanlage' },
    //{ _id: 3, value: 'T', bezeichnung: 'Treibgasanlage' },
    //];

    // Pumpentyp
    public pumpentypOptions = [
        //{ id: null, value: null, bezeichnung: '' },
        {
            _id: 1,
            value: 'Blackmer - LBG 1"',
            bezeichnung: 'Blackmer - LBG 1"',
        },
        {
            _id: 1,
            value: 'Blackmer - LBG 1.25"',
            bezeichnung: 'Blackmer - LBG 1.25"',
        },
        {
            _id: 1,
            value: 'Blackmer - LBG 1.5"',
            bezeichnung: 'Blackmer - LBG 1.5"',
        },
        { _id: 1, value: "Ebsray - RC20", bezeichnung: "Ebsray - RC20" },
        { _id: 1, value: "Ebsray - RC25", bezeichnung: "Ebsray - RC25" },
        { _id: 1, value: "Ebsray - RX33", bezeichnung: "Ebsray - RX33" },
        {
            _id: 1,
            value: "SIHI - SC2003/5 AA AFU 1A Y",
            bezeichnung: "SIHI - SC2003/5 AA AFU 1A Y",
        },
        {
            _id: 1,
            value: "SIHI - SC2003/5 BA AFU 1A Q",
            bezeichnung: "SIHI - SC2003/5 BA AFU 1A Q",
        },
        {
            _id: 1,
            value: "SIHI - SC2004/5 BA AFU 1A Q",
            bezeichnung: "SIHI - SC2004/5 BA AFU 1A Q",
        },
        {
            _id: 1,
            value: "Veeder-Root - Red Jacket LPG300V17-21 Premier",
            bezeichnung: "Veeder-Root - Red Jacket LPG300V17-21 Premier",
        },
        {
            _id: 1,
            value: "Veeder-Root - Red Jacket LPG300V17-21 Premier Hi Flow",
            bezeichnung:
                "Veeder-Root - Red Jacket LPG300V17-21 Premier Hi Flow",
        },
        { _id: 1, value: "Viking - HJ4195", bezeichnung: "Viking - HJ4195" },
        { _id: 1, value: "Viking - HJ895", bezeichnung: "Viking - HJ895" },
    ];

    // Abschlussfragen
    jaNeinOptions = [
        { label: "Ja", value: true },
        { label: "Nein", value: false },
    ];
    // Abschlussfragen:    // Prüfergebnis entfällt -> es wird eine eigene Pos erstellt.
    //public pruefergebnisOptions = [
    //  //{ id: null, value: null, bezeichnung: '' },
    //  { _id: 1, value: 'O', bezeichnung: 'Ohne Mängel' },
    //  { _id: 1, value: 'M', bezeichnung: 'Mit Mängel' },
    //  { _id: 1, value: 'S', bezeichnung: 'Mit Mängel nicht bestanden – Stilllegung der Anlage.' },
    //];

    // zusätzliche eMails
    //zusaetzlicheEMails = [];

    zaehlerEnabled: boolean = null;

    // Bilder
    // WICHTIG:
    // this.positionsdatenFotosFileUpload.files + this.positionsdatenFotosGalleryImages IMMER GLEICHZIEHEN, this.CRUDItem.positionsdatenFotos nur bei getValuesFromForm akualisieren!
    @ViewChild("positionsdatenFotosFileUpload_mangel")
    public positionsdatenFotosFileUpload_mangel: FileUpload;
    @ViewChild("positionsdatenFotosFileUpload_behoben")
    public positionsdatenFotosFileUpload_behoben: FileUpload;
    @ViewChild("positionsdatenFotosFileUpload_allgemein")
    public positionsdatenFotosFileUpload_allgemein: FileUpload;
    //@ViewChild('positionsdatenFotosGalleria') public positionsdatenFotosGalleria: Galleria;
    ////positionsdatenFotosFileUpload.files : File[] = [];
    positionsdatenFotosFileUpload_files_mangel: File[] = [];
    positionsdatenFotosFileUpload_files_behoben: File[] = [];
    positionsdatenFotosFileUpload_files_allgemein: File[] = [];
    //positionsdatenFotosGalleryImages: Image[] = null;
    //positionsdatenFotosDisplayGalleryOrUpload: string = "U";
    positionsdatenFotosTitlePicGuid: string = "00000000"; // guid des Titelbildes
    //positionsdatenFotosAlreadySwitchedToGallery: boolean = false; // schon einmal autom. auf Gallery geswitched (das machen wir nur 1mal, danach soll der User manuell switchen)
    positionsdatenFotoAktuellUploadingFile: any = null;
    positionsdatenFotoIsUploading = false;
    positionsdatenFotoAccordionSelected_mangel = true;
    positionsdatenFotoAccordionSelected_behoben = true;

    // das (i) soll bei Checkboxen möglichst direkt neben dem Checkbox-Text dargestellt werden.
    // Dazu müssen wir wissen wie breit der breiteste Checkbox-Text ist
    calcWidthOfString_canvas: any = null;
    feldTypCheckBoxMaxWidthInPx: number = -1;
    feldTypCheckBoxAdditionalSpace: number = 60; // Wie breit sind die anderen Elemente -abgesehen vom Text- bei checkbox (die checkbox selbst + space + Kennzeichen Mussfeld)

    // Unterschrift
    //unterschrift = null;
    unterschriftKundeEMailRequired: boolean = null;
    unterschriftKundeRequired: boolean = null;

    // wellDone Dialog / saveWithoutValidators
    wellDoneDialogShow: boolean = false;
    wellDoneDialogSkip: boolean = null; // Merker, dass aktuell nur "Zwischengespeichert" wird -> kein wellDoneDialog

    // offene Mängel Dialog
    offeneMaengelDialogShow: boolean = false;
    offeneMaengelExist: boolean = null;

    dokumenteDialogShow: boolean = false;

    // logo
    urlToLogo: string = null;

    // primeNg Crash, wenn man saved, während datey/dateMY/time sichtbar! TypeError: date.getMonth is not a function at set defaultDate (primeng-calendar.mjs:114:38)
    // Workaround: während Save ausblenden!
    hideDuringSave: boolean = false;

    // pruefdatum
    pruefDatumValuePreviousValue?: Date;

    // CHILD-spezifisch: zusätzliche Widgets (ausser Standard Inputs, Autocomplete) - ENDE

    constructor(
        @Inject(forwardRef(() => AppComponent)) public _app: AppComponent,
        private _injector: Injector,
        private _translate: TranslateService,
        private _crudItemService: KopfdatenService,
        private _guard: AuftragsChecklisteDetailGuard,

        // CHILD-spezifisch: zusätzliche Services - START
        private dokumenteService: DokumenteService,
        private auftragsDokumentService: AuftragsDokumentService,
        private behaelterService: BehaelterService,
        private checklisteService: ChecklisteService,
        private checklistePositionenService: ChecklistePositionService,
        private checklistePositionenFeldService: ChecklistePositionenFeldService,
        private positionsdatenService: PositionsdatenService,
        private positionsdatenFelderService: PositionsdatenFelderService,
        private positionsdatenFotosService: PositionsdatenFotosService,
        private leistungsService: LeistungService,
        private auftragsdatenService: AuftragsdatenService,
        private _systemService: _SystemService,
        private leistungskatalogSpediteurService: LeistungskatalogSpediteurService,
        private leistungRueckgemeldetService: LeistungRueckgemeldetService,
        // CHILD-spezifisch: zusätzliche Services - ENDE
    ) {
        super(_app, _injector);
        console.log("AuftragsChecklisteDetailComponent.constructor()");

        this.crudItemService = _crudItemService;
        this.guard = _guard;

        // CHILD-spezifisch die Validator Messages bestücken - START
        this.validationMessages = {
            pruefer: {
                required:
                    this._translate.instant("Prüfer", true) +
                    ": " +
                    this._translate.instant("ist erforderlich", true),
                maxlength:
                    this._translate.instant("Prüfer", true) +
                    " " +
                    this._translate.instant(
                        "darf 255 Zeichen nicht überschreiten",
                        true,
                    ),
            },

            //pruefergebnisSelected: {
            //  required: this._translate.instant('Prüfergebnis', true) + ': ' + this._translate.instant('ist erforderlich', true),
            //maxlength: this._translate.instant('Ergebnis', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
            //},

            betriebskennzeichen: {
                required:
                    this._translate.instant("Betriebskennzeichen", true) +
                    ": " +
                    this._translate.instant("ist erforderlich", true),
                maxlength:
                    this._translate.instant("Betriebskennzeichen", true) +
                    " " +
                    this._translate.instant(
                        "darf 255 Zeichen nicht überschreiten",
                        true,
                    ),
            },

            //datumNaechsteAnlagenpruefung: {
            //  required: this._translate.instant('Datum Nächste Anlagenprüfung', true) + ': ' + this._translate.instant('ist erforderlich', true),
            //},

            nachpruefungErforderlich: {
                required:
                    this._translate.instant("Nachprüfung Erforderlich", true) +
                    ": " +
                    this._translate.instant("ist erforderlich", true),
                maxlength:
                    this._translate.instant("Nachprüfung Erforderlich", true) +
                    " " +
                    this._translate.instant(
                        "darf 255 Zeichen nicht überschreiten",
                        true,
                    ),
            },

            bemerkung: {
                maxlength:
                    this._translate.instant("Bemerkung", true) +
                    " " +
                    this._translate.instant(
                        "darf 255 Zeichen nicht überschreiten",
                        true,
                    ),
            },

            eMailversandProtokoll: {
                maxlength:
                    this._translate.instant("E-Mail-Versand Protokoll", true) +
                    " " +
                    this._translate.instant(
                        "darf 255 Zeichen nicht überschreiten",
                        true,
                    ),
            },

            unterschriftPruefer: {
                required:
                    this._translate.instant(
                        "Unterschrift befähigte Person",
                        true,
                    ) +
                    ": " +
                    this._translate.instant(
                        "Die Unterschrift ist erforderlich",
                        true,
                    ),
                //maxlength: this._translate.instant('Unterschrift befähigte Person', true) + ' ' + this._translate.instant('darf 0 Zeichen nicht überschreiten', true)
                minlength:
                    this._translate.instant(
                        "Unterschrift befähigte Person",
                        true,
                    ) +
                    ": " +
                    this._translate.instant(
                        "Die Unterschrift ist nicht gültig",
                        true,
                    ),
            },

            unterschriftKunde: {
                required:
                    this._translate.instant("Unterschrift Kunde", true) +
                    ": " +
                    this._translate.instant(
                        "Die Unterschrift ist erforderlich",
                        true,
                    ),
                //maxlength: this._translate.instant('Unterschrift Kunde', true) + ' ' + this._translate.instant('darf 0 Zeichen nicht überschreiten', true)
                minlength:
                    this._translate.instant("Unterschrift Kunde", true) +
                    ": " +
                    this._translate.instant(
                        "Die Unterschrift ist nicht gültig",
                        true,
                    ),
            },

            pruefdatum: {
                // Achtung: Bei Spediteuren heisst das "Lieferdatum"! - wird programmtechnisch geändert. s.u.
                required:
                    this._translate.instant("Prüfdatum", true) +
                    ": " +
                    this._translate.instant("ist erforderlich", true),
            },

            //anlagenbeschreibungSelected: {
            //  required: this._translate.instant('Anlagenart', true) + ': ' + this._translate.instant('ist erforderlich', true),
            //},

            pumpentypSelected: {
                required:
                    this._translate.instant("Pumpentyp", true) +
                    ": " +
                    this._translate.instant("ist erforderlich", true),
            },

            anstrichSelected: {
                required:
                    this._translate.instant("Neuer Anstrich in Farbe", true) +
                    ": " +
                    this._translate.instant("ist erforderlich", true),
            },

            //behaelterdruck: {
            //  required: this._translate.instant('Behälterdruck', true) + ': ' + this._translate.instant('ist erforderlich', true),
            //},

            //behaelterfuellgrad: {
            //  required: this._translate.instant('Behälterfüllgrad', true) + ': ' + this._translate.instant('ist erforderlich', true),
            //},

            unterschriftKundeName: {
                required:
                    this._translate.instant("Unterschrift Kunde", true) +
                    ": " +
                    this._translate.instant(
                        "Bitte geben Sie den Namen an",
                        true,
                    ),
                maxlength:
                    this._translate.instant("Unterschrift Kunde", true) +
                    ": " +
                    this._translate.instant(
                        "Der Name darf maximal 100 Zeichen betragen",
                        true,
                    ),
            },
            unterschriftKundeEMail: {
                required:
                    this._translate.instant("Unterschrift Kunde", true) +
                    ": " +
                    this._translate.instant(
                        "Bitte geben Sie die E-Mail-Adresse an",
                        true,
                    ),
                maxlength:
                    this._translate.instant("Unterschrift Kunde", true) +
                    ": " +
                    this._translate.instant(
                        "Die E-Mail-Adresse darf maximal 100 Zeichen betragen",
                        true,
                    ),
                email:
                    this._translate.instant("Unterschrift Kunde", true) +
                    ": " +
                    this._translate.instant(
                        "Die E-Mail-Adresse ist ungültig",
                        true,
                    ),
            },
            unterschriftPrueferName: {
                required:
                    this._translate.instant(
                        "Unterschrift befähigte Person",
                        true,
                    ) +
                    ": " +
                    this._translate.instant(
                        "Bitte geben Sie den Namen an",
                        true,
                    ),
                maxlength:
                    this._translate.instant(
                        "Unterschrift befähigte Person",
                        true,
                    ) +
                    ": " +
                    this._translate.instant(
                        "Der Name darf maximal 100 Zeichen betragen",
                        true,
                    ),
            },

            zusaetzlicheEMailAdressenArr: {
                email_ungueltig: this._translate.instant(
                    "Die zusätzlichen E-Mail-Adressen enthalten eine ungültige Adresse",
                    true,
                ), // custom validator
                maxlength:
                    this._translate.instant(
                        "Die zusätzlichen E-Mail-Adressen",
                        true,
                    ) +
                    " " +
                    this._translate.instant(
                        "dürfen 500 Zeichen nicht überschreiten",
                        true,
                    ),
            },

            //massnahmenAbgeschlossen: { // tab Abschluss dauerhaft ausblenden!
            //  required: this._translate.instant('Bitte geben Sie an, ob die Maßnahmen abgeschlossen sind', true),
            //},

            //weiterbetrieb: { // tab Abschluss dauerhaft ausblenden!
            //  required: this._translate.instant('Bitte geben Sie an, ob es gegen den Weiterbetrieb der Anlage Bedenken gibt', true),
            //},

            // Felder aus Auftragsdaten, die aber hier mit verwaltet werden
            /*_Auftragsdaten_BehaelterSelected: {
        required: this._translate.instant('Behälter', true) + ': ' + this._translate.instant('ist erforderlich', true), // #39321: Nach "Verschiebung" der Behälternummer in die Feldtypen: gar kein Validator mehr!
      },*/
        };
        // CHILD-spezifisch die Validator Messages bestücken - ENDE

        this.genericValidator = new GenericValidator(this.validationMessages);

        this.buildForm();
    }

    buildForm() {
        // CHILD-spezifisch die Form aufbauen - START
        this.CRUDForm = this.fb.group({
            // Startseite
            pruefdatum: [null, [Validators.required]], // ACHTUNG: siehe removeValidators() / restoreValidators() !!!
            anlagenbeschreibungSelected: [null /*, [Validators.required]*/], // ACHTUNG: siehe removeValidators() / restoreValidators() !!! -> Das Feld ist nicht mehr sichtbar, daher auch keine Prüfungen
            //behaelterdruck: [null, [Validators.required]], // ACHTUNG: siehe removeValidators() / restoreValidators() !!!
            //behaelterfuellgrad: [null, [Validators.required]], // ACHTUNG: siehe removeValidators() / restoreValidators() !!!
            pumpentypSelected: [null, [Validators.required]], // ACHTUNG: siehe removeValidators() / restoreValidators() !!! - AUSSERDEM: nach Ermittlung der Leistung: updateValidatorsDependingFromLeistung()
            anstrichSelected: [null, [Validators.required]], // ACHTUNG: siehe removeValidators() / restoreValidators() !!! - AUSSERDEM: nach Ermittlung der Leistung: updateValidatorsDependingFromLeistung()

            // Kopfdaten
            bemerkung: ["", [Validators.maxLength(255)]],
            datumNaechsteAnlagenpruefung: [null /*, [Validators.required]*/], // ACHTUNG: siehe removeValidators() / restoreValidators() !!!

            // Abschlussfragen
            //massnahmenAbgeschlossen: [null/*, [Validators.required]*/], // tab Abschluss dauerhaft ausblenden! // ACHTUNG: siehe removeValidators() / restoreValidators() !!!
            //weiterbetrieb: [null/*, [Validators.required]*/], // tab Abschluss dauerhaft ausblenden! // ACHTUNG: siehe removeValidators() / restoreValidators() !!!
            //pruefergebnisSelected: [null, [Validators.required]], // ACHTUNG: siehe removeValidators() / restoreValidators() !!!

            // Unterschrift Kunde
            unterschriftKundeName: [
                "",
                [Validators.required, Validators.maxLength(100)],
            ], // ACHTUNG: siehe removeValidators() / restoreValidators() !!!
            unterschriftKunde: [
                "",
                [
                    Validators.required /*, Validators.maxLength(0)*/,
                    Validators.minLength(8000),
                ],
            ], // ACHTUNG: siehe removeValidators() / restoreValidators() !!!
            unterschriftKundeEMail: [
                "",
                [
                    Validators.required,
                    Validators.maxLength(100),
                    Validators.email,
                ],
            ], // ACHTUNG: siehe removeValidators() / restoreValidators() !!!

            // Unterschrift Prüfer
            unterschriftPrueferName: [
                "",
                [Validators.required, Validators.maxLength(100)],
            ], // ACHTUNG: siehe removeValidators() / restoreValidators() !!!
            unterschriftPruefer: [
                "",
                [
                    Validators.required /*, Validators.maxLength(0)*/,
                    Validators.minLength(8000),
                ],
            ], // ACHTUNG: siehe removeValidators() / restoreValidators() !!!
            zusaetzlicheEMailAdressenArr: [
                "",
                [Validators.maxLength(500), validateCommaSeparatedEMails(null)],
            ], // nicht async aber abgeleitet von async validator https://www.tektutorialshub.com/angular/angular-async-validator-example/ // ACHTUNG: siehe removeValidators() / restoreValidators() !!!

            // Felder aus Auftragsdaten (die aber innerhalb dieser Entity mit verwaltet werden)
            _Auftragsdaten_Wiedervorlage: [null],
            _Auftragsdaten_BehaelterSelected: [
                null /*, [Validators.required]*/,
            ], // ACHTUNG: siehe removeValidators() / restoreValidators() !!! - AUSSERDEM: nach Ermittlung der Leistung: updateValidatorsDependingFromLeistung()
            // #39321: Nach "Verschiebung" der Behälternummer in die Feldtypen: gar kein Validator mehr!

            // NOT IN USE
            pruefer: [
                "" /*, [Validators.required, Validators.maxLength(255)]*/,
            ],
            rueckmeldedatum: [null],
            betriebskennzeichen: [
                "" /*, [Validators.required, Validators.maxLength(255)]*/,
            ],
            datumNaechsteFeststellungspruefung: [null],
            nachpruefungErforderlich: [
                "" /*, [Validators.required, Validators.maxLength(255)]*/,
            ],
            datumNachpruefungBis: [null],
            eMailversand: [false],
            eMailversandProtokoll: ["", [Validators.maxLength(255)]],
        });
        // CHILD-spezifisch die Form aufbauen - ENDE
    }

    /*testEval(testNr: number, thisComponent: AuftragsChecklisteDetailComponent) {
    console.log("AuftragsChecklisteDetailComponent.testEval() thisComponent:", thisComponent);
    if(testNr == 1) return true;
    else if(testNr == 2) return false;
    else return null;
  }*/

    ngOnInit() {
        console.log("AuftragsChecklisteDetailComponent.ngOnInit()");
        // Test eval()
        /*
    console.log("AuftragsChecklisteDetailComponent.ngOnInit() eval(true && true):", eval("true && true"));
    console.log("AuftragsChecklisteDetailComponent.ngOnInit() eval(true && false):", eval("true && false"));
    console.log("AuftragsChecklisteDetailComponent.ngOnInit() eval(false || true):", eval("false || true"));
    document["testEval"] = this.testEval;
    console.log("AuftragsChecklisteDetailComponent.ngOnInit() eval(document.testEval(1, this)):", eval("document.testEval(1, this)"));
    console.log("AuftragsChecklisteDetailComponent.ngOnInit() eval(document.testEval(2, this)):", eval("document.testEval(2, this)"));
    */

        this.blockedDocument = true;

        if (this.config.get("debug_Auftragsverwaltung") == true) {
            this.debugMode = true;
        }

        // CHILD-spezifische Zusätze, z.B. Nachladen anderer Entities - START
        this.route.queryParams.subscribe((params) => {
            console.log(
                "AuftragsChecklisteDetailComponent.ngOnInit() params/this:",
                params,
                this,
            );
            this.queryParams = params;

            // debug-Mode aktivieren ?
            if (this.queryParams != null && this.queryParams.debugMode == "T") {
                this.debugMode = true;
            }
        });

        // OFFLINE-MODE ? id und andere query parameters per JS holen (kein ng Router!)
        //let searchParams = new URLSearchParams(window.location.search); // https://sentry.io/answers/how-to-get-values-from-urls-in-javascript/
        let searchParams = this._app.initialURLSearchParams; // https://sentry.io/answers/how-to-get-values-from-urls-in-javascript/
        // im Prinzip erkennt er den offline-mode eh schon aufgrund AppConfigService, man kann aber alternativ (zum Test) auch ?offline=T mitgeben
        if (
            (searchParams.has("offline") &&
                searchParams.get("offline") == "T") ||
            this.config
                .get("dataMode")
                .localeCompare(/*("online") != 0*/ "maui") == 0 ||
            this.config.get("dataMode").localeCompare("test") == 0
        ) {
            this.offlineMode = true;
            //for (let param of searchParams) {
            //  console.log(param);
            //}
            let dataIdPara = this.app.initialModulParams.find(
                (x) => x.parameterName == "id",
            );
            let checklisteIdPara = this.app.initialModulParams.find(
                (x) => x.parameterName == "checklisteId",
            );
            let auftragsIdPara = this.app.initialModulParams.find(
                (x) => x.parameterName == "auftragsId",
            );
            let dokumentIdPara = this.app.initialModulParams.find(
                (x) => x.parameterName == "dokumentId",
            );
            let navPara = this.app.initialModulParams.find(
                (x) => x.parameterName == "nav",
            );

            this.dataId = parseInt(dataIdPara.parameterValue);

            this.queryParams = {
                checklisteId: parseInt(checklisteIdPara.parameterValue),
                auftragsId: parseInt(auftragsIdPara.parameterValue),
                dokumentId: parseInt(dokumentIdPara.parameterValue),
                nav: navPara.parameterValue,
            };
            console.log(
                "AuftragsChecklisteDetailComponent.ngOnInit() OFFLINE: getting dataId/queryParams:",
                this.dataId,
                this.queryParams,
            );
        }

        this.debug_ProgressbarRefresh = this.config.get(
            "debug_ProgressbarRefresh",
        );

        //this.urlToLogo = this._systemService.getLogoDownloadUrl();
        this._systemService.getLogoDownloadUrl().subscribe(
            (response) => {
                //this.urlToLogo = response; // das setzten der URL mit blob:localhost... (aus systemService) führt zu src="unsafe:blob:"! - Lösung: per js:
                setTimeout(() => {
                    let img = document.getElementById(
                        "auftragsChecklisteDetailWelldoneLogo",
                    );
                    if (img != null) img["src"] = response;
                }, 50);
            },
            (error: any) => {
                //this.handleError(error);
                console.error(
                    "AuftragsChecklisteDetail error during getting logo: ",
                    error,
                );
            },
        );

        // CHILD-spezifische Zusätze, z.B. Nachladen anderer Entities - ENDE

        super.ngOnInit();
    }

    // US 33968: Test Android Kamera
    /*manuell_programmierte_dateiauswahl(evt) {
    alert("manuell_programmierte_dateiauswahl");
    var files = evt.target.files; 
    for (var i = 0, f; f = files[i]; i++) {
      alert("manuell_programmierte_dateiauswahl:"+f.name);
    }
  }*/

    ngAfterViewInit(): void {
        // US 33968: Test Android Kamera
        /*
    setTimeout(() => {
      document.getElementById('manuell_programmierte_dateiauswahl').addEventListener('change', this.manuell_programmierte_dateiauswahl, false);
      alert("manuell_programmierte_dateiauswahl:event attached");
    }, 1000);
    */

        super.ngAfterViewInit();

        //console.log("AuftragsChecklisteDetailComponent.ngAfterViewInit() tabView:", this.tabView);
        //console.log("AuftragsChecklisteDetailComponent.ngAfterViewInit() tabView.el.nativeElement:", this.tabView.el.nativeElement);

        //setTimeout(() => {
        //  this.resizeFileUpload();
        //}, 500);
        setTimeout(() => {
            this.app.iOSFixResizeWebview(
                "AuftragsChecklisteDetail.ngAfterViewInit",
            );
        }, 300);

        setTimeout(() => {
            if (this.app.inAppMode == false) this.calcMaxWidthOfCheckboxText();
        }, 10);

        this.app.auftragComponent = this;
    }

    onCRUDItemRetrieved(CRUDItem: /*IAnrede*/ any): void {
        // overwrite
        console.log(
            "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved() CRUDItem:",
            CRUDItem,
        );

        if (this.dataId == 0) {
            // Neuanlage
            CRUDItem.positionsdaten = [];
            if (this.queryParams != null) {
                CRUDItem.auftragsdatenId = this.queryParams.auftragsId;
                CRUDItem.checklisteId = this.queryParams.checklisteId;
                CRUDItem.dokumentId = this.queryParams.dokumentId;
            }

            let year = moment().year();
            let month = moment().month() + 1;
            let day = moment().date(); // day() ist day of week
            let today = new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
            CRUDItem.pruefdatum = today;

            // weitere Vorbestückungen erfolgen nach laden der Auftragsdaten!
        } else {
            //  CRUDItem.positionsdaten.forEach(positionsdaten => {
            //    //positionsdaten['_touched'] = true; // damit die auch wieder gespeichert werden!
            //  });
            this.messageWrapperService.postTimedMessage({
                severity: "info",
                summary: "Gespeicherte Aufgabe",
                detail:
                    "Gespeicherte Aufgabe vom " +
                    this.datumOhneZeitPipe.transform(CRUDItem.modified) +
                    " wird fortgesetzt.",
            });

            // Achtung: Behälter kommt ohne Summary! Das nachtragen:
            if (CRUDItem._Auftragsdaten_Behaelter != null) {
                //CRUDItem._Auftragsdaten_Behaelter.summary = CRUDItem._Auftragsdaten_Behaelter.behaelterNummer + " " + CRUDItem._Auftragsdaten_Behaelter.hersteller + " " + CRUDItem._Auftragsdaten_Behaelter.baujahr; // kommt warum auch immer nicht aus der API
                CRUDItem._Auftragsdaten_Behaelter.summary =
                    this.behaelterService.buildSummary(
                        CRUDItem._Auftragsdaten_Behaelter,
                    ); // kommt warum auch immer nicht aus der API
            }
        }

        // #WIEDERAUFSETZEN - KANN ES BEI NEUANLAGE GAR NICHT GEBEN!
        //this.posSelected hier schon zu setzen bringt Nichts, da nach Prüfung wieder auf 0 gesetzt wird.
        //Das wird erst nach den Prüfungen etc. gesetzt.
        /*console.log("AuftragsChecklisteDetailComponent.onCRUDItemRetrieved() WIEDERAUFSETZEN: Abfrage tabSelected");
    let tabSelected = prompt("tabSelected:");
    if(tabSelected != null) {
      CRUDItem['tabSelected'] = parseInt(tabSelected, 10);
    }
    console.log("AuftragsChecklisteDetailComponent.onCRUDItemRetrieved() WIEDERAUFSETZEN: Abfrage posSelected");
    let posSelected = prompt("posSelected:");
    if(posSelected != null) {
      CRUDItem['posSelected'] = parseInt(posSelected, 10);
    }*/

        this.auftragsdatenService
            .getAuftragsdatenIncludingPositionen(CRUDItem.auftragsdatenId)
            .subscribe(
                (response) => {
                    console.log(
                        "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved() getAuftragsdatenIncludingPositionen() response:",
                        response,
                    );
                    this.auftragsdaten = response;

                    // dienstleister bestimmen
                    let _dienstleister = this.app.dienstleister.filter(
                        (f) => f.id == this.auftragsdaten.dienstleisterId,
                    );
                    if (_dienstleister == null || _dienstleister.length != 1) {
                        let _bekannte = "";
                        if (this.app.dienstleister != null) {
                            this.app.dienstleister.forEach((dl) => {
                                _bekannte +=
                                    dl.id + " " + dl.bezeichnung + "   ";
                            });
                        }
                        this.messageWrapperService.postStaticMessage({
                            severity: "error",
                            detail:
                                "Dienstleister mit der Id=" +
                                this.auftragsdaten.dienstleisterId +
                                " ist unbekannt. Der Auftrag kann nicht verarbeitet werden. Bekannte Dienstleister: " +
                                _bekannte,
                            summary: "Dienstleister nicht bekannt",
                        });
                    }
                    this.dienstleister = this.app.dienstleister.filter(
                        (f) => f.id == this.auftragsdaten.dienstleisterId,
                    )[0];

                    // Leistung dazulesen (nicht aus app - das ist ggf. noch nicht bestückt)
                    this.leistungsService
                        .getLeistung(this.auftragsdaten.leistung)
                        .subscribe(
                            (responseLeistung) => {
                                console.log(
                                    "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved() getLeistung() responseLeistung:",
                                    responseLeistung,
                                );
                                this.leistung = responseLeistung;
                                if (
                                    this.leistung != null &&
                                    this.leistung.unterschriftKunde != true
                                ) {
                                    // falls es keine Unterschrift Kunde geben soll -> TabNrn anpassen
                                    this.tabNRUnterschriftKunde = null;
                                    this.tabNRUnterschriftPruefer--;
                                }

                                // Bei Spediteur: Nach den Pos. kommt noch ein zusätzlicher Tab: Leistungen
                                if (this.dienstleister.spediteur == true) {
                                    this.tabNRLeistungen = this.tabNRPos + 1;
                                    if (
                                        this.tabNRKopf != null &&
                                        this.tabNRKopf != 0
                                    )
                                        this.tabNRKopf++;
                                    if (
                                        this.tabNRAbschluss != null &&
                                        this.tabNRAbschluss != 0
                                    )
                                        this.tabNRAbschluss++;
                                    if (
                                        this.tabNRUnterschriftKunde != null &&
                                        this.tabNRUnterschriftKunde != 0
                                    )
                                        this.tabNRUnterschriftKunde++;
                                    if (
                                        this.tabNRUnterschriftPruefer != null &&
                                        this.tabNRUnterschriftPruefer != 0
                                    )
                                        this.tabNRUnterschriftPruefer++;

                                    // Ausserdem bei Spediteur: Prüfdatum heisst Lieferdatum
                                    this.validationMessages.pruefdatum.required =
                                        this._translate.instant(
                                            "Lieferdatum",
                                            true,
                                        ) +
                                        ": " +
                                        this._translate.instant(
                                            "ist erforderlich",
                                            true,
                                        );
                                }

                                this.updateValidatorsDependingFromLeistung();
                            },
                            function (error) {
                                console.error(
                                    "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved() getLeistung() error:",
                                    error,
                                );
                                return this.handleError(error);
                            },
                        );

                    // Abgeschlossene Aufträge (O) dürfen gar nicht mehr geöffnet werden
                    // "Freigabe offen" (N) dürfen nur im List-Mode geöffnet werden
                    let forbidden = false;
                    let mode: string = null;
                    if (this.queryParams != null) {
                        if (this.queryParams.nav == "map") mode = "map";
                        else if (this.queryParams.nav == "list") mode = "list";
                    }
                    if (mode == "map") {
                        if (
                            this.auftragsdaten.status != "C" &&
                            this.auftragsdaten.status != "M"
                        )
                            forbidden = true;
                    } else if (mode == "list") {
                        // im List-Mode darf auch ein "Freigabe offen" noch geöffnet werden, weil so steigt der Leiter ja ein, um
                        // in vollends ganz abzuschliessen
                        if (
                            this.auftragsdaten.status != "C" &&
                            this.auftragsdaten.status != "M" &&
                            this.auftragsdaten.status != "N"
                        )
                            forbidden = true;
                    } else {
                        if (
                            this.auftragsdaten.status == "C" ||
                            this.auftragsdaten.status == "M"
                        ) {
                            // C / M ist ja immer erlaubt
                            forbidden = false;
                        } else {
                            // ansonsten: wenn unklar, ob map oder liste -> vorsichtshalber abbrechen
                            this.blockedDocument = true;
                            CRUDItem.positionsdaten = [];
                            this.messageWrapperService.postTimedMessage({
                                severity: "error",
                                summary: this.translate.instant(
                                    "Aufgabe",
                                    true,
                                ),
                                detail: "Diese Aufgabe darf nur noch aus der Auftrags-Liste bearbeitet werden. Sie werden weitergeleitet.",
                            });
                            super.onCRUDItemRetrieved(CRUDItem);
                            this.navigateToMapOrList();
                            return;
                        }
                    }
                    if (forbidden == true) {
                        this.blockedDocument = true;
                        CRUDItem.positionsdaten = [];
                        this.messageWrapperService.postTimedMessage({
                            severity: "error",
                            summary: this.translate.instant("Aufgabe", true),
                            detail: "Diese Aufgabe ist bereits erledigt. Sie werden weitergeleitet.",
                        });
                        super.onCRUDItemRetrieved(CRUDItem);
                        this.navigateToMapOrList();
                        return;
                    }

                    //if(this.dataId == 0) { // Neuanlage // Benutzer immer lesen!, aber die CRUDItem-Bestückungen weiterhin nur wenn Neuanlage
                    //CRUDItem.benutzerId = this._app.getBenutzer().id;
                    //CRUDItem.unterschriftPrueferName = this._app.getBenutzer().name;
                    this.benutzerSubscription =
                        this.app.benutzerBehaviourSubject.subscribe(
                            (benutzer) => {
                                if (benutzer != null) {
                                    console.log(
                                        "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved() got benutzer:",
                                        benutzer,
                                    );
                                    this.benutzer = benutzer;
                                    if (this.dataId == 0) {
                                        // Neuanlage
                                        CRUDItem.benutzerId = benutzer.id;
                                        CRUDItem.unterschriftPrueferName =
                                            benutzer.name;
                                    }
                                    setTimeout(() => {
                                        this.benutzerSubscription.unsubscribe();
                                    }, 10);
                                    this.onCRUDItemRetrieved_pt2(CRUDItem);
                                }
                            },
                        );
                    if (this.dataId == 0) {
                        // Neuanlage
                        // wenn Daten in den Feldern "Ansprechpartner" vorhanden, dann die nehmen!
                        if (
                            this.auftragsdaten.name_1Ansprechpartner != null &&
                            this.auftragsdaten.name_1Ansprechpartner.length > 0
                        )
                            CRUDItem.unterschriftKundeName =
                                this.auftragsdaten.name_1Ansprechpartner +
                                (this.auftragsdaten.name_2Ansprechpartner !=
                                null
                                    ? " " +
                                      this.auftragsdaten.name_2Ansprechpartner
                                    : "");
                        else
                            CRUDItem.unterschriftKundeName =
                                this.auftragsdaten.name_1Behaelterstandort +
                                (this.auftragsdaten.name_2Behaelterstandort !=
                                null
                                    ? " " +
                                      this.auftragsdaten.name_2Behaelterstandort
                                    : "");
                        if (
                            this.auftragsdaten.eMailAnsprechpartner != null &&
                            this.auftragsdaten.eMailAnsprechpartner.length > 0
                        )
                            CRUDItem.unterschriftKundeEMail =
                                this.auftragsdaten.eMailAnsprechpartner;
                        else
                            CRUDItem.unterschriftKundeEMail =
                                this.auftragsdaten.kontaktdaten_Avisierung_EMail;

                        CRUDItem.anlagenbeschreibung =
                            this.auftragsdaten.auftragsdatenAnlagentyp;
                    }
                    //}
                },
                function (error) {
                    console.error(
                        "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved() getAuftragsdaten() error:",
                        error,
                    );
                    return this.handleError(error);
                },
            );
    }
    onCRUDItemRetrieved_pt2(CRUDItem: /*IAnrede*/ any): void {
        // overwrite
        this._systemService.getSettings().subscribe((settings) => {
            if (settings != null) {
                console.log(
                    "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt2() got settings:",
                    settings,
                );
                this.unterschriftKundeEMailRequired =
                    settings.unterschriftKundeEMailRequired;
                this.unterschriftKundeRequired =
                    settings.unterschriftKundeRequired;

                this.zaehlerEnabled = settings.zaehlerEnabled;

                this.updateValidatorsDependingFromSettings();

                this.onCRUDItemRetrieved_pt3(CRUDItem);
            }
            //else {
            //  console.log("AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt2() settings == null");
            //}
        });
    }
    onCRUDItemRetrieved_pt3(CRUDItem: /*IAnrede*/ any): void {
        this.checklisteService
            .getCheckliste(
                CRUDItem.checklisteId,
                true /*cropDokument*/,
                true /*cropLeitfaden*/,
            )
            .subscribe((response) => {
                console.log(
                    "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt3() getCheckliste() response:",
                    response,
                );
                //console.log("AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt3() this:", this);
                this.checkliste = response;
                /*if(this.checkliste.hinweistext == null || this.checkliste.hinweistext.length == 0) { // wenn kein Hinweistext, dann auch kein Start!
        this.tabShowStart = false;
        this.tabNRStart--;
        this.tabNRPos--;
        this.tabNRKopf--;
        this.tabNRUnterschrift--;
      }*/

                // alle nicht schon vorhandenen Positionen der Checkliste nachtragen - macht die API
                /*
      let checklistePositionen = response.checklistePositionen.sort((a, b) => {
        if (a.reihenfolge > b.reihenfolge) {
          return 1;
        }
        if (a.reihenfolge < b.reihenfolge) {
          return -1;
        }
        return 0;
      });
      */
                let checklistePositionCounter = 0;
                response.checklistePositionen.forEach(
                    (checklistePosition) => {
                        checklistePositionCounter++;

                        let found = CRUDItem.positionsdaten.filter(
                            (f) =>
                                f.checklistePositionId == checklistePosition.id,
                        );
                        if (found == null || found.length == 0) {
                            let positionsdaten =
                                this.positionsdatenService.initializePositionsdaten();
                            positionsdaten.id = 0;
                            positionsdaten.reihenfolge =
                                checklistePosition.reihenfolge;
                            positionsdaten.kopfdaten = null;
                            positionsdaten.kopfdatenId = this.dataId;
                            positionsdaten.checklistePosition =
                                checklistePosition;
                            positionsdaten.checklistePositionId =
                                checklistePosition.id;
                            positionsdaten.bezeichnung =
                                checklistePosition.bezeichnung;

                            checklistePosition.checklistePositionenFelder.forEach(
                                (checklistePositionenFeld) => {
                                    let positionsdatenFeld =
                                        this.positionsdatenFelderService.initializePositionsdatenFelder();
                                    positionsdatenFeld.id = 0;
                                    positionsdatenFeld.reihenfolge =
                                        checklistePositionenFeld.reihenfolge;
                                    positionsdatenFeld.positionsdaten = null;
                                    positionsdatenFeld.positionsdatenId =
                                        positionsdaten.id;
                                    positionsdatenFeld.checklistePositionenFeld =
                                        checklistePositionenFeld;
                                    positionsdatenFeld.checklistePositionenFeldId =
                                        checklistePositionenFeld.id;
                                    positionsdatenFeld.typ =
                                        checklistePositionenFeld.typ;
                                    positionsdatenFeld.felddefinition =
                                        checklistePositionenFeld.felddefinition;
                                    positionsdatenFeld.bezeichnung =
                                        checklistePositionenFeld.bezeichnung;

                                    positionsdaten.positionsdatenFelder.push(
                                        positionsdatenFeld,
                                    );
                                },
                            );
                            // alles nochmal neu sortieren (weil wir haben ja evtl. neue Pos geadded)
                            checklistePosition.checklistePositionenFelder =
                                checklistePosition.checklistePositionenFelder.sort(
                                    (a, b) => {
                                        if (a.reihenfolge > b.reihenfolge) {
                                            return 1;
                                        }
                                        if (a.reihenfolge < b.reihenfolge) {
                                            return -1;
                                        }
                                        return 0;
                                    },
                                );

                            CRUDItem.positionsdaten.push(positionsdaten);
                        }
                        // alles nochmal neu sortieren (weil wir haben ja evtl. neue Pos geadded)
                        CRUDItem.positionsdaten = CRUDItem.positionsdaten.sort(
                            (a, b) => {
                                if (a.reihenfolge > b.reihenfolge) {
                                    return 1;
                                }
                                if (a.reihenfolge < b.reihenfolge) {
                                    return -1;
                                }
                                return 0;
                            },
                        );

                        if (
                            checklistePositionCounter ==
                            response.checklistePositionen.length
                        ) {
                            // wenn zur letzten checklistePosition die checklistePositionFelder gelesen -> weiter!
                            // zuvor aber noch alle Zeitfelder, die 5stellig gespeichert sind (HH:mm) -> zu Datumsfelder machen, weil sonst p-calendar damit nicht klar kommt
                            // dasselbe mit Datumsfelder...
                            CRUDItem.positionsdaten.forEach(
                                (positionsdaten) => {
                                    positionsdaten.positionsdatenFelder.forEach(
                                        (positionsdatenFeld) => {
                                            if (
                                                positionsdatenFeld
                                                    .checklistePositionenFeld
                                                    .typ == "time"
                                            ) {
                                                if (
                                                    positionsdatenFeld.feldwert !=
                                                        null &&
                                                    (
                                                        "" +
                                                        positionsdatenFeld.feldwert
                                                    ).length == 5
                                                ) {
                                                    //let zeitAlsDate:any = Date.parse("0001-01-01T"+positionsdatenFeld.feldwert+":00.000Z"); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse?retiredLocale=de
                                                    //zeitAlsDate = new Date(zeitAlsDate);
                                                    let hh = Number(
                                                        positionsdatenFeld.feldwert.substring(
                                                            0,
                                                            2,
                                                        ),
                                                    );
                                                    let mm = Number(
                                                        positionsdatenFeld.feldwert.substring(
                                                            3,
                                                            5,
                                                        ),
                                                    );
                                                    let zeitAlsDate: any =
                                                        new Date(
                                                            "January 1, 0001 00:00:00 GMT",
                                                        );
                                                    zeitAlsDate.setUTCFullYear(
                                                        1,
                                                    );
                                                    zeitAlsDate.setHours(hh);
                                                    zeitAlsDate.setMinutes(mm);
                                                    positionsdatenFeld.feldwert =
                                                        zeitAlsDate;
                                                } else {
                                                    // alles andere ist ungültig!
                                                    positionsdatenFeld.feldwert =
                                                        null;
                                                }
                                            } else if (
                                                positionsdatenFeld.checklistePositionenFeld.typ.startsWith(
                                                    "date",
                                                )
                                            ) {
                                                if (
                                                    positionsdatenFeld.feldwert !=
                                                        null &&
                                                    (
                                                        "" +
                                                        positionsdatenFeld.feldwert
                                                    ).length == 10
                                                ) {
                                                    let dd = Number(
                                                        positionsdatenFeld.feldwert.substring(
                                                            8,
                                                            10,
                                                        ),
                                                    );
                                                    let mm = Number(
                                                        positionsdatenFeld.feldwert.substring(
                                                            5,
                                                            7,
                                                        ),
                                                    );
                                                    let yyyy = Number(
                                                        positionsdatenFeld.feldwert.substring(
                                                            0,
                                                            4,
                                                        ),
                                                    );
                                                    //let dateAlsDate:any = Date.parse(yyyy+"-"+mm+"-"+dd+"T12:00:00.000Z"); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse?retiredLocale=de
                                                    //dateAlsDate = new Date(dateAlsDate);
                                                    let dateAlsDate: any =
                                                        new Date(
                                                            "January 1, 0001 00:00:00 GMT",
                                                        );
                                                    dateAlsDate.setUTCFullYear(
                                                        yyyy,
                                                    );
                                                    dateAlsDate.setUTCMonth(
                                                        mm - 1,
                                                    );
                                                    dateAlsDate.setUTCDate(dd);
                                                    positionsdatenFeld.feldwert =
                                                        dateAlsDate;
                                                } else {
                                                    // alles andere ist ungültig!
                                                    positionsdatenFeld.feldwert =
                                                        null;
                                                }
                                            }
                                        },
                                    );
                                },
                            );

                            this.onCRUDItemRetrieved_pt4(CRUDItem);
                        }
                    },
                    function (error) {
                        console.error(
                            "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt3() getCheckliste() error:",
                            error,
                        );
                        return this.handleError(error);
                    },
                );
            });
    }

    onCRUDItemRetrieved_pt4(CRUDItem: /*IAnrede*/ any): void {
        //console.log("AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt4() auftragsdaten:", this.auftragsdaten);
        this.leistungskatalogSpediteurService
            .getLeistungskatalogSpediteurForLeistung(
                this.auftragsdaten.leistung,
            )
            .subscribe(
                (response) => {
                    //console.log("AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt4() getLeistungskatalogSpediteurForLeistung() response:", response);
                    //console.log("AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt4() this:", this);
                    this.leistungskatalogSpediteur = response;
                    // leistungskatalog hat eine Property "artikelbezeichnung", Autocomplete will aber "bezeichnung". Kopieren ...
                    this.leistungskatalogSpediteur.forEach(
                        (leistungskatalogSpediteur) => {
                            leistungskatalogSpediteur["bezeichnung"] =
                                leistungskatalogSpediteur.artikelbezeichnung;
                        },
                    );

                    console.log(
                        "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt4() auftragsdaten.auftragspositionen:",
                        this.auftragsdaten.auftragspositionen,
                    );
                    //console.log("AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt4() CRUDItem.leistungenRueckgemeldet:", CRUDItem.leistungenRueckgemeldet);

                    // alle nicht schon vorhandenen LeistungsRückmeldungen der Auftragspositionen nachtragen
                    if (
                        this.dienstleister != null &&
                        this.dienstleister.spediteur == true
                    ) {
                        let counter = 0;
                        this.auftragsdaten.auftragspositionen.forEach(
                            (auftragsposition) => {
                                counter++;

                                let foundLeistungenRueckgemeldet =
                                    CRUDItem.leistungenRueckgemeldet.filter(
                                        (f) =>
                                            f.auftragspositionenId ==
                                            auftragsposition.id,
                                    );
                                let foundLeistungskatalogSpediteur =
                                    this.leistungskatalogSpediteur.filter(
                                        (f) =>
                                            f.id ==
                                            auftragsposition["artikelnummerId"],
                                    );
                                if (
                                    (foundLeistungenRueckgemeldet == null ||
                                        foundLeistungenRueckgemeldet.length ==
                                            0) &&
                                    foundLeistungskatalogSpediteur != null &&
                                    foundLeistungskatalogSpediteur.length == 1
                                ) {
                                    let leistungRueckgemeldet =
                                        this.leistungRueckgemeldetService.initializeLeistungRueckgemeldet();
                                    leistungRueckgemeldet.id = 0;
                                    //leistungRueckgemeldet.reihenfolge = checklistePosition.reihenfolge;
                                    //leistungRueckgemeldet.kopfdaten = null;
                                    leistungRueckgemeldet.kopfdatenId =
                                        this.dataId;
                                    //leistungRueckgemeldet.auftragspositionen = auftragsposition;
                                    leistungRueckgemeldet.auftragspositionenId =
                                        auftragsposition.id;
                                    leistungRueckgemeldet.artikelnummerId =
                                        auftragsposition.artikelnummerId;
                                    leistungRueckgemeldet.artikelnummer =
                                        foundLeistungskatalogSpediteur[0];
                                    leistungRueckgemeldet.preis =
                                        auftragsposition.preis != null
                                            ? auftragsposition.preis
                                            : foundLeistungskatalogSpediteur[0]
                                                  .preis;
                                    leistungRueckgemeldet.menge =
                                        auftragsposition.menge != null
                                            ? auftragsposition.menge
                                            : null;
                                    leistungRueckgemeldet.positionsNr =
                                        auftragsposition.positionsNr;
                                    //leistungRueckgemeldet.lieferdatum = '0001-01-01T00:00:00.000Z';
                                    leistungRueckgemeldet.lieferdatum =
                                        CRUDItem.pruefdatum;

                                    CRUDItem.leistungenRueckgemeldet.push(
                                        leistungRueckgemeldet,
                                    );
                                }
                                // alles nochmal neu sortieren (weil wir haben ja evtl. neue Pos geadded)
                                /*CRUDItem.leistungenRueckgemeldet = CRUDItem.leistungenRueckgemeldet.sort((a, b) => {
            if (a.auftragspositionenId > b.auftragspositionenId) {
              return 1;
            }
            if (a.auftragspositionenId < b.auftragspositionenId) {
              return -1;
            }
            return 0;
          });*/
                            },
                        );

                        console.log(
                            "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt4() CRUDItem.leistungenRueckgemeldet:",
                            CRUDItem.leistungenRueckgemeldet,
                        );
                    }

                    this.onCRUDItemRetrieved_pt5(CRUDItem);
                },
                function (error) {
                    console.error(
                        "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt4() getLeistungskatalogSpediteurForLeistung() error:",
                        error,
                    );
                    return this.handleError(error);
                },
            );
    }

    onCRUDItemRetrieved_pt5(CRUDItem: /*IAnrede*/ any): void {
        console.log(
            "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt5()  CRUDItem/auftragsdaten:",
            CRUDItem,
            this.auftragsdaten,
        );

        // feld.feldwert enthält WÄHREND CRUDBasicAutocompleteComponent das komplette Objekt, in der DB aber nur die Id
        // (Details siehe *** CONTAINER_FELDWERT)
        // Daher:
        // Bei Start: alle feldwerte des Typs containerNr -> ersetzen durch objekt
        const allePosData = CRUDItem.positionsdaten;
        allePosData.forEach((positionsdaten, posIdx) => {
            const alleFelder = positionsdaten.positionsdatenFelder;
            alleFelder.forEach((feld, feldIdx) => {
                if (feld.typ == "containerNr" && feld.feldwert != null) {
                    //console.log("AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt5() feld = containerNr: feld:", feld);
                    this.behaelterService
                        .getBehaelterForAutoComplete(feld.feldwert)
                        .subscribe(
                            (response) => {
                                console.log(
                                    "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt5() feld = containerNr: feld/response:",
                                    feld,
                                    response,
                                );
                                const behaelter: IBehaelter = response;
                                feld.feldwert = behaelter;

                                this.onCRUDItemRetrieved_pt5_1(
                                    CRUDItem,
                                    feldIdx,
                                    posIdx,
                                    allePosData,
                                    alleFelder,
                                );
                            },
                            function (error) {
                                console.error(
                                    "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt5() error:",
                                    error,
                                );
                                return this.handleError(error);
                            },
                        );
                } else {
                    this.onCRUDItemRetrieved_pt5_1(
                        CRUDItem,
                        feldIdx,
                        posIdx,
                        allePosData,
                        alleFelder,
                    );
                }
            });
        });
    }

    onCRUDItemRetrieved_pt5_1(
        CRUDItem: /*IAnrede*/ any,
        feldIdx,
        posIdx,
        allePosData,
        alleFelder,
    ): void {
        const istLetztes =
            posIdx === allePosData.length - 1 &&
            feldIdx === alleFelder.length - 1;
        if (istLetztes) {
            this.onCRUDItemRetrieved_pt6(CRUDItem);
        }
    }

    onCRUDItemRetrieved_pt6(CRUDItem: /*IAnrede*/ any): void {
        console.log(
            "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt6()  CRUDItem/auftragsdaten:",
            CRUDItem,
            this.auftragsdaten,
        );

        super.onCRUDItemRetrieved(CRUDItem);

        // Pos., die aufgrund einer Abhängigkeit vom Auftragskopf ausgefiltert werden können -> von Anfang an ausfiltern!
        this.updatePosFilterAbhaengigkeitenVomAuftragskopf();
        // gleich zu Beginn feststellen, welches die letzte nicht-ausgeblendete Pos ist + ob es offene Mängel gibt ...
        this.updatePosEnabled(); // ... dazu müssen auch erst alle Pos mit _ENABLED markiert werden
        this.calcLetzteSichtbarePosUndOffeneMaengelExist();

        console.log(
            "AuftragsChecklisteDetailComponent.onCRUDItemRetrieved_pt6() getCheckliste() this.CRUDItem:",
            this.CRUDItem,
        );

        // Prüfen
        this.blockedDocument = true;
        for (let i = 0; i < this.CRUDItem.positionsdaten.length; i++) {
            this.posSelected = i;
            //this.prepareAutoComplete(); // für Prüfung nicht benötigt
            this.posFileUploadUpdate(true); // weil pruefePosition() auch prüft, ob Bilder vorhanden!
            let errors = this.pruefePosition(false);
            //CRUDItem.positionsdaten[i]['_valid'] = errors.length == 0; // macht pruefePosition bereits
        }
        // WIEDERAUFSETZEN
        try {
            // Haben wir Format T;n;P;n ?
            // RegExp testen und gleichzeitig Werte extrahieren
            let letzteAktionMatch =
                this.CRUDItem.letzteAktion?.match(/^T;(\d+);P;(\d+)$/);
            let tabSelected: number = null;
            let posSelected: number = null;
            if (letzteAktionMatch) {
                tabSelected = parseInt(letzteAktionMatch[1], 10); // -> 1
                posSelected = parseInt(letzteAktionMatch[2], 10); // -> 8
                console.log(
                    "AuftragsChecklisteDetail.onCRUDItemRetrieved_pt6() tabSelected, posSelected:",
                    tabSelected,
                    posSelected,
                );
            } else {
                console.log(
                    "AuftragsChecklisteDetail.onCRUDItemRetrieved_pt6() letzte Aktion hat nicht Format T;n;P;n -> ignoriere letzteAktion:",
                    this.CRUDItem.letzteAktion,
                );
            }

            if (/*this.CRUDItem['*/ tabSelected /*']*/ != null) {
                setTimeout(() => {
                    this.tabSelected = /*this.CRUDItem['*/ tabSelected /*']*/;
                }, 100);
            }
            if (/*this.CRUDItem['*/ posSelected /*']*/ != null) {
                if (
                    /*this.CRUDItem['*/ posSelected /*']*/ >
                        this.posLetzteSichtbare ||
                    /*this.CRUDItem['*/ posSelected /*']*/ + 1 >
                        CRUDItem.positionsdaten.length
                ) {
                    // falls mittlerweile eine Pos rausgeflogen / ausgeblendet wurde
                    this.posSelected = this.posLetzteSichtbare;
                } else {
                    this.posSelected = /*this.CRUDItem['*/ posSelected /*']*/;
                }
            } else {
                this.posSelected = 0;
            }
        } catch (e) {
            console.log(
                "AuftragsChecklisteDetail.onCRUDItemRetrieved_pt6() error Wiederaufsetzen: error: :",
                e,
            );
            this.posSelected = 0;
        }

        this.updatePosEnabled();
        this.calculateTouchedAndValid();

        this.app.iOSFixResizeWebview(
            "AuftragsChecklisteDetail.onCRUDItemRetrieved_pt6",
        );

        this.blockedDocument = false;
    }

    calcMaxWidthOfCheckboxText() {
        // Abmessen/Berechnen wie breit der breiteste Checkbox-Text ist
        // Weil: das (i) soll bei Checkboxen möglichst direkt neben dem Checkbox-Text dargestellt werden.
        // Dazu müssen wir wissen wie breit der breiteste Checkbox-Text ist
        if (this.CRUDItem == null) {
            // retry in 100ms
            setTimeout(() => {
                this.calcMaxWidthOfCheckboxText();
            }, 100);
            return;
        }

        if (this.calcWidthOfString_canvas == null) {
            this.calcWidthOfString_canvas = document.createElement("canvas");
        }
        //this.calcWidthOfString_canvas = document.getElementById("calcWidthOfString_canvas");
        if (this.debugMode == true)
            console.log(
                "AuftragsChecklisteDetailComponent.calcMaxWidthOfCheckboxText() calcWidthOfString_canvas:",
                this.calcWidthOfString_canvas,
            );
        let font =
            "normal 1rem Roboto, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif"; // font gemäß p-component
        setTimeout(() => {
            let context = this.calcWidthOfString_canvas["getContext"]("2d");
            context.font = font;

            this.CRUDItem.positionsdaten.forEach((positionsdaten) => {
                positionsdaten.positionsdatenFelder.forEach((feld) => {
                    if (
                        feld.typ == "checkbox" &&
                        feld.checklistePositionenFeld.info != null &&
                        feld.checklistePositionenFeld.info.length > 0
                    ) {
                        let widthInPx = this.calcWidthOfString(
                            feld.bezeichnung,
                            font,
                        );
                        if (this.debugMode == true)
                            console.log(
                                "AuftragsChecklisteDetailComponent.calcMaxWidthOfCheckboxText() feld/widthInPx:",
                                feld,
                                widthInPx,
                            );
                        if (widthInPx > this.feldTypCheckBoxMaxWidthInPx)
                            this.feldTypCheckBoxMaxWidthInPx = widthInPx;
                    }
                });
            });

            //document.removeChild(this.calcWidthOfString_canvas); // wurde ja nie ins document geadded
        }, 10);
    }

    calcWidthOfString(text: string, font: string) {
        let context = this.calcWidthOfString_canvas["getContext"]("2d");
        context.font = font;
        let widthInPx = context.measureText(text).width;
        if (this.debugMode == true)
            console.log(
                "AuftragsChecklisteDetailComponent.calcWidthOfString() text/font/widthInPx:",
                text,
                font,
                widthInPx,
            );
        //console.error("AuftragsChecklisteDetailComponent.calcWidthOfString() canvas:", canvas);
        return widthInPx;
    }

    navigateToMapOrList() {
        //In der App (Offline) discard Event auslösen damit View sich wider schließt
        if (this.config.get("dataMode").localeCompare("maui") == 0) {
            setTimeout(() => {
                let eventData = {
                    eventType: "discard",
                    data: JSON.stringify({
                        discard: "discard",
                    }),
                };
                this.app.sendMessageToDotNet(eventData);
            }, 10);
        } else {
            let navigateTo = "/map"; // default

            if (this.queryParams != null) {
                if (this.queryParams.nav == "map")
                    navigateTo = "/map"; // wenn queryParam vorhanden, dann entspr. nach map Oder Liste navigieren
                else if (this.queryParams.nav == "list") navigateTo = "/list"; // wenn queryParam vorhanden, dann entspr. nach map Oder Liste navigieren
            }

            this.router.navigate([navigateTo]);
        }
    }

    cancelCRUDEdit() {
        // overwrite
        //this.router.navigate(['/map']);

        // siehe RouteBuilderAuftragsCheckliste: dort musste der Dialog in der Map geschlossen werden.
        // den nun wieder aktivieren
        if (this.app.getMapComponent() != null)
            this.app.getMapComponent().dialogAuftragUnhide();

        this.navigateToMapOrList();
    }

    saveWithValidation() {
        console.log("AuftragsChecklisteDetailComponent.saveWithValidation()");

        this.wellDoneDialogSkip = false; // bei Abschliessendem Speichern -> WellDoneDialog!

        // Wenn Abgeschlossen, dann muss an den Controller der Parameter ?abgeschlossen=true übergeben werden.
        // Wir machen das, indem wir die saveMethode austauschen
        this.CRUDMethodNameSave =
            "save" +
            this.CRUDItemBezeichnungSingularCapitalized +
            "Abgeschlossen";

        this.validateAndSaveCRUDItem(true);

        // ggf. danach wieder die normale Save-Methode verwenden (kein "?abgeschlossen=true" - siehe "?abgeschlossen=true")
        this.CRUDMethodNameSave = null;
    }

    saveWithoutValidation() {
        console.log(
            "AuftragsChecklisteDetailComponent.saveWithoutValidation()",
        );

        // #WIEDERAUFSETZEN
        console.log(
            "AuftragsChecklisteDetailComponent.saveWithoutValidation() WIEDERAUFSETZEN: this.tabSelected/this.posSelected",
            this.tabSelected,
            this.posSelected,
        );

        // primeNg Crash, wenn man saved, während datey/dateMY/time sichtbar! TypeError: date.getMonth is not a function at set defaultDate (primeng-calendar.mjs:114:38)
        // Workaround: während Save ausblenden! - muss auch nicht wieder eingeblendet werden, weil saveWITHOUTValidation ja immer klappt!
        this.hideDuringSave = true;

        // OFFLINE-MODE
        if (this.config.get("dataMode").localeCompare("online") != 0) {
            setTimeout(() => {
                let eventData = {
                    eventType: "callBackTest",
                    data: JSON.stringify({
                        someData: "hello world!",
                    }),
                };
                //this.app.sendMessageToDotNetTwo(eventData);
            }, 10);
        }

        // Validatoren deaktivieren, die das Speichern verhindern
        this.removeValidators();

        // dann saven
        this.wellDoneDialogSkip = true; // bei Zwischenspeichern kein WellDoneDialog

        this.CRUDMethodNameSave = null; // die normale Save-Methode verwenden (kein "?abgeschlossen=true" - siehe "?abgeschlossen=true")

        this.validateAndSaveCRUDItem(true);
    }

    removeValidators() {
        console.log("AuftragsChecklisteDetailComponent.removeValidators()");

        // Validatoren deaktivieren, die das Speichern verhindern
        //this.CRUDForm.controls.datumNaechsteAnlagenpruefung.setErrors(null);
        //this.CRUDForm.controls.datumNaechsteAnlagenpruefung.clearValidators();
        //this.CRUDForm.controls.datumNaechsteAnlagenpruefung.updateValueAndValidity();
        this.CRUDForm.controls.pruefdatum.setErrors(null);
        this.CRUDForm.controls.pruefdatum.clearValidators();
        this.CRUDForm.controls.pruefdatum.updateValueAndValidity();
        //this.CRUDForm.controls.anlagenbeschreibungSelected.setErrors(null); // -> Das Feld ist nicht mehr sichtbar, daher auch keine Prüfungen
        //this.CRUDForm.controls.anlagenbeschreibungSelected.clearValidators();
        //this.CRUDForm.controls.anlagenbeschreibungSelected.updateValueAndValidity();
        this.CRUDForm.controls.pumpentypSelected.setErrors(null);
        this.CRUDForm.controls.pumpentypSelected.clearValidators();
        this.CRUDForm.controls.pumpentypSelected.updateValueAndValidity();
        this.CRUDForm.controls.anstrichSelected.setErrors(null);
        this.CRUDForm.controls.anstrichSelected.clearValidators();
        this.CRUDForm.controls.anstrichSelected.updateValueAndValidity();
        this.CRUDForm.controls._Auftragsdaten_BehaelterSelected.setErrors(null);
        this.CRUDForm.controls._Auftragsdaten_BehaelterSelected.clearValidators();
        this.CRUDForm.controls._Auftragsdaten_BehaelterSelected.updateValueAndValidity();
        //this.CRUDForm.controls.behaelterdruck.setErrors(null);
        //this.CRUDForm.controls.behaelterdruck.clearValidators();
        //this.CRUDForm.controls.behaelterdruck.updateValueAndValidity();
        //this.CRUDForm.controls.behaelterfuellgrad.setErrors(null);
        //this.CRUDForm.controls.behaelterfuellgrad.clearValidators();
        //this.CRUDForm.controls.behaelterfuellgrad.updateValueAndValidity();
        this.CRUDForm.controls.unterschriftPruefer.setErrors(null);
        this.CRUDForm.controls.unterschriftPruefer.clearValidators();
        this.CRUDForm.controls.unterschriftPruefer.updateValueAndValidity();
        this.CRUDForm.controls.unterschriftKunde.setErrors(null);
        this.CRUDForm.controls.unterschriftKunde.clearValidators();
        this.CRUDForm.controls.unterschriftKunde.updateValueAndValidity();
        this.CRUDForm.controls.unterschriftKundeName.setErrors(null);
        this.CRUDForm.controls.unterschriftKundeName.clearValidators();
        this.CRUDForm.controls.unterschriftKundeName.updateValueAndValidity();
        this.CRUDForm.controls.unterschriftKundeEMail.setErrors(null);
        this.CRUDForm.controls.unterschriftKundeEMail.clearValidators();
        this.CRUDForm.controls.unterschriftKundeEMail.updateValueAndValidity();
        this.CRUDForm.controls.unterschriftPrueferName.setErrors(null);
        this.CRUDForm.controls.unterschriftPrueferName.clearValidators();
        this.CRUDForm.controls.unterschriftPrueferName.updateValueAndValidity();
        this.CRUDForm.controls.zusaetzlicheEMailAdressenArr.setErrors(null);
        this.CRUDForm.controls.zusaetzlicheEMailAdressenArr.clearValidators();
        this.CRUDForm.controls.zusaetzlicheEMailAdressenArr.updateValueAndValidity();
        //this.CRUDForm.controls.massnahmenAbgeschlossen.setErrors(null); // tab Abschluss dauerhaft ausblenden!
        //this.CRUDForm.controls.massnahmenAbgeschlossen.clearValidators(); // tab Abschluss dauerhaft ausblenden!
        //this.CRUDForm.controls.massnahmenAbgeschlossen.updateValueAndValidity(); // tab Abschluss dauerhaft ausblenden!
        //this.CRUDForm.controls.weiterbetrieb.setErrors(null); // tab Abschluss dauerhaft ausblenden!
        //this.CRUDForm.controls.weiterbetrieb.clearValidators(); // tab Abschluss dauerhaft ausblenden!
        //this.CRUDForm.controls.weiterbetrieb.updateValueAndValidity(); // tab Abschluss dauerhaft ausblenden!
        //this.CRUDForm.controls.pruefergebnisSelected.setErrors(null);
        //this.CRUDForm.controls.pruefergebnisSelected.clearValidators();
        //this.CRUDForm.controls.pruefergebnisSelected.updateValueAndValidity();
    }

    restoreValidators() {
        console.log("AuftragsChecklisteDetailComponent.restoreValidators()");

        // Validatoren wieder aktivieren, die das Speichern verhindern
        //this.CRUDForm.controls.datumNaechsteAnlagenpruefung.setErrors(null);
        //this.CRUDForm.controls.datumNaechsteAnlagenpruefung.addValidators(Validators.required);
        //this.CRUDForm.controls.datumNaechsteAnlagenpruefung.updateValueAndValidity();
        this.CRUDForm.controls.pruefdatum.setErrors(null);
        this.CRUDForm.controls.pruefdatum.addValidators(Validators.required);
        this.CRUDForm.controls.pruefdatum.updateValueAndValidity();
        //this.CRUDForm.controls.anlagenbeschreibungSelected.setErrors(null); // -> Das Feld ist nicht mehr sichtbar, daher auch keine Prüfungen
        //this.CRUDForm.controls.anlagenbeschreibungSelected.addValidators(Validators.required);
        //this.CRUDForm.controls.anlagenbeschreibungSelected.updateValueAndValidity();
        this.CRUDForm.controls.pumpentypSelected.setErrors(null);
        if (this.leistung != null && this.leistung.pumpentyp == true)
            this.CRUDForm.controls.pumpentypSelected.addValidators(
                Validators.required,
            );
        this.CRUDForm.controls.pumpentypSelected.updateValueAndValidity();
        this.CRUDForm.controls.anstrichSelected.setErrors(null);
        if (this.leistung != null && this.leistung.anstrich == true)
            this.CRUDForm.controls.anstrichSelected.addValidators(
                Validators.required,
            );
        this.CRUDForm.controls.anstrichSelected.updateValueAndValidity();
        //this.CRUDForm.controls._Auftragsdaten_BehaelterSelected.setErrors(null);
        //if(this.leistung != null && this.leistung.leistungsart == "BEHAUSL") this.CRUDForm.controls._Auftragsdaten_BehaelterSelected.addValidators(Validators.required);
        //this.CRUDForm.controls._Auftragsdaten_BehaelterSelected.updateValueAndValidity();
        //if(this.leistung != null && this.leistung.anstrich != true) this.CRUDForm.controls.behaelterdruck.setErrors(null);
        //this.CRUDForm.controls.behaelterdruck.addValidators(Validators.required);
        //this.CRUDForm.controls.behaelterdruck.updateValueAndValidity();
        //this.CRUDForm.controls.behaelterfuellgrad.setErrors(null);
        //if(this.leistung != null && this.leistung.anstrich != true) this.CRUDForm.controls.behaelterfuellgrad.addValidators(Validators.required);
        //this.CRUDForm.controls.behaelterfuellgrad.updateValueAndValidity();
        this.CRUDForm.controls.unterschriftPruefer.setErrors(null);
        this.CRUDForm.controls.unterschriftPruefer.addValidators(
            Validators.required,
        );
        this.CRUDForm.controls.unterschriftPruefer.addValidators(
            Validators.minLength(8000),
        );
        this.CRUDForm.controls.unterschriftPruefer.updateValueAndValidity();
        this.CRUDForm.controls.unterschriftKunde.setErrors(null);
        if (
            this.leistung != null &&
            this.leistung.unterschriftKunde == true &&
            this.unterschriftKundeRequired == true
        ) {
            this.CRUDForm.controls.unterschriftKunde.addValidators(
                Validators.required,
            );
            this.CRUDForm.controls.unterschriftKunde.addValidators(
                Validators.minLength(8000),
            );
        }
        this.CRUDForm.controls.unterschriftKunde.updateValueAndValidity();
        this.CRUDForm.controls.unterschriftKundeName.setErrors(null);
        if (this.leistung != null && this.leistung.unterschriftKunde == true)
            this.CRUDForm.controls.unterschriftKundeName.addValidators(
                Validators.required,
            );
        if (this.leistung != null && this.leistung.unterschriftKunde == true)
            this.CRUDForm.controls.unterschriftKundeName.addValidators(
                Validators.maxLength(100),
            );
        this.CRUDForm.controls.unterschriftKundeName.updateValueAndValidity();
        this.CRUDForm.controls.unterschriftKundeEMail.setErrors(null);
        if (
            this.leistung != null &&
            this.leistung.unterschriftKunde == true &&
            this.unterschriftKundeEMailRequired == true
        )
            this.CRUDForm.controls.unterschriftKundeEMail.addValidators(
                Validators.required,
            );
        if (this.leistung != null && this.leistung.unterschriftKunde == true)
            this.CRUDForm.controls.unterschriftKundeEMail.addValidators(
                Validators.maxLength(100),
            );
        if (this.leistung != null && this.leistung.unterschriftKunde == true)
            this.CRUDForm.controls.unterschriftKundeEMail.addValidators(
                Validators.email,
            );
        this.CRUDForm.controls.unterschriftKundeEMail.updateValueAndValidity();
        this.CRUDForm.controls.unterschriftPrueferName.setErrors(null);
        this.CRUDForm.controls.unterschriftPrueferName.addValidators(
            Validators.required,
        );
        this.CRUDForm.controls.unterschriftPrueferName.addValidators(
            Validators.maxLength(100),
        );
        this.CRUDForm.controls.unterschriftPrueferName.updateValueAndValidity();
        this.CRUDForm.controls.zusaetzlicheEMailAdressenArr.setErrors(null);
        this.CRUDForm.controls.zusaetzlicheEMailAdressenArr.addValidators(
            Validators.maxLength(500),
        );
        this.CRUDForm.controls.zusaetzlicheEMailAdressenArr.addValidators(
            validateCommaSeparatedEMails(null),
        );
        this.CRUDForm.controls.zusaetzlicheEMailAdressenArr.updateValueAndValidity();
        //this.CRUDForm.controls.massnahmenAbgeschlossen.setErrors(null); // tab Abschluss dauerhaft ausblenden!
        //this.CRUDForm.controls.massnahmenAbgeschlossen.addValidators(Validators.required); // tab Abschluss dauerhaft ausblenden!
        //this.CRUDForm.controls.massnahmenAbgeschlossen.updateValueAndValidity(); // tab Abschluss dauerhaft ausblenden!
        //this.CRUDForm.controls.weiterbetrieb.setErrors(null); // tab Abschluss dauerhaft ausblenden!
        //if(this.leistung != null && this.leistung.pruefergebnis != true) this.CRUDForm.controls.weiterbetrieb.addValidators(Validators.required); // tab Abschluss dauerhaft ausblenden!
        //this.CRUDForm.controls.weiterbetrieb.updateValueAndValidity(); // tab Abschluss dauerhaft ausblenden!
        //this.CRUDForm.controls.pruefergebnisSelected.setErrors(null);
        //if(this.leistung != null && this.leistung.pruefergebnis == true) this.CRUDForm.controls.pruefergebnisSelected.addValidators(Validators.required);
        //this.CRUDForm.controls.pruefergebnisSelected.updateValueAndValidity();
    }

    updateValidatorsDependingFromLeistung() {
        console.log(
            "AuftragsChecklisteDetailComponent.updateValidatorsDependingFromLeistung()",
        );
        if (this.leistung == null || this.leistung.pumpentyp != true) {
            this.CRUDForm.controls.pumpentypSelected.setErrors(null);
            this.CRUDForm.controls.pumpentypSelected.clearValidators();
            this.CRUDForm.controls.pumpentypSelected.updateValueAndValidity();
        }
        if (this.leistung == null || this.leistung.anstrich != true) {
            this.CRUDForm.controls.anstrichSelected.setErrors(null);
            this.CRUDForm.controls.anstrichSelected.clearValidators();
            this.CRUDForm.controls.anstrichSelected.updateValueAndValidity();
        }
        //if(this.leistung != null && this.leistung.leistungsart != "BEHAUSL") {
        //  this.CRUDForm.controls._Auftragsdaten_BehaelterSelected.setErrors(null);
        //  this.CRUDForm.controls._Auftragsdaten_BehaelterSelected.clearValidators();
        //  this.CRUDForm.controls._Auftragsdaten_BehaelterSelected.updateValueAndValidity();
        //}
        //if(this.leistung == null || this.leistung.anstrich == true) {
        //  this.CRUDForm.controls.behaelterdruck.setErrors(null);
        //  this.CRUDForm.controls.behaelterdruck.clearValidators();
        //  this.CRUDForm.controls.behaelterdruck.updateValueAndValidity();
        //  this.CRUDForm.controls.behaelterfuellgrad.setErrors(null);
        //  this.CRUDForm.controls.behaelterfuellgrad.clearValidators();
        //  this.CRUDForm.controls.behaelterfuellgrad.updateValueAndValidity();
        //}
        if (this.leistung == null || this.leistung.unterschriftKunde != true) {
            this.CRUDForm.controls.unterschriftKunde.setErrors(null);
            this.CRUDForm.controls.unterschriftKunde.clearValidators();
            this.CRUDForm.controls.unterschriftKunde.updateValueAndValidity();
            this.CRUDForm.controls.unterschriftKundeEMail.setErrors(null);
            this.CRUDForm.controls.unterschriftKundeEMail.clearValidators();
            this.CRUDForm.controls.unterschriftKundeEMail.updateValueAndValidity();
            this.CRUDForm.controls.unterschriftKundeName.setErrors(null);
            this.CRUDForm.controls.unterschriftKundeName.clearValidators();
            this.CRUDForm.controls.unterschriftKundeName.updateValueAndValidity();
        }
        //if(this.leistung == null || this.leistung.pruefergebnis == true) { // tab Abschluss dauerhaft ausblenden!
        //  this.CRUDForm.controls.weiterbetrieb.setErrors(null); // tab Abschluss dauerhaft ausblenden!
        //  this.CRUDForm.controls.weiterbetrieb.clearValidators(); // tab Abschluss dauerhaft ausblenden!
        //  this.CRUDForm.controls.weiterbetrieb.updateValueAndValidity(); // tab Abschluss dauerhaft ausblenden!
        //}
        //if(this.leistung == null || this.leistung.pruefergebnis != true) {
        //  this.CRUDForm.controls.pruefergebnisSelected.setErrors(null);
        //  this.CRUDForm.controls.pruefergebnisSelected.clearValidators();
        //  this.CRUDForm.controls.pruefergebnisSelected.updateValueAndValidity();
        //}
    }
    updateValidatorsDependingFromSettings() {
        console.log(
            "AuftragsChecklisteDetailComponent.updateValidatorsDependingFromSettings()",
        );
        if (this.unterschriftKundeRequired == false) {
            this.CRUDForm.controls.unterschriftKunde.setErrors(null);
            this.CRUDForm.controls.unterschriftKunde.clearValidators();
            this.CRUDForm.controls.unterschriftKunde.updateValueAndValidity();
        }
        if (this.unterschriftKundeEMailRequired == false) {
            //US 38470 Validators nur dann setzten wenn sie vorher auch schon gesetzt waren!
            let emailValidatorSet =
                this.CRUDForm.controls.unterschriftKundeEMail.hasValidator(
                    Validators.email,
                );
            let lengthValidatorSet =
                this.CRUDForm.controls.unterschriftKundeEMail.hasValidator(
                    Validators.maxLength(100),
                );

            this.CRUDForm.controls.unterschriftKundeEMail.setErrors(null);
            this.CRUDForm.controls.unterschriftKundeEMail.clearValidators();
            // Es soll ja nur der "required" gelöscht werden, die anderen Validators sollen bleiben! (Wenn sie zuvor auch schon vorhanden waren)
            if (emailValidatorSet)
                this.CRUDForm.controls.unterschriftKundeEMail.addValidators(
                    Validators.email,
                );

            if (lengthValidatorSet)
                this.CRUDForm.controls.unterschriftKundeEMail.addValidators(
                    Validators.maxLength(100),
                );

            this.CRUDForm.controls.unterschriftKundeEMail.updateValueAndValidity();
        }
    }
    buildFormCloneForStartValidationOnly() {
        // eine Form builden, wo nur die Controls von Start drin sind (um nur die zu prüfen)
        let CRUDFormFilteredOnlyStart = this.fb.group({});
        CRUDFormFilteredOnlyStart.controls.pruefdatum =
            this.CRUDForm.controls.pruefdatum;
        //CRUDFormFilteredOnlyStart.controls.anlagenbeschreibungSelected = this.CRUDForm.controls.anlagenbeschreibungSelected; // -> Das Feld ist nicht mehr sichtbar, daher auch keine Prüfungen
        CRUDFormFilteredOnlyStart.controls.pumpentypSelected =
            this.CRUDForm.controls.pumpentypSelected;
        CRUDFormFilteredOnlyStart.controls.anstrichSelected =
            this.CRUDForm.controls.anstrichSelected;
        CRUDFormFilteredOnlyStart.controls._Auftragsdaten_BehaelterSelected =
            this.CRUDForm.controls._Auftragsdaten_BehaelterSelected;
        //CRUDFormFilteredOnlyStart.controls.behaelterdruck = this.CRUDForm.controls.behaelterdruck;
        //CRUDFormFilteredOnlyStart.controls.behaelterfuellgrad = this.CRUDForm.controls.behaelterfuellgrad;

        return CRUDFormFilteredOnlyStart;
    }

    validateStart() {
        // NUR Start validaten!
        console.log("AuftragsChecklisteDetailComponent.validateStart()");

        // Validatoren AUF DER STARTSEITE prüfen
        this.CRUDForm.controls.pruefdatum.updateValueAndValidity();
        //this.CRUDForm.controls.anlagenbeschreibungSelected.updateValueAndValidity(); // -> Das Feld ist nicht mehr sichtbar, daher auch keine Prüfungen
        this.CRUDForm.controls.pumpentypSelected.updateValueAndValidity();
        this.CRUDForm.controls.anstrichSelected.updateValueAndValidity();
        this.CRUDForm.controls._Auftragsdaten_BehaelterSelected.updateValueAndValidity();
        //this.CRUDForm.controls.behaelterdruck.updateValueAndValidity();
        //this.CRUDForm.controls.behaelterfuellgrad.updateValueAndValidity();

        console.log(
            "AuftragsChecklisteDetailComponent.validateStart() CRUDForm.controls:",
            this.CRUDForm.controls,
        );
        if (
            this.CRUDForm.controls.pruefdatum.errors != null ||
            //|| this.CRUDForm.controls.anlagenbeschreibungSelected.errors != null // -> Das Feld ist nicht mehr sichtbar, daher auch keine Prüfungen
            this.CRUDForm.controls.pumpentypSelected.errors != null ||
            this.CRUDForm.controls.anstrichSelected.errors != null ||
            this.CRUDForm.controls._Auftragsdaten_BehaelterSelected.errors !=
                null
            //|| this.CRUDForm.controls.behaelterdruck.errors != null
            //|| this.CRUDForm.controls.behaelterfuellgrad.errors != null
        ) {
            this.startLastValidationWasInvalid = true;
        } else {
            this.startLastValidationWasInvalid = false;
        }

        return !this.startLastValidationWasInvalid;
    }

    saveCRUDItem(a: any, close: boolean) {
        // overwrite
        console.log("AuftragsChecklisteDetailComponent.saveCRUDItem() a:", a);

        let itemToSave = cloneDeep(a);

        //TODO
        itemToSave.pruefer = "#";
        //itemToSave.ergebnis = "#";
        itemToSave.betriebskennzeichen = "#";
        itemToSave.nachpruefungErforderlich = "#";
        itemToSave.positionsdaten.forEach((positionsdaten) => {
            //if(positionsdaten.bemerkung == undefined) positionsdaten.bemerkung = ""; // sonst Fehler beim put
        });
        //itemToSave.unterschriftPruefer = "";
        //itemToSave.unterschriftKunde = "";
        if (itemToSave.rowVersion == null) itemToSave.rowVersion = "";

        //if(this.dataId == 0) { // Neuanlage   -> verlegt nach CRUDItemRetrieved
        //  itemToSave.auftragsdatenId = this.CRUDItem.auftragsdatenId;
        //  itemToSave.checklisteId = this.CRUDItem.checklisteId;
        //  itemToSave.dokumentId = this.CRUDItem.dokumentId;
        //  itemToSave.benutzerId = this._app.getBenutzer().id;
        //}

        // Positionsdaten: nur die speichern, die bereits eine id haben, oder _touched sind
        itemToSave.positionsdaten = itemToSave.positionsdaten.filter(
            (f) => f["_touched"] == true || (f.id != null && f.id != 0),
        ); // offline: neu angelegte haben negative id

        // Navigationen auf Checkliste etc. NICHT übergeben, sonst versucht EF die neu anzulegen
        itemToSave.positionsdaten.forEach((positionsdaten) => {
            delete positionsdaten.checklistePosition;

            positionsdaten.positionsdatenFelder.forEach(
                (positionsdatenFeld) => {
                    delete positionsdatenFeld.checklistePositionenFeld;
                },
            );
        });

        // feld.feldwert enthält WÄHREND CRUDBasicAutocompleteComponent das komplette Objekt, in der DB aber nur die Id
        // (Details siehe *** CONTAINER_FELDWERT)
        // Daher:
        // Bei Save: alle feldwerte des Typs containerNr -> objekt ersetzen durch id
        const allePosData = itemToSave.positionsdaten;
        allePosData.forEach((positionsdaten, posIdx) => {
            const alleFelder = positionsdaten.positionsdatenFelder;
            alleFelder.forEach((feld, feldIdx) => {
                if (feld.typ == "containerNr" && feld.feldwert != null) {
                    feld.feldwert = "" + feld.feldwert.id;
                }
            });
        });

        // Bilder
        console.log(
            "AuftragsChecklisteDetailComponent.saveCRUDItem() CRUDItem.positionsdaten:",
            this.CRUDItem.positionsdaten,
        );

        super.saveCRUDItem(itemToSave, close);
    }

    onSaveComplete(close: boolean): void {
        // overwrite - aber nur wegen dem navigate - bzw. dem zwischengeschalteten WellDoneDialog
        this.blockedDocument = false;
        let bezeichnung = this.getCRUDBezeichnung();
        this.messageWrapperService.postTimedMessage({
            severity: "success",
            summary: this.deleted
                ? this.translate.instant("Löschen erfolgreich", true)
                : this.translate.instant("Speichern erfolgreich", true),
            detail: bezeichnung,
        }); // TO DO
        this.CRUDForm.reset();
        // US 14152: Es gibt ein Problem, wenn man ein Feld ändert, NICHT verlässt, per STRG+S zwischenspeichert.
        // in dem Fall bleibt das Feld / die Form dirty. Der dirty muss aber raus, sonst kann man die Form nicht verlassen (guard!)
        if (close == false) {
            let activeElement = $(document.activeElement);
            if (activeElement != null) {
                activeElement.blur();
                activeElement.focus();
            }
        }
        if (close) {
            //console.log("CRUDBasicDetailComponent.onSaveComplete() routing to:", this.CRUDItemRoutePlural);
            //this.router.navigate(['/' + this.CRUDItemRoutePlural], { queryParamsHandling: "merge" });

            // wenn Abschliessen -> wellDoneDialog (der macht später die navigation) - bei "Zwischenspeichern" -> direkt navigieren
            if (this.wellDoneDialogSkip == false) {
                this.wellDoneDialogSkip = null;
                this.wellDoneDialogShow = true;
            } else {
                this.wellDoneDialogSkip = null;
                //this.router.navigate(['/map']);

                // siehe RouteBuilderAuftragsCheckliste: dort musste der Dialog in der Map geschlossen werden.
                // den nun wieder aktivieren
                if (this.app.getMapComponent() != null) {
                    let mapComponent = this.app.getMapComponent();
                    mapComponent.dialogAuftragUnhide();

                    // Ausserdem: nach zwischenspeichern: Icon aktualisieren, Es könnte sich ja die Farbe ändern ...
                    let auftrag = mapComponent.lastclickedAuftrag;
                    if (auftrag != null) {
                        let existingMarker = auftrag["___marker"];
                        if (
                            existingMarker != null &&
                            existingMarker != undefined
                        ) {
                            // neue Auftragsdaten lesen (weil inzw. vermutlich Status M = Begonnen)
                            this.auftragsdatenService
                                .getAuftragsdatenIncludingPositionen(auftrag.id)
                                .subscribe(
                                    (response) => {
                                        console.log(
                                            "AuftragsChecklisteDetailComponent.onSaveComplete() getAuftragsdatenIncludingPositionen() response:",
                                            response,
                                        );
                                        auftrag = response;
                                        auftrag["___marker"] = existingMarker;

                                        // Wichtig: auch den Auftrag im array aktualisieren (das ggf. Status M)
                                        let auftragFoundInAuftraegeIdx =
                                            mapComponent.auftraege.findIndex(
                                                (f) => f.id == auftrag.id,
                                            );
                                        if (auftragFoundInAuftraegeIdx > -1) {
                                            let auftragFoundInAuftraege_existingMarker =
                                                mapComponent.auftraege[
                                                    auftragFoundInAuftraegeIdx
                                                ]["___marker"];
                                            mapComponent.auftraege[
                                                auftragFoundInAuftraegeIdx
                                            ] = response;
                                            console.log(
                                                "AuftragsChecklisteDetailComponent.onSaveComplete() mapComponent.auftraege[auftragFoundInAuftraegeIdx]:",
                                                mapComponent.auftraege[
                                                    auftragFoundInAuftraegeIdx
                                                ],
                                            );
                                            mapComponent.auftraege[
                                                auftragFoundInAuftraegeIdx
                                            ]["___marker"] =
                                                auftragFoundInAuftraege_existingMarker;
                                        }

                                        let ueberfaelligJahr =
                                            mapComponent.isAuftragUeberfaelligJahr(
                                                auftrag,
                                            );
                                        let ueberfaelligTage =
                                            mapComponent.isAuftragUeberfaelligTage(
                                                auftrag,
                                            );
                                        let sameLocationCounter = 0;
                                        sameLocationCounter =
                                            existingMarker[
                                                "___sameLocationCounter"
                                            ];
                                        let markerIcon =
                                            mapComponent.getMarkerIcon(
                                                auftrag,
                                                ueberfaelligJahr,
                                                ueberfaelligTage,
                                                sameLocationCounter,
                                            );
                                        existingMarker.setIcon(markerIcon);
                                    },
                                    function (error) {
                                        console.error(
                                            "AuftragsChecklisteDetailComponent.onSaveComplete() getAuftragsdatenIncludingPositionen() error:",
                                            error,
                                        );
                                        return this.handleError(error);
                                    },
                                );
                        }
                    }
                }

                this.navigateToMapOrList();
            }
        }
    }

    wellDoneDialogWeiterClicked() {
        // Map/Liste über Umweg laden, weil wir wollen nach Abschliessen ein Refresh -> da soll die ReUseStrategy umgangen werden!
        /*this.router.navigateByUrl('/dummy', {skipLocationChange: true}).then(() => {
      setTimeout(() => {
        this.navigateToMapOrList();
      }, 10);		
    });*/

        // wenn abgeschlossen, dann aus der Map ausblenden! - Aus der Liste aber nicht! - danach ganz normal zurück zur Map!
        try {
            this._app.getMapComponent().removeMarker(this.auftragsdaten);
        } catch (e) {
            console.error(
                "AuftragsChecklisteDetailComponent.wellDoneDialogWeiterClicked() error:",
                e,
            );
        }
        this.navigateToMapOrList();
    }

    getCRUDBezeichnung() {
        // overwrite
        //if(this.CRUDForm != null && this.CRUDForm.get('bezeichnung') != null) return this.CRUDForm.get('bezeichnung').value;
        //return this.CRUDItem.bezeichnung;
        return "Auftrag";
    }

    calculateTouchedAndValid() {
        let touchedOrAlreadySavedAndValid = 0;
        this.CRUDItem.positionsdaten.forEach((positionsdaten) => {
            if (
                positionsdaten["_valid"] == true &&
                (positionsdaten["_touched"] == true ||
                    (positionsdaten.id != null && positionsdaten.id != 0))
            )
                touchedOrAlreadySavedAndValid++; // offline: neu angelegte haben negative id
            else if (
                positionsdaten["_enabled"] == false &&
                (positionsdaten["_touched"] == true ||
                    (positionsdaten.id != null && positionsdaten.id != 0))
            )
                touchedOrAlreadySavedAndValid++; // ausgeblendete als erledigte zählen // offline: neu angelegte haben negative id
        });
        this.posCountTouchedOrAlreadySavedAndValid =
            touchedOrAlreadySavedAndValid;
    }

    getValuesFromForm() {
        let a = super.getValuesFromForm(); // Standard! do not change!

        // CHILD-spezifische assigns, z.B. spracheId aus strache.Id bestücken - START
        // Die signaturePad Daten werden bereits durch unterschriftOnChangeXXX() in CRUDItem übernommen - daher daraus nehmen!
        /*
    let dataKunde = this.signaturePadKunde.getPNGData();
    a.unterschriftKunde = dataKunde;
    let dataPruefer = this.signaturePadPruefer.getPNGData();
    a.unterschriftKunde = dataPruefer;
    */
        a.unterschriftKunde = this.CRUDItem.unterschriftKunde;
        a.unterschriftPruefer = this.CRUDItem.unterschriftPruefer;
        // nach Unterschrift-Löschen Button ist das null! das darf aber nicht, daher abfragen:
        if (a.unterschriftKunde == null) a.unterschriftKunde = ""; // wieder so setzen wie aus initialize...();
        if (a.unterschriftPruefer == null) a.unterschriftPruefer = ""; // wieder so setzen wie aus initialize...();

        a.anlagenbeschreibungAnlagentyp =
            a.anlagenbeschreibungSelected != null
                ? a.anlagenbeschreibungSelected.anlagentyp
                : null;
        a.anlagenbeschreibung = null;
        a.pumpentyp =
            a.pumpentypSelected != null ? a.pumpentypSelected.value : null;
        //a.ergebnis = a.pruefergebnisSelected != null ? a.pruefergebnisSelected.value : null;

        //a.anstrich = a.anstrichSelected != null ? a.anstrichSelected : null;
        a.anstrich = null;
        a.anstrichId =
            a.anstrichSelected != null ? a.anstrichSelected.id : null;
        a.anstrichBezeichnung =
            a.anstrichSelected != null ? a.anstrichSelected.bezeichnung : null;

        // das ist der Behälter, der nachträglich bei Auslieferung eingetragen wird!
        a._Auftragsdaten_Behaelter = null;
        a._Auftragsdaten_BehaelterId =
            a._Auftragsdaten_BehaelterSelected != null
                ? a._Auftragsdaten_BehaelterSelected.id
                : null;

        a.zusaetzlicheEMailAdressen = null;
        if (
            a.zusaetzlicheEMailAdressenArr != null &&
            a.zusaetzlicheEMailAdressenArr.length > 0
        ) {
            a.zusaetzlicheEMailAdressenArr.forEach((zusaetzlicheEMail) => {
                console.log(
                    "AuftragsChecklisteDetailComponent.getValuesFromForm() zusaetzlicheEMail:",
                    zusaetzlicheEMail,
                );
                if (a.zusaetzlicheEMailAdressen == null)
                    a.zusaetzlicheEMailAdressen = "";
                else a.zusaetzlicheEMailAdressen += ",";
                a.zusaetzlicheEMailAdressen += zusaetzlicheEMail;
            });
        }

        // zuvor aber noch alle Zeitfelder wie zu 5 stelligen Alphas machen
        a.positionsdaten.forEach((positionsdaten) => {
            positionsdaten.positionsdatenFelder.forEach(
                (positionsdatenFeld) => {
                    if (
                        positionsdatenFeld.checklistePositionenFeld.typ ==
                            "time" &&
                        positionsdatenFeld.feldwert != null
                    ) {
                        let zeit5stellig =
                            (
                                "0" + positionsdatenFeld.feldwert.getHours()
                            ).slice(-2) +
                            ":" +
                            (
                                "0" + positionsdatenFeld.feldwert.getMinutes()
                            ).slice(-2);
                        positionsdatenFeld.feldwert = zeit5stellig;
                    } else if (
                        positionsdatenFeld.checklistePositionenFeld.typ.startsWith(
                            "date",
                        ) &&
                        positionsdatenFeld.feldwert != null
                    ) {
                        let datum10stellig =
                            (
                                "0" + positionsdatenFeld.feldwert.getFullYear()
                            ).slice(-4) +
                            "." +
                            (
                                "0" +
                                (positionsdatenFeld.feldwert.getMonth() + 1)
                            ).slice(-2) +
                            "." +
                            ("0" + positionsdatenFeld.feldwert.getDate()).slice(
                                -2,
                            );
                        positionsdatenFeld.feldwert = datum10stellig;
                    }
                },
            );
        });

        // dasselbe für Datumsfelder in LeistungenRueckgemeldet
        /*a.leistungenRueckgemeldet.forEach(leistungRueckgemeldet => {
      if(leistungRueckgemeldet.lieferdatum != null && leistungRueckgemeldet.lieferdatum instanceof Date) {
        let datum10stellig = 
        ("0" + leistungRueckgemeldet.lieferdatum.getFullYear()).slice(-4) + "." + 
        ("0" + (leistungRueckgemeldet.lieferdatum.getMonth() +1)).slice(-2) + "." + 
        ("0" + leistungRueckgemeldet.lieferdatum.getDate()).slice(-2);
        leistungRueckgemeldet.lieferdatum = datum10stellig;
        debugger;
      }
    });*/

        // *TEXT1000
        // string und text-Eingaben dürfen maximal 1000 Zeichen sein! - Das wurde in bereits geprüft und gewarned! (siehe *TEXT1000)
        // wenn er nun trotzdem speichert, muss bei 1000 Zeichen abgeschnitten werden.
        a.positionsdaten.forEach((positionsdaten) => {
            positionsdaten.positionsdatenFelder.forEach((feld) => {
                if (
                    (feld.checklistePositionenFeld.typ == "string" ||
                        feld.checklistePositionenFeld.typ == "text") &&
                    feld.feldwert.length > this.posFeldTextMaxLen
                ) {
                    feld.feldwert = feld.feldwert.substring(0, 1000);
                    console.error(
                        "AuftragsChecklisteDetailComponent.getValuesFromForm() WARNING: feldwert gekürzt bei bei positionsdaten/feld:",
                        positionsdaten.bezeichnung,
                        feld.bezeichnung,
                    );
                }
            });
        });

        // LeistungenRueckgemeldet OHNE SpediteurKatalog zurückmelden - die id reicht!, dasselbe für Kopfdaten
        a.leistungenRueckgemeldet.forEach((leistungRueckgemeldet) => {
            leistungRueckgemeldet.artikelnummerId =
                leistungRueckgemeldet.artikelnummer.id;
            delete leistungRueckgemeldet.artikelnummer;
            delete leistungRueckgemeldet.kopfdaten;
        });

        // letzteAktion
        a.letzteAktion = "T;" + this.tabSelected + ";P;" + this.posSelected;

        // CHILD-spezifische assigns, z.B. spracheId aus strache.Id bestücken - ENDE

        console.log(
            "AuftragsChecklisteDetailComponent.getValuesFromForm() a:",
            a,
        );
        return a;
    }

    sendValuesToForm() {
        // CHILD-spezifisch die Form patchen - START
        //let anlagenbeschreibungSelectedArr = this.anlagenbeschreibungOptions.filter(f => f.value == /*'B'*/this.CRUDItem.anlagenbeschreibung);
        //let anlagenbeschreibungSelected = anlagenbeschreibungSelectedArr != null && anlagenbeschreibungSelectedArr.length != 0 ? anlagenbeschreibungSelectedArr[0] : null;
        let pumpentypSelectedArr = this.pumpentypOptions.filter(
            (f) => f.value == /*'B'*/ this.CRUDItem.pumpentyp,
        );
        let pumpentypSelected =
            pumpentypSelectedArr != null && pumpentypSelectedArr.length != 0
                ? pumpentypSelectedArr[0]
                : null;
        //let pruefergebnisSelectedArr = this.pruefergebnisOptions.filter(f => f.value == /*'B'*/this.CRUDItem.ergebnis);
        //let pruefergebnisSelected = pruefergebnisSelectedArr != null && pruefergebnisSelectedArr.length != 0 ? pruefergebnisSelectedArr[0] : null;

        let zusaetzlicheEMailsArr =
            this.CRUDItem.zusaetzlicheEMailAdressen != null
                ? this.CRUDItem.zusaetzlicheEMailAdressen.split(",")
                : null;

        this.CRUDForm.patchValue({
            pruefdatum:
                this.CRUDItem.pruefdatum != null
                    ? new Date(this.CRUDItem.pruefdatum)
                    : null,
            pruefer: this.CRUDItem.pruefer,
            rueckmeldedatum:
                this.CRUDItem.rueckmeldedatum != null
                    ? new Date(this.CRUDItem.rueckmeldedatum)
                    : null,
            //pruefergebnisSelected: pruefergebnisSelected,
            betriebskennzeichen: this.CRUDItem.betriebskennzeichen,
            datumNaechsteAnlagenpruefung:
                this.CRUDItem.datumNaechsteAnlagenpruefung != null
                    ? new Date(this.CRUDItem.datumNaechsteAnlagenpruefung)
                    : null,
            datumNaechsteFeststellungspruefung:
                this.CRUDItem.datumNaechsteFeststellungspruefung != null
                    ? new Date(this.CRUDItem.datumNaechsteFeststellungspruefung)
                    : null,
            nachpruefungErforderlich: this.CRUDItem.nachpruefungErforderlich,
            datumNachpruefungBis:
                this.CRUDItem.datumNachpruefungBis != null
                    ? new Date(this.CRUDItem.datumNachpruefungBis)
                    : null,
            bemerkung: this.CRUDItem.bemerkung,
            eMailversand: this.CRUDItem.eMailversand,
            eMailversandProtokoll: this.CRUDItem.eMailversandProtokoll,
            unterschriftPruefer: this.CRUDItem.unterschriftPruefer,
            unterschriftKunde: this.CRUDItem.unterschriftKunde,
            anlagenbeschreibungSelected: this.CRUDItem.anlagenbeschreibung,
            pumpentypSelected: pumpentypSelected,
            anstrichSelected: this.CRUDItem.anstrich,
            //behaelterdruck: this.CRUDItem.behaelterdruck,
            //behaelterfuellgrad: this.CRUDItem.behaelterfuellgrad,
            unterschriftKundeName: this.CRUDItem.unterschriftKundeName,
            unterschriftKundeEMail: this.CRUDItem.unterschriftKundeEMail,
            unterschriftPrueferName: this.CRUDItem.unterschriftPrueferName,
            zusaetzlicheEMailAdressenArr: zusaetzlicheEMailsArr,
            //massnahmenAbgeschlossen: this.CRUDItem.massnahmenAbgeschlossen, // tab Abschluss dauerhaft ausblenden!
            //weiterbetrieb: this.CRUDItem.weiterbetrieb, // tab Abschluss dauerhaft ausblenden!
            _Auftragsdaten_Wiedervorlage:
                this.CRUDItem._Auftragsdaten_Wiedervorlage != null
                    ? new Date(this.CRUDItem._Auftragsdaten_Wiedervorlage)
                    : null,
            _Auftragsdaten_BehaelterSelected:
                this.CRUDItem._Auftragsdaten_Behaelter,
        });

        // CHILD-spezifisch die Form patchen - ENDE
        //console.log("KopfdatenDetailComponent.sendValuesToForm() CRUDForm:", this.CRUDForm);
        super.sendValuesToForm(); // haben nicht alle DetailComponents - erst ab Ticket 9412 17.07.2019
    }

    tabSelectedChanged() {
        let i = 0;
        for (let t of this.tabView.tabs) {
            if (t._selected) this.tabSelected = i;
            i++;
        }
        console.log(
            "Checkliste.tabSelectedChanged() tabSelected:",
            this.tabSelected,
        );

        setTimeout(() => {
            this.resizeFileUpload();
        }, 500);
    }

    startClicked(ohnePruefung: boolean) {
        if (ohnePruefung != true) {
            if (this.validateStart() == false) {
                // wenn nicht Fehlerfrei, dann Stop!
                setTimeout(() => {
                    // Fehler ausgeben (aus CRUDBasicDetail.validateAndSave()) - aber nur die der StartSeite !!!
                    let CRUDFormFilteredOnlyStart =
                        this.buildFormCloneForStartValidationOnly();
                    this.displayMessage = this.genericValidator.processMessages(
                        CRUDFormFilteredOnlyStart,
                        true,
                    );

                    let errorMessage: string = "";
                    for (let key of Object.keys(this.displayMessage)) {
                        if (
                            this.displayMessage[key] != null &&
                            this.displayMessage[key] != ""
                        ) {
                            errorMessage += "<br>" + this.displayMessage[key];
                        }
                    }
                    //if (this.CRUDForm.errors != null) {
                    //  for (let error of Object.keys(this.CRUDForm.errors)) {
                    //    errorMessage += '<br>' + this.translate.instant(error, true);
                    //    // Fehlermeldungen aus formValidators (nicht controlValidators) festhalten, damit die im HTML dargestellt werden können
                    //    this.displayMessageForm[error] = this.translate.instant(error, true);
                    //  }
                    //}

                    let message: Message = {
                        severity: "error",
                        summary: this.translate.instant(
                            "Validierungsfehler",
                            true,
                        ),
                        detail: `${errorMessage}`,
                    };
                    this.messageWrapperService.postTimedMessage(message);
                }, 100);

                console.log(
                    "Checkliste.startClicked() this.displayMessage:",
                    this.displayMessage,
                );
                return;
            }
        }

        this.tabSelected++;

        this.updatePosEnabled();
        this.posUeberspringeNotEnabled("F", ohnePruefung);

        this.posErrors = [];
        this.posPrepareAllAutoCompletes();
        this.posFileUploadUpdate();

        /*for(let t of this.tabView.tabs){
      if (t.selected)
           t.selected = false;
}
    this.tabView.tabs[this.tabSelected].selected = true;*/
        console.log("Checkliste.startClicked() tabView:", this.tabView);

        setTimeout(() => {
            this.resizeFileUpload();
        }, 500);
    }

    posUeberspringeNotEnabled(
        direction: string /* F = Forward / B = Backward */,
        ueberspringen: boolean,
    ) {
        // so lange vorwärtsblättern bis eine _enabled pos ...
        if (this.debugMode == true)
            console.log(
                "Checkliste.posUeberspringeNotEnabled() posSelected:",
                this.posSelected,
            );
        if (this.debugMode == true)
            console.log(
                "Checkliste.posUeberspringeNotEnabled() CRUDItem.positionsdaten[this.posSelected]:",
                this.CRUDItem.positionsdaten[this.posSelected],
            );
        let uebersprungen: boolean = false;
        while (
            this.tabSelected == this.tabNRPos &&
            this.CRUDItem.positionsdaten[this.posSelected]["_enabled"] == false
        ) {
            this.CRUDItem.positionsdaten[this.posSelected]["_touched"] = true;
            uebersprungen = true;
            let _abhaengigkeitenAndOperator: I_Abhaengigkeit[] =
                this.getAbhaengigkeitPos(
                    this.CRUDItem.positionsdaten[this.posSelected],
                    false,
                );
            //let _abhaengigkeitPlatzhalterFeld = _abhaengigkeitAndOperator.platzhalterFeld;
            //let _abhaengigkeitSummary = _abhaengigkeitPlatzhalterFeld.checklistePositionenFeld.bezeichnung;
            //let _abhaengigkeitSummary = _abhaengigkeitAndOperator.summary;
            let _abhaengigkeitSummary = this.summarizeAbhaengigkeitenSummaries(
                _abhaengigkeitenAndOperator,
            );
            if (this.debugMode == true)
                this.messageWrapperService.postStaticMessage({
                    severity: "info",
                    summary:
                        "DEBUG: " +
                        this.translate.instant(
                            "Position wurde übersprungen",
                            true,
                        ),
                    detail:
                        "Position " +
                        (this.posSelected + 1) +
                        " '" +
                        this.CRUDItem.positionsdaten[this.posSelected]
                            .bezeichnung +
                        "' wurde übersprungen" +
                        "\n\n" +
                        "Grund: " +
                        _abhaengigkeitSummary,
                });
            if (direction == "F") {
                if (
                    this.posSelected <
                    this.CRUDItem.positionsdaten.length - 1
                ) {
                    console.log(
                        "Checkliste.posUeberspringeNotEnabled() überspringe pos posSelected:",
                        this.posSelected,
                    );
                    this.posSelected++;
                } else {
                    // es gibt keine weitere Position: zu den Kopfdaten!
                    console.log(
                        "Checkliste.posUeberspringeNotEnabled() überspringe LETZTE pos posSelected:",
                        this.posSelected,
                    );
                    //if(ueberspringen != true) this.weiterZuKopfClicked(false /* aus HTML hier ohne parm! */); //
                    //else this.weiterZuKopfClicked(true); // wie wenn man im HTML klickt ...
                    this.weiterZuKopfClicked(true); // die position soll immer wie "überspringen" behandelt werden! soll ja nicht geprüft werden!
                }
            } else if (direction == "B") {
                if (this.posSelected > 0) {
                    console.log(
                        "Checkliste.posUeberspringeNotEnabled() überspringe pos posSelected:",
                        this.posSelected,
                    );
                    this.posSelected--;
                } else {
                    // es gibt keine weitere Position: zu den Kopfdaten!
                    console.log(
                        "Checkliste.posUeberspringeNotEnabled() überspringe LETZTE pos posSelected:",
                        this.posSelected,
                    );
                    //if(ueberspringen != true) this.zurueckClicked(false /* aus HTML hier ohne parm! */); // wie wenn man im HTML klickt ...
                    //else this.zurueckClicked(true); // wie wenn man im HTML klickt ...
                    this.zurueckClicked(true); // die position soll immer wie "überspringen" behandelt werden! soll ja nicht geprüft werden!
                }
            }
        }
        if (uebersprungen == true) this.calculateTouchedAndValid(); // weil die ja neue als _touched markiert wurden
    }

    zurueckZuLeistungenBzwPosClicked() {
        if (this.tabSelected == this.tabNRKopf) {
            if (this.tabNRLeistungen != null && this.tabNRLeistungen != 0) {
                this.zurueckZuLeistungenClicked();
            } else {
                this.zurueckZuPosClicked();
            }
        } else {
            this.zurueckZuPosClicked();
        }
    }

    zurueckZuPosClicked() {
        this.tabSelected--;

        this.updatePosEnabled();
        this.posUeberspringeNotEnabled("B", false);

        this.posErrors = [];
        this.posPrepareAllAutoCompletes();
        this.posFileUploadUpdate();

        console.log("Checkliste.zurueckZuPosClicked() tabView:", this.tabView);

        setTimeout(() => {
            this.resizeFileUpload();
        }, 500);
    }

    zurueckZuLeistungenClicked() {
        console.log(
            "Checkliste.zurueckZuLeistungenClicked() tabView:",
            this.tabView,
        );
        this.zurueckZuVorherigemTab();
    }
    zurueckZuKopfClicked() {
        console.log("Checkliste.zurueckZuKopfClicked() tabView:", this.tabView);
        this.zurueckZuVorherigemTab();
    }
    zurueckZuAbschlussClicked() {
        console.log(
            "Checkliste.zurueckZuAbschlussClicked() tabView:",
            this.tabView,
        );
        this.zurueckZuVorherigemTab();
    }
    zurueckZuUnterschriftKundeClicked() {
        console.log(
            "Checkliste.zurueckZuUnterschriftKundeClicked() tabView:",
            this.tabView,
        );
        this.zurueckZuVorherigemTab();
    }
    zurueckZuVorherigemTab() {
        this.tabSelected--;

        this.updatePosEnabled();
        this.posUeberspringeNotEnabled("B", false);

        this.posErrors = [];
        this.posPrepareAllAutoCompletes();
        this.posFileUploadUpdate();

        console.log(
            "Checkliste.zurueckZuVorherigemTab() tabView:",
            this.tabView,
        );

        setTimeout(() => {
            this.resizeFileUpload();
        }, 500);
    }

    zurueckClicked(ohneSave: boolean) {
        if (this.tabSelected == this.tabNRPos) {
            if (ohneSave != true) {
                this.posErrors = this.pruefePosition(true);
                this.calculateTouchedAndValid();
                if (this.posErrors.length > 0) {
                    //return; // Bei Zurück (im Gegensatz zu weiter) IMMER machen, auch wenn Fehlerhaft
                }
            }
        }

        if (this.posSelected > 0) {
            if (ohneSave != true) {
                // save
            }
            this.posSelected--;

            this.updatePosEnabled();
            this.posUeberspringeNotEnabled("B", ohneSave);

            this.posErrors = [];
            this.posPrepareAllAutoCompletes();
            this.posFileUploadUpdate();

            setTimeout(() => {
                this.resizeFileUpload();
            }, 500);
        } else {
            this.tabSelected--;

            /*for(let t of this.tabView.tabs){
        if (t.selected)
             t.selected = false;
  }
      this.tabView.tabs[this.tabSelected].selected = true;*/
            console.log("Checkliste.zurueckClicked() tabView:", this.tabView);

            setTimeout(() => {
                this.resizeFileUpload();
            }, 500);
        }
    }

    weiterVonLeistungenZuKopfClicked() {
        console.log(
            "Checkliste.weiterVonLeistungenZuKopfClicked() tabView:",
            this.tabView,
        );
        this.weiterWennAllePosValid();
    }
    weiterZuAbschlussClicked() {
        console.log(
            "Checkliste.weiterZuAbschlussClicked() tabView:",
            this.tabView,
        );
        this.weiterWennAllePosValid();
    }
    weiterZuUnterschriftKundeClicked() {
        console.log(
            "Checkliste.weiterZuUnterschriftKundeClicked() tabView:",
            this.tabView,
        );
        this.weiterWennAllePosValid();
    }
    weiterZuUnterschriftPrueferClicked() {
        console.log(
            "Checkliste.weiterZuUnterschriftPrueferClicked() tabView:",
            this.tabView,
        );
        this.weiterWennAllePosValid();
    }
    weiterWennAllePosValid() {
        console.log(
            "Checkliste.weiterWennAllePosValid() tabView:",
            this.tabView,
        );
        if (
            this.posCountTouchedOrAlreadySavedAndValid <
            this.CRUDItem.positionsdaten.length
        ) {
            // unterschrift noch nicht zugänglich
            this.messageWrapperService.postStaticMessage({
                severity: "error",
                summary: "Unbearbeitete Positionen",
                detail: "Es gibt noch unbearbeitete Positionen.",
            });
        } else {
            this.weiterZuNaechstemTab();
        }
    }
    weiterZuKopfClicked(ohneSave: boolean) {
        // Wir sind auf der letzten Pos!
        if (ohneSave != true) {
            this.posErrors = this.pruefePosition(true);
            this.calculateTouchedAndValid();
            if (this.posErrors.length > 0) {
                return; // nicht weiter!
            }
        }
        this.weiterZuNaechstemTab();
    }
    weiterZuNaechstemTab() {
        this.tabSelected++;

        this.updatePosEnabled();
        this.posUeberspringeNotEnabled("F", false);

        this.posErrors = [];
        this.posPrepareAllAutoCompletes();
        this.posFileUploadUpdate();

        console.log("Checkliste.weiterZuNaechstemTab() tabView:", this.tabView);

        setTimeout(() => {
            this.resizeFileUpload();
        }, 500);
    }

    weiterClicked(ohneSave: boolean) {
        if (this.tabSelected == this.tabNRPos) {
            if (ohneSave != true) {
                this.posErrors = this.pruefePosition(true);
                this.calculateTouchedAndValid();
                if (this.posErrors.length > 0) {
                    return; // nicht weiter!
                }
            }
        }

        if (this.posSelected < this.CRUDItem.positionsdaten.length - 1) {
            if (ohneSave != true) {
                // save
            }
            this.posSelected++;

            this.updatePosEnabled();
            this.posUeberspringeNotEnabled("F", ohneSave);

            this.posErrors = [];
            this.posPrepareAllAutoCompletes();
            this.posFileUploadUpdate();

            setTimeout(() => {
                this.resizeFileUpload();
            }, 500);
        } else {
            console.log("Checkliste.weiterClicked() nach letzter Position!"); // Sollte niemals vorkommen!, wenn doch! Fix it!
        }
    }

    //uploadFromCamera___OLD_VERSION(/*UorC: string, */bereich: string) {
    /*let inputs = document.getElementsByTagName("input");
    //console.log("Checkliste.uploadFromCamera() inputs:", inputs);
    let numFoundInputImage = 0;
    for(let i = 0; i < inputs.length; i++) {
      if(inputs[i].accept.startsWith('image')) {
        console.log("Checkliste.uploadFromCamera() input für image found:", inputs[i]);
        if(inputs[i].parentElement.innerText=='Datei auswählen') {
          // wenn bereich = Mangel -> 1. gefundene Feld verarbeiten
          // wenn bereich = Behebung -> 2. gefundene Feld verarbeiten
          // Rest ignorieren
          numFoundInputImage++;
          if(bereich == 'M' && numFoundInputImage == 1 || bereich == 'B' && numFoundInputImage == 2 || bereich == 'A' && numFoundInputImage == 1) {
            console.log("Checkliste.uploadFromCamera() input zu 'Datei auswählen' found:", inputs[i]);
            //http://anssiko.github.io/html-media-capture/
            //https://stackoverflow.com/questions/62796478/setting-the-capture-attribute-of-an-html-form-image-input-via-javascript
            inputs[i].setAttribute("capture", "");
            inputs[i].click();
            // Danach direkt wieder zurücksetzen
            setTimeout(() => {
              inputs[i].removeAttribute("capture");
            }, 500);
          }
          else {
            // ignore
          }
        }
      }
    }*/
    //}

    // uploadFromX() vs onNGFileInputSelect
    // camera-button: geht immer über uploadFromX()
    //                ios + android: upload per MAUI
    //                browser: simuliert den Click des Original-Datei auswählen-Button
    // Datei auswählen-button:
    //                android: Der "Original-Button" von PrimeNg wird ausgeblendet, stattdessen ein eigener angezeigt. Der ruft - wie die camera - uploadFromX()
    //                ios + browser: Nutzt den "Original-Button" von PrimeNg
    uploadFromX(from: string, fileUpload: FileUpload) {
        // from: "camera" (cameraButton) / "picker" (app-Mode pickerButton)
        console.log("Checkliste.uploadFromX() fileUpload:", fileUpload);

        if (this.app.inAppMode == true) {
            // nur bei App: Bild wird "nativ"/MAUI aufgenommen - und per JS an uploadFromCameraNative() gesandt
            if (
                /*window.navigator.userAgent*/ this.app.userAgent.indexOf(
                    "DLPApp_Android",
                ) >= 0 ||
                /*window.navigator.userAgent*/ (this.app.userAgent.indexOf(
                    "DLPApp_iOS",
                ) >= 0 &&
                    from == "camera")
            ) {
                console.log(
                    "Checkliste.uploadFromX() Android / iOS = upload 'native'",
                );

                let bereich: string = null;
                if (fileUpload == this.positionsdatenFotosFileUpload_behoben) {
                    bereich = "B";
                } else if (
                    fileUpload == this.positionsdatenFotosFileUpload_mangel
                ) {
                    bereich = "M";
                } else if (
                    fileUpload == this.positionsdatenFotosFileUpload_allgemein
                ) {
                    bereich = "A";
                } else {
                    // kann eigentlich nicht vorkommen, aber sicherheitshalber:
                    alert(
                        "Error: Bereich des Bildes ist nicht definiert (Mangel, Behoben, Allgemein)",
                    );
                }

                setTimeout(() => {
                    let eventData = {
                        eventType: from /*"camera"*/,
                        data: JSON.stringify({
                            bereich: bereich,
                            acceptImage: true,
                            acceptPDF: bereich == "A" ? true : false,
                        }),
                    };
                    this.app.sendMessageToDotNet(eventData);
                }, 10);

                return;
            }
        }

        // Normal/-Nicht-Android-Version
        let nativeElement = fileUpload["el"].nativeElement;
        let firstChild = nativeElement.children[0];
        let firstChildFirstChild = firstChild.children[0];
        let firstChildFirstChildFirstChild = firstChildFirstChild.children[0]; // 1.child = der "Datei auswählen"-Button von PrimeNG // 2.child wäre der Kamera-Button
        console.log(
            "Checkliste.uploadFromX() firstChildFirstChildFirstChild:",
            firstChildFirstChildFirstChild,
        );
        let inputs =
            firstChildFirstChildFirstChild.getElementsByTagName("input");
        console.log("Checkliste.uploadFromX() inputs:", inputs);
        //console.log("Checkliste.uploadFromX() inputs[0].getAttribute('capture'):", inputs[0].getAttribute("capture"));

        inputs[0].setAttribute("capture", "");
        inputs[0].accept = "image/*"; // Wichtig bei Android: application/pdf muss raus, sonst öffnet er nicht direkt die cam!
        inputs[0].click();
        // Danach direkt wieder zurücksetzen
        setTimeout(() => {
            inputs[0].removeAttribute("capture");
            inputs[0].accept = "image/*,application/pdf";
        }, 500);
    }

    //https://stackoverflow.com/questions/35940290/how-to-convert-base64-string-to-javascript-file-object-like-as-from-file-input-f
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    /*debug_simulateNativeUploadFromCamera(bereich: string) {
    console.log("Checkliste.debug_simulateNativeUploadFromCamera()");
    //let dateiname = 'slayer_black'+Date.now()+'.png';
    //let objectURL: string = 'data:image/png;base64,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';
    let dateiname = 'slayer_black'+Date.now()+'.pdf';
    let objectURL: string = 'data:application/pdf;base64,JVBERi0xLjQKJcTl8uXrp4EKMSAwIG9iago8PC9UeXBlL1BhZ2UvUGFyZW50IDAgMCBSL0NvbnRlbnRzIFsgXS9NZWRpYUJveFswIDAgMCAwXSA+PgplbmRvYmoKNiAwIG9iago8PC9UeXBlL0NhdGFsb2cvUGFnZXMgMSAwIFI+PgplbmRvYmoKeHJlZgowIDYKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDEwIDAwMDAwIG4gCjAwMDAwMDAwMjAgMDAwMDAgbiAKdHJhaWxlcgo8PC9TaXplIDYvUm9vdCA2IDAgUi9JbmZvIDUgMCBSCj4+CnN0YXJ0eHJlZgozMAolRU9G';
    //this.uploadFromCameraNative(bereich, dateiname, objectURL);
    setTimeout(() => {
      this.app.uploadFileFromApp('auftragPos', bereich, dateiname, objectURL);
    }, 10);
  }*/

    /*debug_downloadEmptyPDF() {
    var base64String = 'data:application/pdf;base64,JVBERi0xLjQKJcTl8uXrp4EKMSAwIG9iago8PC9UeXBlL1BhZ2UvUGFyZW50IDAgMCBSL0NvbnRlbnRzIFsgXS9NZWRpYUJveFswIDAgMCAwXSA+PgplbmRvYmoKNiAwIG9iago8PC9UeXBlL0NhdGFsb2cvUGFnZXMgMSAwIFI+PgplbmRvYmoKeHJlZgowIDYKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDEwIDAwMDAwIG4gCjAwMDAwMDAwMjAgMDAwMDAgbiAKdHJhaWxlcgo8PC9TaXplIDYvUm9vdCA2IDAgUi9JbmZvIDUgMCBSCj4+CnN0YXJ0eHJlZgozMAolRU9G';
    const downloadLink = document.createElement("a");
    downloadLink.href = base64String;
    downloadLink.download = "blank.pdf";
    downloadLink.click();
  }*/

    // Upload Bild aus Native (.net MAUI)
    uploadFromCameraNative(
        bereich: string,
        dateiname: string /* inkl. .suffix! */,
        objectURL: string,
    ) {
        // objectURL z.B. data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAjVBMVEX///8AAAD5+fnv7++jo6PU1NT7+/v39/fGxsb09PTOzs6FhYXl5eWtra3x8fHr6+u2trZwcHDd3d1iYmKbm5s9PT3Z2dm1tbU/Pz+lpaWQkJAZGRmJiYl1dXUUFBQsLCxYWFg0NDRMTExkZGRycnIkJCR9fX0LCwtQUFBaWlo3NzcYGBggICC/v78QEBD8K2nnAAAPQ0lEQVR4nO1c2ZaqOhClFBAZRBQFEUfE6Uj//+fdVEIQlVHx9jlrZb80tiGkkqpdQ4KSJCAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg8JdhnPz2CL6NxVkd4N/h5LdH8i3osInIHxvk3x7Jt2ACyjYA0H97JN+CCkAs8XLe//ZAvocTkdAD3/3tcXwPG9AkgPi3h/FF+DA+APwrTDp5Y6AbWAP8Izo62f2clbY3WQD+zP/GcL4AgKlDjKoNtGQPYMn/iKc4AsFMaiWi7RIJp/CtIXULm8i334zH7dZjh9Pyj9DMCuCimOa41U0TFPAfoZkhGeqFaF2rm3ooIPwbPIM6GoI1bXfXgUrY8qZfQoRhyakdZahXIt7qBOGXxtQpFICb25YyHLRBoqjRlwbVKWYAzhaCVvfoREAH1fvcoHFv9d7AugIJTC4JVOvo0H3ylD6VjeSHywZPSH43QUZK1KRbdcTmg/XwmczIbMJWsvYBfSkyPxrhpyCu8DhZWpVtLDhKo/w/rnDqS1TQeqqJndpZsMcqeciXVprQDMSwqWyjEnke/J4H4LEvyPTUPWEGuYpcOCwZxeUIi/rRvoMN9WrVOhpC5OcfTwhmy67W9Vo6f6ji+Ga/sNUCtcEv/u4zuFTAQ2WbPjbJmRKJ1mKVXd7qJTQAetkHK56ZtKdE6fV6+WZaZMk7CHtSxzCpgFDdr4FNctoV3H0nkbBu3rPAbrs9RvRpp91+SgJ9gMAN3GOoRfJEGs5AdhzSXTB4W5hC+PjEn2oDGMKjhD24l0fXmYKX5V0agEEvRnJwuEEZ/Ptl0OU6yrTzmh4DbJRzewYJ0lPo1NMQDCRQi+8msc89YyFyLH3fn0WH1V2iWWRYyTEvbrvgowpMR+tyQtrovkSEfG1+TViEjl8Fr0RbkW2z5na+o4k2tjRtnk6vg+RlZDJ2RatUNeqquRY2umUfh/mU0OYJ4vlWImGSX37S1brkKUTdB1Jk2xbj9uW62kE3BNVRqIs3Ymx0d8Z7mN2/Q5aN0BAD8O3XWwkIpdyD0m2pAk7uujz+g2QUhX67dLwITEfrsl7vcZ0jmOWCmz7vwYNLoYQYEnr8A1JWCfO6+aoyNfy1654/rXFhgldbrlboNGQqEz6aLZUQRdNhWyihlTfDRRYovMB/mGmTmo8vedFHRSA6U6e64tr+wV/KuZxeHfbNCaTeToFd4ers8ma4KWW10fM3bso3i+Oo+I4GoGUkqNP18YMme3TNlUUwva431+1lhR6cxqVKsT2jBhj8g1auMWSp50/DQ2uEnSId3i51rbEHp6aRSgVkYflVwfX0lCMhD9/wPE82HORSSjx6sYSk6T3k3ZQ7gTMcXtbKtbCMsDb1mAvfaxUKHJuwDHNQJ7xyDlCGTSDLx0IJUU9+2KWp43iLE4tHD5Rhl5gXpHEPCVg15e2l5PZC6Pe1qcCARxjWrFQ+WB6PQeIWSrjNlFSFMZQnWlaxFwkiSfnDJnEHP16rgFU94X3zumZ0Hmg4NjJwCeCoEz4ZmIqe+OObbs5Jgw3VQq9IQno7Y8MoQO4oc717KN4xMfcmI8T2gZzT6CYlT0Y6PGaRCU1riauk3ydFwyeD27BClQfYV1nRCq25iDLJCviH25508wOLfX2QM7gPQWvCMkjhADzKxvDgocrAAm1uzFpRMTICP5zzZlCyThJ1DbPX/w4Tn9rGDIKRTvQ4qqcNa5b6nEEjR0GJMCOHa6quT1imhjYvkJDEM0fm7Re0p9tzA47NK9EMrH1m6PQ79biSxnFdJWdgrKi10nh0W9OY5g3ZvKM1uAV6skzpo1+wQhYPSZm2l565UeB5euYOl27R1+Utq3WZh7Fk1QTkQ8n+kUeai3notrbAN82pMh3juMBWdmkTo0AndjwkPbPRlnmzw1MkkGTZsPuoNToZsxxVBav9wDAtRr9QeyDNzHhUwkMlMC0Mn/yUP/qv3tzknsJmT7zMJ3OlIHjtPZKeldUBjOIpKcm00y+t8fTCbo+vNYG7kVMsB8qqcdPUq/ZeqRngD7tI+R42jqdPXkVc5NzI0M2s7/2AlJcL/F51F7klxARhXKzVKDu92Dxv0QSZnvAxn+LlemMo2/5wmycWwjM7dmXeSxkfVMl7PPram5V7KpT+2KDNCuI1uIT7Z8I/8XEvlpDDz479yeJx9LMLSTGS5Jw1On+UNNnAFf1S1QwD87Ref6sIYEMu4fGJSRbZEjIBnQyHWXze83jKltBqVpv8JMw+THzlw4op+072y6OaRbaCknOpCA7QxqgHcp8s9cj5kcUN+Z3i60Da87ayAk+IPz2U29+NJpI9p1FNuDPy3+Succcl9fXW9Fzqqlmmaqd3PCz0jnMrLQM8Vswle3P/8ITPd2fCVAU0NrVy5qe1/BKsMh1VltuqTQ2Pj54M9U9ODJMrbZ8qaV5ZjqFkZZ/Hj/I5HRaDe3LaqWuxrCRHhX3KaXQqhjX2isHcnDfM6VfAt0JY8JV/MFnzRTZnmWw0IYdu94oHLO5kG4HSPKce1NmbKpdgsyguFPIRKvwq18WaLzx9RN60eg88GbMhJFIap3V8/Ii7H7SYi6lIPF9E1WPJKqawyrmiarwnk6+lV/eKDLFKxjM2zUPL3RIzQ0NSfiCNtFsfHqwG3zzYrRQ3kCIu4Zkbl/NjoA5qvdJIaRr7qa885udhk9LOtXJhVGophqauIEpY4aj7A0ipNS6Xt8TlRoATi/5heAF37VXdTbTRj8AKcALcnLlpvEhKF6bU19gT1BFVGluqxLkPah7YHsMpt/WM36J0CffgTqu3Tonb3B9Bplt+Ws4n+OlyMkdebsUYTNw9JYuYT28KUgEvJTMeSUyAWRQJV+I/Nfce4RyCu0DPOb/Pv5YWyYdh5RIySrunlT1W7upkS+YRjMYcToV7qjkYbie1dj9y9gEEFq5dL6MnTKkoPzP9qKh3WVmxkYIlbN0fsmI1DSKfcUJWTxi5Ev/2M6st5Uihb91WGl1+4DmCnrInq9TtKu6+PAVCNM+6vitIKXhKFko2mt2SZdzUKOqPRoQ7a7s1qb9DHUN1xZWgscmOdjsr3xlR4alGPEwH0i0sJl9yQdbv02nUWDR1qq2nkunZLIxZn/qLtII/QaI6o4tlEemiPJIev6ik8Q2fyAQknmK+tNkC7NOEoIIDM7iESTcqJYcDpZqBOeVuY1zt7emcPCVKI4jjiqLcO6A7A+BeMN/v7di+N3mqPJw1O7dvkbj2JFFjwtXfsDiJ2S/1FRV76MOCPe8AVtBteErTpHiU2z5jli7XF4wpLFhoIFFXiinlD9P5hH3FtJRcKjaN7lVpOLJNPKGwcPu0gfHSIThnKK8dvwF6hEfmzn7A/ZGS5rW16JOg69SjfgZnx9/jwk3YNwzRwVnFWKSJaR61N9zE0haTHtWXV0kWQGObzo4NUfJydG7aq6zzW9P37Rxj7I+oHbJUL0jLiqOXw0HreOZHkWGEBtOYSTFZxxt92eHpcfQUlzkvM2FFYU0rcPNVUz4LI8uxqUw0NrrG6bDTKBN2l3CRzM3+a2p7LD59q8EKJ/rzgxgMOIahycuKO0hzPFNuXMxzY+84uUsIKZEqqUaWb6YMoWQDcwvUgtvshpYDMwsve09mzIcn+c0TURcsV8tpKcxoSaBX67lxQgortjZs0fFsGw+hCkgEGg+r1A00KPY/wwU38ShhpGuouLzr6opzVOpJArDO7wylcHREK7OzTNhr+/zTncnaQkHTk9PQgYo7cq417gbKq7Cwo319XpWimnThngKjmSbn7p/gXt1JMEezPaZG2GcqXnOaTIHyPCmBCSY4tcera4FBoJEJta1XDJUTrD3OaN6YhapjYgRLUyW0adrqWDO+fEngBWegFf5Py1K46bXKAkNk96pEhyKQNLWvB7tchTGYhVJkolA3Pu20S71yE4y6+3Kfl55c/vQdeJL4LoMsto/rYqXRXON5Vhzdo60xkdAZ6Cz+W1OxmriyEVSea00Pmn4WvKEhrE48OsIlLE4D1KEyDhxaYPBD1zmYj44qIesW9nVWF2RjThqEXEk1k6iwid8ivjyIqgUzXsNVid5vHgfmJYZmudH9wACZgj1sn2Pl8Yn00deoXaWmN2+wd7SqqVYsAAP50ye7UOi91Cx5SSBXsR6a87lxeg4ryYzK8qsTH6M1mRpOGC9bDRsk6aeauMwGPIxxfs09GgMLCJ6X6TmmhW4ShMo+fpUM8UMiMOLBX9mNMv5EUfJ2VV/8mNeGZX2aYxzeFzGk2Sr/pBWLhbjtp4all6f71pz67Us79+XWv9WnsRMZ7+52Ix3rGt49D1f7zatgM+fojpMkGdeUMoaehD4GeabGPTxg02CjkBY5nXfJ5oweLStyPyzh0pErluwZE10ydLqEbdIdnODa9IwV3oz3DtAisdjZmdVJtobLQ92aPUPXJX2LS9jKO2PYWd+Kut/o+tbbXn+Ip0gyxuNHrMIG1cNn4M4x2JeWEdas7l0yBjqqU7OC0SMCQiBqZjfsyNL2vfjBI7NyurasjqGSNin7ytvTe2RjE2+q3M9oYc3g7QM6gUl9W4PqeP4maJj9bWiZv7UlziGOHTV7wogf830LtkpDzHaJzk/T95roWfb2xzOomd/vclsuQGF/rXpIGle1VRhnx1laAMuUyn3VNp9uE8Rta39+41PbJiE/Pdi39IlzjHlzTwg/PKODAVgrltKbWiEDWYxruyESZpfCNvFHDSqT9UL4bfVu0MoK9DVo8y5/z3Hb7Icjcmg9JVLSRk93l0hp4m2bwl62Lt6+sQfqN7eDMAQ17vJtaaf9eN8gb7Ps1dMXTHbB2Ov0N0ffIPPdGy8yT5sM2iYztzEcqdM9ZK/9NtHknazWbBLZ20vJvXX9uwy3Bm9PdYJGhniadX6myvq8qNklZl1t6GRQ23r7L+P8aQT6gqDBO4z/J2Zd/wAMbvt3fpTwExS9AvcRmhUj/j/oXR8xVpZd/kZHB9h+vh/3iEPbxPDL0DvYU33E6S/7ScHOT6Z6f5ur6PQ4nPTwrv1fgbDz6Y4CHeJuDr10AatzTzEAqecf/x41lf90/Vu4iTzYeSQb+1tENDv/veYFrqJU81buPw77n/ht1k8w6Pzn8QQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBL6M/wC1NcFE5fWs5wAAAABJRU5ErkJggg==
        // wie aus https://www.base64-image.de/
        console.log("Checkliste.uploadFromCameraNative()");

        let fileUpload: FileUpload = null;
        let fileUpload_files: File[] = null;
        //let fileUpload_files:File[] = null;
        if (bereich == "B") {
            fileUpload = this.positionsdatenFotosFileUpload_behoben;
            fileUpload_files = this.positionsdatenFotosFileUpload_files_behoben;
        } else if (bereich == "M") {
            fileUpload = this.positionsdatenFotosFileUpload_mangel;
            fileUpload_files = this.positionsdatenFotosFileUpload_files_mangel;
        } else if (bereich == "A") {
            fileUpload = this.positionsdatenFotosFileUpload_allgemein;
            fileUpload_files =
                this.positionsdatenFotosFileUpload_files_allgemein;
        } else {
            // kann eigentlich nicht vorkommen, aber sicherheitshalber:
            alert(
                "Error: Bereich des Bildes ist nicht definiert (Mangel, Behoben, Allgemein)",
            );
        }

        //create File V1:
        //let newFile = new File([], dateiname + "." + dateiendung, {
        //  type: "image/" + (dateiendung),
        //});
        //newFile['_objectURL'] = objectURL;

        //create File V2:
        let newFile = this.dataURLtoFile(objectURL, dateiname);
        //Wichtig für die Vorschau:
        newFile["objectURL"] = objectURL;

        //TODO: Prüfen: create File V3: so macht primeNG das! (https://github.com/primefaces/primeng/blob/master/src/app/components/fileupload/fileupload.ts)
        //file.objectURL = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(files[i]));

        //newFile['_alreadyUploaded'] = /*false*/undefined;
        //newFile['_percentUploaded'] = 0;
        //newFile['_guid'] = '00000000-0000-0000-0000-000000000000';
        //newFile['_positionsdatenFoto'] = null;
        newFile["_bereich"] = bereich;
        console.log(
            "AuftragsChecklisteDetailComponent.uploadFromCameraNative() newFile/_alreadyUploaded:",
            newFile,
            newFile["_alreadyUploaded"],
        );

        // Upload File V1: funktioniert eigentlich - aber nicht, wenn von .NET MAUI aufgerufen. Da kommt es zu folgendem Effekt:
        // Datei wird eingetragen, aber danach scheint die gesamte optische Aktualisierung stecken zu bleiben!
        // erst, wenn man wieder ein Button drückt (egal welcher), kommmt
        // - die blaue succes Meldung
        // - der Neue Datei-Eintrag in der Vorschau
        // Das einzige was optisch unverzögert funktioniert sind alerts
        /*
    fileUpload._files.push(newFile);
    console.log("AuftragsChecklisteDetailComponent.uploadFromCameraNative() fileUpload/fileUpload_files:", fileUpload, fileUpload_files);

    //Achtung: wenn diese Methode nicht von AuftragsChecklisteDetailComponent selbst aufgerufen wurde, 
    //sondern z.B. aus appComponent (uploadFileFromApp())
    //erkennt ng/primeNg die Änderung nicht! Es funktioniert zwar, aber es erfolgt kein optischer Refresh, der die Datei sofort anzeigt!
    //Lösung: einmal das Array refreshen! - ODER BESSER: fileUpload.cd.markForCheck(); (https://github.com/primefaces/primeng/blob/master/src/app/components/fileupload/fileupload.ts)
      
    setTimeout(() => {
      //fileUpload_files = [...fileUpload_files];
      fileUpload.cd.markForCheck();
      setTimeout(() => {
        // nachdem das Array bestückt ist, den Event aufrufen, der auch aufgerufen werden würde, wenn man per Button Click eine neue Datei eingestellt hätte
        let newEvent = {
          files: [newFile]
        };
        console.log("AuftragsChecklisteDetailComponent.uploadFromCameraNative() newEvent:", newEvent);
        this.onNGFileInputSelect(newEvent, bereich); 
      }, 100);
    }, 100);
    */

        // Upload File V2: ganz anderer Ansatz:
        // wir simulieren die Bestückung des "<input type='file'>" (das bei primeNg fileUpload unsichtbar ist, aber existiert!)
        // funktioniert auch bei Aufruf aus .NET MAUI
        // Aber in der aktuellen Version funktioniert es auch nur, wenn 1mal bzw. mehrfach, wenn sich jedes mal der
        //      Dateiname ändert. Bei Camera-Einsatz ist das ja aber der Fall. (im Sim-Button auch!)
        fileUpload.clearInputElement(); // ggf. vorheriges Löschen - TODO: brauchen wir das wirklich ?

        // das native "<input type='file'>" finden:
        let nativeElement = fileUpload["el"].nativeElement;
        let firstChild = nativeElement.children[0];
        let firstChildFirstChild = firstChild.children[0];
        let firstChildFirstChildFirstChild = firstChildFirstChild.children[0]; // 1.child = der "Datei auswählen"-Button von PrimeNG // 2.child wäre der Kamera-Button
        console.log(
            "AuftragsChecklisteDetailComponent.uploadFromCameraNative() firstChildFirstChildFirstChild:",
            firstChildFirstChildFirstChild,
        );
        let inputs =
            firstChildFirstChildFirstChild.getElementsByTagName("input");
        let input = inputs[0];
        console.log(
            "AuftragsChecklisteDetailComponent.uploadFromCameraNative() input:",
            input,
        );

        // FileAuswahl über den "<input type='file'>" SIMULIEREN: https://dev.to/code_rabbi/programmatically-setting-file-inputs-in-javascript-2p7i
        let dataTransfer = new DataTransfer();
        dataTransfer.items.add(newFile);
        let fileList = dataTransfer.files;
        input.files = fileList;
        input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    resizeFileUpload() {
        console.log("Checkliste.resizeFileUpload(): not in use anymore! skip!");
        return;
    }

    unterschriftOnChangeKunde() {
        console.log("UserDetail.unterschriftOnChangeKunde()");
        let data = this.signaturePadKunde.getPNGData();
        //console.log("UserDetail.unterschriftOnChangeKunde() data:", data);
        //console.log("UserDetail.unterschriftOnChangeKunde() data.length:", data.length);
        this.CRUDItem.unterschriftKunde = data;
        this.CRUDForm.patchValue({
            // in das unsichtbare Input-Feld übernehmen
            unterschriftKunde: this.CRUDItem.unterschriftKunde,
        });
    }

    unterschriftOnChangePruefer() {
        console.log("UserDetail.unterschriftOnChangePruefer()");
        let data = this.signaturePadPruefer.getPNGData();
        this.CRUDItem.unterschriftPruefer = data;
        this.CRUDForm.patchValue({
            // in das unsichtbare Input-Feld übernehmen
            unterschriftPruefer: this.CRUDItem.unterschriftPruefer,
        });
    }

    posHasRequired() {
        let required = false;
        if (
            this.CRUDItem.positionsdaten[this.posSelected].checklistePosition
                .bewertung == true &&
            this.CRUDItem.positionsdaten[this.posSelected].checklistePosition
                .mussfeld == true
        ) {
            required = true;
        }
        this.CRUDItem.positionsdaten[
            this.posSelected
        ].positionsdatenFelder.forEach((feld) => {
            if (feld.checklistePositionenFeld.mussfeld == true) {
                required = true;
            }
        });
        return required;
    }

    pruefePosition(setTouchedIfNoRequired: boolean) {
        //console.log("UserDetail.pruefePosition() this.CRUDItem:", this.CRUDItem);

        // touched nur setzen, wenn es KEIN Mussfeld Feld gibt aber man weitergeblättert hat -> dann gilt das als verarbeitet!
        // wenn es Mussfeld gibt ist das unnötig, weil das Klicken des Mussfelds verursacht bereits den _touched!
        if (setTouchedIfNoRequired == true) {
            let required = this.posHasRequired();
            if (required == false)
                this.CRUDItem.positionsdaten[this.posSelected]["_touched"] =
                    true;
        }

        let posErrors = [];
        if (
            this.CRUDItem.positionsdaten[this.posSelected].checklistePosition
                .bewertung == true
        ) {
            if (
                this.CRUDItem.positionsdaten[this.posSelected]
                    .checklistePosition.mussfeld == true
            ) {
                if (
                    this.CRUDItem.positionsdaten[this.posSelected]
                        .bewertungIO == false &&
                    this.CRUDItem.positionsdaten[this.posSelected]
                        .bewertungNiO == false &&
                    this.CRUDItem.positionsdaten[this.posSelected]
                        .bewertungBehoben == false &&
                    this.CRUDItem.positionsdaten[this.posSelected]
                        .checklistePosition.mussfeld == true
                ) {
                    let posError = {
                        checklistePositionenFeldId: null,
                        message:
                            "Bitte wählen Sie 'i.O.' oder 'n.i.O.' und ggf. 'behoben'",
                    };
                    posErrors.push(posError);
                }

                if (
                    this.CRUDItem.positionsdaten[this.posSelected]
                        .bewertungNiO == true &&
                    (this.positionsdatenFotosFileUpload_files_mangel == null ||
                        this.positionsdatenFotosFileUpload_files_mangel
                            .length == 0)
                ) {
                    if (
                        this.CRUDItem.positionsdaten[this.posSelected]
                            .checklistePosition.mangelFotosMussfeld == true
                    ) {
                        let posError = {
                            checklistePositionenFeldId:
                                /*-2*/ this
                                    .posErrorChecklistePositionenFeldId_FotoDesMangels,
                            message:
                                "Bitte fügen Sie mindestens ein Foto des Mangels ein",
                        };
                        posErrors.push(posError);
                    }
                }
            }

            // Prüfungen, die auch sein sollen, wenn KEIN Mussfeld:
            if (
                this.CRUDItem.positionsdaten[this.posSelected].bewertungIO ==
                    true &&
                (this.CRUDItem.positionsdaten[this.posSelected].bewertungNiO ==
                    true ||
                    this.CRUDItem.positionsdaten[this.posSelected]
                        .bewertungBehoben == true)
            ) {
                let posError = {
                    checklistePositionenFeldId: null,
                    message:
                        "'i.O.' kann nicht gleichzeitig mit 'n.i.O.' / 'behoben' ausgewählt werden",
                };
                posErrors.push(posError);
            }

            if (
                this.CRUDItem.positionsdaten[this.posSelected].bewertungNiO ==
                    true &&
                (this.CRUDItem.positionsdaten[this.posSelected].bemerkung ==
                    null ||
                    this.CRUDItem.positionsdaten[this.posSelected].bemerkung
                        .length == 0)
            ) {
                let posError = {
                    checklistePositionenFeldId:
                        /*-1*/ this
                            .posErrorChecklistePositionenFeldId_BemerkungDesMangels,
                    message:
                        "Bitte geben Sie eine kurze Beschreibung des Mangels an",
                };
                posErrors.push(posError);
            }

            if (
                this.CRUDItem.positionsdaten[this.posSelected].bemerkung !=
                    null &&
                this.CRUDItem.positionsdaten[this.posSelected].bemerkung
                    .length > 300
            ) {
                let posError = {
                    checklistePositionenFeldId:
                        /*-1*/ this
                            .posErrorChecklistePositionenFeldId_BemerkungDesMangels,
                    message:
                        "Bei Bemerkung zum Mangel sind maximal 300 Zeichen möglich",
                };
                posErrors.push(posError);
            }

            if (
                this.CRUDItem.positionsdaten[this.posSelected]
                    .bewertungBehoben == true &&
                (this.CRUDItem.positionsdaten[this.posSelected]
                    .bemerkungBehoben == null ||
                    this.CRUDItem.positionsdaten[this.posSelected]
                        .bemerkungBehoben.length == 0)
            ) {
                let posError = {
                    checklistePositionenFeldId:
                        /*-1*/ this
                            .posErrorChecklistePositionenFeldId_BemerkungDerBehebung,
                    message:
                        "Bitte geben Sie eine kurze Beschreibung der Behebung an",
                };
                posErrors.push(posError);
            }
            if (
                this.CRUDItem.positionsdaten[this.posSelected]
                    .bemerkungBehoben != null &&
                this.CRUDItem.positionsdaten[this.posSelected].bemerkungBehoben
                    .length > 300
            ) {
                let posError = {
                    checklistePositionenFeldId:
                        /*-1*/ this
                            .posErrorChecklistePositionenFeldId_BemerkungDerBehebung,
                    message:
                        "Bei Bemerkung zur Behebung sind maximal 300 Zeichen möglich",
                };
                posErrors.push(posError);
            }
            if (
                this.CRUDItem.positionsdaten[this.posSelected]
                    .bewertungBehoben == true &&
                (this.positionsdatenFotosFileUpload_files_behoben == null ||
                    this.positionsdatenFotosFileUpload_files_behoben.length ==
                        0)
            ) {
                if (
                    this.CRUDItem.positionsdaten[this.posSelected]
                        .checklistePosition.behobenFotosMussfeld == true
                ) {
                    let posError = {
                        checklistePositionenFeldId:
                            /*-2*/ this
                                .posErrorChecklistePositionenFeldId_FotoDerBehebung,
                        message:
                            "Bitte fügen Sie mindestens ein Foto der Behebung ein",
                    };
                    posErrors.push(posError);
                }
            }

            // wenn Fehler im Tab Mangel oder Bewertung -> dann auch Tab aufklappen!
            /*       try {
        let idxM = posErrors.findIndex(f => f.checklistePositionenFeldId == this.posErrorChecklistePositionenFeldId_BemerkungDesMangels || f.checklistePositionenFeldId == this.posErrorChecklistePositionenFeldId_FotoDesMangels);
        if(idxM > -1) {
          this.positionsdatenFotoAccordionSelected_mangel == true;
        }

        let idxB = posErrors.findIndex(f => f.checklistePositionenFeldId == this.posErrorChecklistePositionenFeldId_BemerkungDerBehebung || f.checklistePositionenFeldId == this.posErrorChecklistePositionenFeldId_FotoDerBehebung);
        if(idxB > -1) {
          this.positionsdatenFotoAccordionSelected_behoben == true;
        }
      }
      catch(e) {
        console.log("UserDetail.pruefePosition() warning - exception:", e);
      }
*/
        }

        //this.CRUDItem.positionsdaten[this.posSelected].checklistePosition.checklistePositionenFelder.forEach(feld => {
        this.CRUDItem.positionsdaten[
            this.posSelected
        ].positionsdatenFelder.forEach((feld) => {
            if (
                feld.checklistePositionenFeld.mussfeld == true &&
                (feld.feldwert == null || feld.feldwert.length == 0) &&
                (feld.feldwertBinary == null || feld.feldwertBinary.length == 0)
            ) {
                let posError = {
                    checklistePositionenFeldId: feld.checklistePositionenFeldId,
                    message: "Bitte Wert eintragen",
                };
                posErrors.push(posError);
            }
            // Prüfung, dass string und text-Eigaben maximal 1000 Zeichen gross sein dürfen. Ggf. kürz getValuesFromForm() vor dem Save! // siehe auch *TEXT1000
            if (
                (feld.checklistePositionenFeld.typ == "string" ||
                    feld.checklistePositionenFeld.typ == "text") &&
                feld.feldwert.length > this.posFeldTextMaxLen
            ) {
                let posError = {
                    checklistePositionenFeldId: feld.checklistePositionenFeldId,
                    message: this._translate
                        .instant(
                            "Die Eingabe darf maximal $NNN$ Zeichen betragen. Beim Zwischenspeichern wird ggf. gekürzt!",
                            true,
                        )
                        .replace("$NNN$", "" + this.posFeldTextMaxLen),
                };
                posErrors.push(posError);
            }
        });

        if (
            this.CRUDItem.positionsdaten[this.posSelected].checklistePosition
                .fotos == true
        ) {
            if (
                this.CRUDItem.positionsdaten[this.posSelected]
                    .checklistePosition.fotosMussFeld == true
            ) {
                if (
                    this.positionsdatenFotosFileUpload_files_allgemein ==
                        null ||
                    this.positionsdatenFotosFileUpload_files_allgemein.length ==
                        0
                ) {
                    let posError = {
                        checklistePositionenFeldId:
                            this
                                .posErrorChecklistePositionenFeldId_FotoAllgemein,
                        message:
                            "Bitte fügen Sie mindestens ein " +
                            (this.CRUDItem.positionsdaten[this.posSelected]
                                .checklistePosition.fotosSindDokumente
                                ? "Dokument"
                                : "Foto") +
                            " ein",
                    };
                    posErrors.push(posError);
                }
            }
        }

        this.CRUDItem.positionsdaten[this.posSelected]["_valid"] =
            posErrors.length == 0;

        //console.log("UserDetail.pruefePosition() returns:", posErrors);
        return posErrors;
    }

    posErrorsHaveMangelErrors(posErrors) {
        let idxMangelError = posErrors.findIndex(
            (f) =>
                f.checklistePositionenFeldId ==
                    this
                        .posErrorChecklistePositionenFeldId_BemerkungDesMangels ||
                f.checklistePositionenFeldId ==
                    this.posErrorChecklistePositionenFeldId_FotoDesMangels,
        );
        return idxMangelError > -1;
    }

    posErrorsHaveBehebungErrors(posErrors) {
        let idxBehebungError = posErrors.findIndex(
            (f) =>
                f.checklistePositionenFeldId ==
                    this
                        .posErrorChecklistePositionenFeldId_BemerkungDerBehebung ||
                f.checklistePositionenFeldId ==
                    this.posErrorChecklistePositionenFeldId_FotoDerBehebung,
        );
        return idxBehebungError > -1;
    }

    posPrepareAllAutoCompletes() {
        //console.log("AuftragsChecklisteDetailComponent.posPrepareAllAutoCompletes()");
        this.CRUDItem.positionsdaten[
            this.posSelected
        ].positionsdatenFelder.forEach((feld) => {
            if (feld.typ == "combobox") {
                this.posAutoCompleteSearch(feld, null);
                console.log(
                    "AuftragsChecklisteDetailComponent.posPrepareAllAutoCompletes() feld:",
                    feld,
                );
            } else if (feld.typ == "dropdown") {
                // erstellt ein object mit {feldwert: 'xxx', bezeichnung: 'yyy'}
                let foundObj =
                    feld.checklistePositionenFeld.checklistePositionenFeldwerte.filter(
                        (item) =>
                            item.feldwert
                                .toUpperCase()
                                .indexOf(feld.feldwert.toUpperCase()) == 0,
                    );
                if (foundObj != null && foundObj.length == 1)
                    feld.___feldwert___asObj = foundObj[0];
                else delete feld.___feldwert___asObj;

                this.posAutoCompleteSearchForDropDown(feld, null);
                console.log(
                    "AuftragsChecklisteDetailComponent.posPrepareAllAutoCompletes() feld:",
                    feld,
                );
            }
        });
    }

    posAutoCompleteSearch(feld: any, $event) {
        console.log(
            "UserDetail.posAutoCompleteSearch() feld/event:",
            feld,
            $event,
        );
        // "___checklistePositionenFeldwerte___filtered" soll die "checklistePositionenFeldwerte" enthalten, aber aufbereitet (nur als String!, kein Obj!)
        // und eben hier gefiltert

        let filteredOptionsAsString = [];
        feld.checklistePositionenFeld.checklistePositionenFeldwerte.forEach(
            (checklistePositionenFeldwert) => {
                filteredOptionsAsString.push(
                    checklistePositionenFeldwert.feldwert,
                );
            },
        );

        if ($event != null && $event.query != null) {
            filteredOptionsAsString = filteredOptionsAsString.filter(
                (item) =>
                    item.toUpperCase().indexOf($event.query.toUpperCase()) > -1,
            );
        }

        feld.checklistePositionenFeld.___checklistePositionenFeldwerte___filtered =
            filteredOptionsAsString;
    }

    posAutoCompleteSearchForDropDown(feld: any, $event) {
        console.log(
            "UserDetail.posAutoCompleteSearchForDropDown() feld/event:",
            feld,
            $event,
        );
        // "___checklistePositionenFeldwerte___filteredForDropDown" soll die "checklistePositionenFeldwerte" enthalten, aber aufbereitet (als Obj!)
        // und eben hier gefiltert

        let filteredOptionsAsObject = [];
        feld.checklistePositionenFeld.checklistePositionenFeldwerte.forEach(
            (checklistePositionenFeldwert) => {
                filteredOptionsAsObject.push(checklistePositionenFeldwert);
            },
        );

        if ($event != null && $event.query != null) {
            filteredOptionsAsObject = filteredOptionsAsObject.filter(
                (item) =>
                    item.bezeichnung
                        .toUpperCase()
                        .indexOf($event.query.toUpperCase()) > -1,
            );
        }

        feld.checklistePositionenFeld.___checklistePositionenFeldwerte___filteredForDropDown =
            filteredOptionsAsObject;
    }

    posMarkAsTouchedAndReCalc() {
        this.CRUDItem.positionsdaten[this.posSelected]["_touched"] = true;
        console.log(
            "UserDetail.posMarkAsTouchedAndReCalc() positionsdaten:",
            this.CRUDItem.positionsdaten[this.posSelected],
        );

        // feststellen, welches die letzte nicht-ausgeblendete Pos ist + ob es offene Mängel gibt ...
        this.updatePosEnabled(); // ... dazu müssen auch erst alle Pos mit _ENABLED markiert werden
        this.calcLetzteSichtbarePosUndOffeneMaengelExist();
    }
    posCheckBoxNiOClicked() {
        console.log("UserDetail.posCheckBoxNiOClicked()");
        if (this.CRUDItem.positionsdaten[this.posSelected].bewertungNiO != true)
            this.CRUDItem.positionsdaten[this.posSelected].bewertungBehoben =
                false;

        if (
            this.CRUDItem.positionsdaten[this.posSelected].bewertungNiO == true
        ) {
            this.positionsdatenFotoAccordionSelected_mangel = true;
            this.positionsdatenFotoAccordionSelected_behoben = false;
        }

        this.posMarkAsTouchedAndReCalc();
    }
    posCheckBoxBehobenClicked() {
        console.log("UserDetail.posCheckBoxBehobenClicked()");

        if (
            this.CRUDItem.positionsdaten[this.posSelected].bewertungBehoben ==
            true
        ) {
            this.positionsdatenFotoAccordionSelected_mangel = false;
            this.positionsdatenFotoAccordionSelected_behoben = true;
        }

        this.posMarkAsTouchedAndReCalc();
    }
    posCheckBoxIOClicked($event) {
        console.log("UserDetail.posCheckBoxIOClicked() $event:", $event);
        this.posMarkAsTouchedAndReCalc();

        // speziell wenn zuvor durch "in Ordnung" weitergeblättert wurde liefert der nä. Click (Pos 2) zwar event = true, aber das Model ist noch false!
        // daher:
        // als erstes:
        //if($event == true || $event == false) this.CRUDItem.positionsdaten[this.posSelected].bewertungIO = $event;

        // wenn "in Ordnung" geklickt, dann weiter
        if (
            this.CRUDItem.positionsdaten[this.posSelected].bewertungIO == true
        ) {
            let _posTab = document.getElementById("posTab");
            let _posTabClassesSave = _posTab.className;

            _posTab.className += " fadeIn";
            setTimeout(() => {
                _posTab.className = _posTabClassesSave;
            }, 1000);

            setTimeout(() => {
                // ohne timeout funktioniert der ZWEITE "In Ordnung" nicht! Es geht nicht auf true!
                // auf letzter Pos gibt es aber ein spez. Event:
                if (
                    this.posSelected ==
                    this.CRUDItem.positionsdaten.length - 1
                ) {
                    this.weiterZuKopfClicked(false);
                } else {
                    this.weiterClicked(false);
                }
            }, 10);
        }
    }

    posFeldCheckBoxClicked(
        feld: IPositionsdatenFelder,
        feldCheckBox: Checkbox,
    ) {
        console.log(
            "UserDetail.posFeldCheckBoxClicked() feldCheckBox:",
            feldCheckBox,
        );
        //alert("UserDetail.posFeldCheckBoxClicked() feldCheckBox.model:" + feldCheckBox.model);
        feld.feldwert = feldCheckBox.model == true ? "T" : "F";

        this.posMarkAsTouchedAndReCalc();
    }

    posFeldSelectButtonClicked(
        feld: IPositionsdatenFelder,
        feldSelectButton: SelectButton,
    ) {
        console.log(
            "UserDetail.posFeldSelectButtonClicked() feldSelectButton:",
            SelectButton,
        );
        //alert("UserDetail.posFeldSelectButtonClicked() feldSelectButton.model:" + SelectButton.model);
        //feld.feldwert = SelectButton.model == true ? "T" : "F";

        this.posMarkAsTouchedAndReCalc();
    }

    posFeldSignatureChanged(
        signaturePad: CRUDBasicSignatureComponent,
        feld: IPositionsdatenFelder,
    ) {
        console.log(
            "UserDetail.posFeldSignatureChanged() signaturePad, feld:",
            signaturePad,
            feld,
        );

        let data = signaturePad.getPNGData();
        //console.log("UserDetail.unterschriftOnChangeKunde() data:", data);
        //console.log("UserDetail.unterschriftOnChangeKunde() data.length:", data.length);
        feld.feldwertBinary = data;
        //this.CRUDForm.patchValue({  // in das unsichtbare Input-Feld übernehmen
        //  unterschriftKunde: this.CRUDItem.unterschriftKunde,
        //});

        this.posMarkAsTouchedAndReCalc();
    }

    posFeldContainerNrChanged(
        autocomplete: CRUDBasicAutocompleteComponent,
        feld: IPositionsdatenFelder,
    ) {
        console.log(
            "UserDetail.posFeldContainerNrChanged() autocomplete, feld:",
            autocomplete,
            feld,
        );

        // *** CONTAINER_FELDWERT
        // feld.feldwert enthält WÄHREND CRUDBasicAutocompleteComponent das komplette Objekt:
        // { id: 131753, interneBehaelterNummer: "0000042639", ...}
        // während dem Editieren soll das so bleiben - ist notwendig für crud-basic-autocomplete
        // Auf der Datenbank enthält feldwert aber nur die id !!!
        // Daher:
        // Bei Start: alle feldwerte des Typs containerNr -> ersetzen durch objekt
        // Bei Save: alle feldwerte des Typs containerNr -> objekt ersetzen durch id

        this.posMarkAsTouchedAndReCalc();
    }

    posFeldDropDownChanged(feld: IPositionsdatenFelder) {
        console.log("UserDetail.posFeldDropDownChanged() feld:", feld);
        if (feld["___feldwert___asObj"] != null)
            feld.feldwert = feld["___feldwert___asObj"].feldwert;
        else feld.feldwert = null;

        this.posMarkAsTouchedAndReCalc();
    }

    posFeldDropDownClear(feld, $event) {
        console.log("UserDetail.posFeldDropDownClear() feld:", feld);
        delete feld["___feldwert___asObj"];
        feld.feldwert = null;

        this.posMarkAsTouchedAndReCalc();
    }

    posOnFocusTime(feld: IPositionsdatenFelder) {
        // autom. bei 1. Klick eine Zeit einstellen: https://stackoverflow.com/questions/61237597/primeng-timeonly-calendar-cannot-select-default-time-intuitively
        console.log(
            "UserDetail.posOnFocusTime() feld.feldwert, feld:",
            feld.feldwert,
            feld,
        );
        if (feld.feldwert == null) {
            //let posFeldTimeLastBlurredTime_milli = this.posFeldTimeLastBlurredTime != null ? this.posFeldTimeLastBlurredTime.getTime() : 0;
            //let now_milli = new Date().getTime();
            //console.log("UserDetail.posOnFocusTime() posFeldTimeLastBlurredTime_milli/now_milli:", posFeldTimeLastBlurredTime_milli, now_milli);
            //if(this.posFeldTimeLastBlurredField != feld || posFeldTimeLastBlurredTime_milli + 1000 < now_milli) {
            console.log("UserDetail.posOnFocusTime() set default");
            let currentTime = new Date();
            let zeitAlsDate: any = new Date("January 1, 0001 00:00:00 GMT");
            zeitAlsDate.setUTCFullYear(1);
            zeitAlsDate.setHours(currentTime.getHours());
            zeitAlsDate.setMinutes(currentTime.getMinutes());
            feld.feldwert = zeitAlsDate;

            this.posMarkAsTouchedAndReCalc();
            //}
            //else {
            //  // Feld wurde gerade erst geblurrt -> also nicht neu bestücken!
            //  console.log("UserDetail.posOnFocusTime() skip since just blurred");
            //}
        }
    }

    posOnSelectTime(feld: IPositionsdatenFelder) {
        //console.log("UserDetail.posOnSelectTime() feld.feldwert:", feld.feldwert);
    }

    posOnBlurTime(feld: IPositionsdatenFelder) {
        console.log(
            "UserDetail.posOnBlurTime() feld.feldwert, feld:",
            feld.feldwert,
            feld,
        );
        //this.posFeldTimeLastBlurredField = feld;
        //this.posFeldTimeLastBlurredTime = new Date();
    }

    public hasTouchedPositions() {
        let touchedPositionIdx = this.CRUDItem.positionsdaten.findIndex(
            (f) => f["_touched"] == true,
        );
        let retValue = touchedPositionIdx >= 0;
        console.log(
            "Auftragscheckliste.onNGFileInputSelect().hasTouchedPositions:",
            retValue,
        );
        return retValue;
    }

    afterSaveCRUDItem() {
        // Overwrite!
        //nach Speichern sind ja alle Pos wieder "untouched". Das ist wichtig, weil der deactive-Guard nach hasTouchedPositions() fragt
        let touchedPositions = this.CRUDItem.positionsdaten.filter(
            (f) => f["_touched"] == true,
        );
        touchedPositions.forEach((positionsdaten) => {
            positionsdaten["_touched"] = false; // damit bei Abfrage von hasTouchedPositions() aus dem deactive-guard kein true kommt!
        });
    }

    onNGFileInputSelect(event, bereich) {
        console.log(
            "Auftragscheckliste.onNGFileInputSelect().event/bereich:",
            event,
            bereich,
        );

        // in der App: Event senden für nativen upload -> Das passiert so gar nicht! siehe stattdessen uploadFromX()
        /*if(this.app.inAppMode == true) {
      // nur bei App: Bild wird "nativ"/MAUI aufgenommen - und per JS an uploadFromCameraNative() gesandt
      if(window.navigator.userAgent.indexOf('DLPApp_Android') >= 0  || window.navigator.userAgent.indexOf('DLPApp_iOS') >= 0) {
        console.log("Checkliste.onNGFileInputSelect() Android / iOS = upload 'native'");

        setTimeout(() => {
          let eventData = {
              eventType: "fotoPicker",
              data: JSON.stringify(
              {
                bereich: bereich,
                acceptImage: true,
                acceptPDF: bereich == 'A' ? true : false
              })
          };
          this.app.sendMessageToDotNet(eventData);
        }, 10);		

        return;
      }
    }*/

        //this.app.writeAppDebugLog("Auftragscheckliste.onNGFileInputSelect().event:"+ event, 0); // US 33968: Test Android Kamera
        //this.app.writeAppDebugLog("Auftragscheckliste.onNGFileInputSelect().bereich:"+ bereich, 0); // US 33968: Test Android Kamera
        //let fileUpload = bereich == 'B' ? this.positionsdatenFotosFileUpload_behoben : this.positionsdatenFotosFileUpload_mangel;
        //let fileUpload_files = bereich == 'B' ? this.positionsdatenFotosFileUpload_files_behoben : this.positionsdatenFotosFileUpload_files_mangel;
        let fileUpload: FileUpload = null;
        let fileUpload_files: File[] = null;
        if (bereich == "B") {
            fileUpload = this.positionsdatenFotosFileUpload_behoben;
            fileUpload_files = this.positionsdatenFotosFileUpload_files_behoben;
        } else if (bereich == "M") {
            fileUpload = this.positionsdatenFotosFileUpload_mangel;
            fileUpload_files = this.positionsdatenFotosFileUpload_files_mangel;
        } else if (bereich == "A") {
            fileUpload = this.positionsdatenFotosFileUpload_allgemein;
            fileUpload_files =
                this.positionsdatenFotosFileUpload_files_allgemein;
        } else {
            // kann eigentlich nicht vorkommen, aber sicherheitshalber:
            alert(
                "Error: Bereich des Bildes ist nicht definiert (Mangel, Behoben, Allgemein)",
            );
        }

        //let fileToUpload : File = event.files[0];
        for (let i: number = 0; i < event.files.length; i++) {
            let fileToUpload: File = event.files[i];
            console.log(
                "Auftragscheckliste.onNGFileInputSelect() fileToUpload:",
                fileToUpload,
            );
            //this.app.writeAppDebugLog("Auftragscheckliste.onNGFileInputSelect() fileToUpload:"+ fileToUpload, 0); // US 33968: Test Android Kamera

            /*const formData = new FormData();
      formData.append('file', fileToUpload, fileToUpload.name);
      let httpClient = this.positionsdatenFotosService.getHTTPClient();
      let apiBaseURL = this.positionsdatenFotosService.getApiBaseUrl();
      httpClient.post(apiBaseURL + 'positionsdatenFotos', formData, {reportProgress: true, observe: 'events'})
        .subscribe(event => {
          console.log("ArtikelDetail.uploadFile() event:", event);
          //if (event.type === HttpEventType.UploadProgress) {
            //let progress = Math.round(100 * event.loaded / event.total);
            //console.log("ArtikelDetail.uploadFile() progress:", progress);
          //}
          //else if (event.type === HttpEventType.Response) {
          //  console.log("ArtikelDetail.uploadFile() success!");
          //}
        });
      */

            /*
      // nicht nur das file uploaden, sondern auch die Entity "PositionsdatenFoto"
      let positionsdatenFotoForCreate = this.positionsdatenFotosService.initializePositionsdatenFoto();
      let dateiendung = fileToUpload.name.substr(fileToUpload.name.lastIndexOf('.') + 1);
      let dateiname = fileToUpload.name.substr(0, fileToUpload.name.length - (dateiendung.length + 1));
      positionsdatenFotoForCreate.dateiname = dateiname;
      positionsdatenFotoForCreate.dateiendung = dateiendung;
      positionsdatenFotoForCreate.bezeichnung = fileToUpload.name;
      positionsdatenFotoForCreate.sortierung = 99;
      */

            // in die fileUpload-Liste eintragen - in die interne von primeNg (._files) ist es schon - aber nicht im parameter positionsdatenFotosFileUpload_files - also:
            // nur noch das eingetragene suchen - und als "noch nicht upgeloaded" markieren - UND IN den parameter positionsdatenFotosFileUpload_files rüberkopieren
            // ACHTUNG HIER AUSNAHME ZU
            // this.positionsdatenFotosFileUpload.files + this.positionsdatenFotosGalleryImages IMMER GLEICHZIEHEN, this.CRUDItem.positionsdatenFotos nur bei getValuesFromForm akualisieren!
            // GRUND: positionsdatenFotosGalleryImages wird beim onSuccess aktualisiert
            /*
      let positionsdatenFotosFilesOhneKennzeichnungAlreadyUploaded = this.positionsdatenFotosFileUpload_files.filter(f => f['_alreadyUploaded'] == undefined);
      let positionsdatenFotosFilesOhneKennzeichnungAlreadyUploadedMitDemNamen = positionsdatenFotosFilesOhneKennzeichnungAlreadyUploaded.filter(f => f.name == fileToUpload.name);
      positionsdatenFotosFilesOhneKennzeichnungAlreadyUploadedMitDemNamen.forEach(file => {
        file['_alreadyUploaded'] = false;
        file['_percentUploaded'] = 0;
        file['_guid'] = null;
      });
      */
            let positionsdatenFotosFilesOhneKennzeichnungAlreadyUploaded =
                fileUpload._files.filter(
                    (f) => f["_alreadyUploaded"] == undefined,
                );
            let positionsdatenFotosFilesOhneKennzeichnungAlreadyUploadedMitDemNamen =
                positionsdatenFotosFilesOhneKennzeichnungAlreadyUploaded.filter(
                    (f) => f.name == fileToUpload.name,
                );
            positionsdatenFotosFilesOhneKennzeichnungAlreadyUploadedMitDemNamen.forEach(
                (file) => {
                    file["_alreadyUploaded"] = false;
                    file["_percentUploaded"] = 0;
                    file["_guid"] = null;
                    file["_bereich"] = bereich;

                    fileUpload_files.push(file);
                },
            );

            //this.positionsdatenFotosService.uploadPositionsdatenFoto(fileToUpload, positionsdatenFotoForCreate, this, this.uploadProgress, this.uploadSuccess);
        }
        console.log(
            "Auftragscheckliste.onNGFileInputSelect() fileUpload.files:",
            fileUpload.files,
        );
        //this.app.writeAppDebugLog("Auftragscheckliste.onNGFileInputSelect() fileUpload.files:"+ fileUpload.files, 0); // US 33968: Test Android Kamera

        setTimeout(() => {
            this.uploadNextPositionsdatenFoto();
        }, 200);

        //this.CRUDItem.positionsdaten['_touched'] == true;
        this.posMarkAsTouchedAndReCalc();
    }
    uploadNextPositionsdatenFoto() {
        console.log("Auftragscheckliste.uploadNextPositionsdatenFoto()");
        if (this.positionsdatenFotoIsUploading == true) {
            console.log(
                "Auftragscheckliste.uploadNextPositionsdatenFoto() 1 upload is running already - wait/retry!",
            );
            setTimeout(() => {
                this.uploadNextPositionsdatenFoto();
            }, 500);
        } else {
            let fileUpload: FileUpload =
                this.positionsdatenFotosFileUpload_mangel;
            let index = fileUpload.files.findIndex(
                (i) => i["_alreadyUploaded"] == false,
            ); // zuerst prüfen, ob es in Mangel noch was hochzuladen gibt
            if (index >= 0) {
                this.positionsdatenFotoIsUploading = true;
                let fileToUpload = fileUpload.files[index];
                this._uploadNextPositionsdatenFotoFor1FileUpload(
                    fileUpload,
                    fileToUpload,
                );
            } else {
                fileUpload = this.positionsdatenFotosFileUpload_behoben;
                let index = fileUpload.files.findIndex(
                    (i) => i["_alreadyUploaded"] == false,
                ); // ansonsten prüfen, ob es in Behoben noch was hochzuladen gibt
                if (index >= 0) {
                    this.positionsdatenFotoIsUploading = true;
                    let fileToUpload = fileUpload.files[index];
                    this._uploadNextPositionsdatenFotoFor1FileUpload(
                        fileUpload,
                        fileToUpload,
                    );
                } else {
                    fileUpload = this.positionsdatenFotosFileUpload_allgemein;
                    let index = fileUpload.files.findIndex(
                        (i) => i["_alreadyUploaded"] == false,
                    ); // ansonsten prüfen, ob es in Allgemein noch was hochzuladen gibt
                    if (index >= 0) {
                        this.positionsdatenFotoIsUploading = true;
                        let fileToUpload = fileUpload.files[index];
                        this._uploadNextPositionsdatenFotoFor1FileUpload(
                            fileUpload,
                            fileToUpload,
                        );
                    } else {
                        console.log(
                            "Auftragscheckliste.uploadNextPositionsdatenFoto() keine weiteren Uploads warten -> Ende!!",
                        );
                    }
                }
            }
        }
    }
    _uploadNextPositionsdatenFotoFor1FileUpload(
        fileUpload: FileUpload,
        fileToUpload: File,
    ) {
        console.log(
            "Auftragscheckliste._uploadNextPositionsdatenFotoFor1FileUpload() fileUpload.files/fileToUpload:",
            fileUpload.files,
            fileToUpload,
        );
        this.positionsdatenFotoAktuellUploadingFile = fileToUpload; // merken für die progress-Rückmeldung
        console.log(
            "Auftragscheckliste._uploadNextPositionsdatenFotoFor1FileUpload() next fileToUpload:",
            fileToUpload,
        );

        // nicht nur das file uploaden, sondern auch die Entity "PositionsdatenFoto"
        let positionsdatenFotoForCreate =
            this.positionsdatenFotosService.initializePositionsdatenFotos();
        delete positionsdatenFotoForCreate["bild"]; // sonst kommen die Parameter beim Controller nicht an!
        let dateiendung = fileToUpload.name.substr(
            fileToUpload.name.lastIndexOf(".") + 1,
        );
        let dateiname = fileToUpload.name.substr(
            0,
            fileToUpload.name.length - (dateiendung.length + 1),
        );
        //positionsdatenFotoForCreate.dateiname = dateiname;
        positionsdatenFotoForCreate.dateiendung = dateiendung;
        //positionsdatenFotoForCreate.bezeichnung = fileToUpload.name;
        //positionsdatenFotoForCreate.sortierung = 99;
        positionsdatenFotoForCreate.bemerkung = dateiname;
        //positionsdatenFotoForCreate.behoben = fileToUpload['_bereich'] == 'B';
        positionsdatenFotoForCreate.bereich = fileToUpload["_bereich"];

        //try {
        this.positionsdatenFotosService.uploadPositionsdatenFotoToTemp(
            fileToUpload,
            positionsdatenFotoForCreate,
            this,
            this.uploadProgress,
            this.uploadSuccess,
            this.uploadError,
        );
        //}
        //catch(e) {
        //  console.error("Auftragscheckliste.uploadNextPositionsdatenFoto() error:", e);
        //  this.handleError(e);
        //}
    }

    uploadError(thisInstance: AuftragsChecklisteDetailComponent, error: any) {
        console.log("Auftragscheckliste.uploadError() error:", error);
        thisInstance.handleError(error);
        //thisInstance.messageWrapperService.postTimedMessage({severity: 'info', summary: 'Upload: '+progress, detail: ''});
    }
    uploadProgress(
        thisInstance: AuftragsChecklisteDetailComponent,
        progress: number,
    ) {
        console.log("Auftragscheckliste.uploadProgress() progress:", progress);
        //thisInstance.messageWrapperService.postTimedMessage({severity: 'info', summary: 'Upload: '+progress, detail: ''});

        if (thisInstance.positionsdatenFotoAktuellUploadingFile != null) {
            thisInstance.positionsdatenFotoAktuellUploadingFile[
                "_percentUploaded"
            ] = progress;
        }
    }
    uploadSuccess(
        thisInstance: AuftragsChecklisteDetailComponent,
        eventbody: any,
    ) {
        console.log("Auftragscheckliste.uploadSuccess()");
        let originalFileName: string = eventbody.originalFileName;
        let guid: string = eventbody.guid;
        //let behoben = eventbody.behoben;
        let bereich = eventbody.bereich;
        console.log(
            "Auftragscheckliste.uploadSuccess() originalFileName:",
            originalFileName,
        );
        console.log("Auftragscheckliste.uploadSuccess() guid:", guid);
        thisInstance.messageWrapperService.postTimedMessage({
            severity: "info",
            summary:
                "Datei " + originalFileName + ": Upload erfolgreich!" /*+guid*/,
            detail: "",
        });

        let dateiendung = originalFileName.substr(
            originalFileName.lastIndexOf(".") + 1,
        );
        let dateiname = originalFileName.substr(
            0,
            originalFileName.length - (dateiendung.length + 1),
        );
        // this.positionsdatenFotosFileUpload.files + this.positionsdatenFotosGalleryImages IMMER GLEICHZIEHEN, this.CRUDItem.positionsdatenFotos nur bei getValuesFromForm akualisieren!
        let newPositionsdatenFoto: IPositionsdatenFotos =
            thisInstance.positionsdatenFotosService.initializePositionsdatenFotos();
        newPositionsdatenFoto.positionsdaten = null;
        newPositionsdatenFoto.positionsdatenId =
            thisInstance.CRUDItem.positionsdaten[thisInstance.posSelected].id;
        //newPositionsdatenFoto.dateiname = dateiname;
        newPositionsdatenFoto.dateiendung = dateiendung;
        //newPositionsdatenFoto.bezeichnung = originalFileName;
        newPositionsdatenFoto.bemerkung = originalFileName;
        newPositionsdatenFoto.guid = guid;
        //newPositionsdatenFoto.behoben = behoben;
        newPositionsdatenFoto.bereich = bereich;
        //newPositionsdatenFoto.sortierung = 99;
        newPositionsdatenFoto.id = 0;
        thisInstance.CRUDItem.positionsdaten[
            thisInstance.posSelected
        ].positionsdatenFotos.push(newPositionsdatenFoto);
        //let fileUpload = /*behoben*/bereich == 'B' ? thisInstance.positionsdatenFotosFileUpload_behoben : thisInstance.positionsdatenFotosFileUpload_mangel;
        //let fileUpload_files = /*behoben*/bereich == 'B' ? thisInstance.positionsdatenFotosFileUpload_files_behoben : thisInstance.positionsdatenFotosFileUpload_files_mangel;
        let fileUpload: FileUpload = null;
        let fileUpload_files: File[] = null;
        if (bereich == "B") {
            fileUpload = thisInstance.positionsdatenFotosFileUpload_behoben;
            fileUpload_files =
                thisInstance.positionsdatenFotosFileUpload_files_behoben;
        } else if (bereich == "M") {
            fileUpload = thisInstance.positionsdatenFotosFileUpload_mangel;
            fileUpload_files =
                thisInstance.positionsdatenFotosFileUpload_files_mangel;
        } else if (bereich == "A") {
            fileUpload = thisInstance.positionsdatenFotosFileUpload_allgemein;
            fileUpload_files =
                thisInstance.positionsdatenFotosFileUpload_files_allgemein;
        } else {
            // kann eigentlich nicht vorkommen, aber sicherheitshalber:
            alert(
                "Error: Bereich des Bildes ist nicht definiert (Mangel, Behoben, Allgemein)",
            );
        }

        // das File als uploaded markieren
        let positionsdatenFotosFilesMitDemDateinamen = fileUpload.files.filter(
            (f) => f.name == originalFileName,
        );
        positionsdatenFotosFilesMitDemDateinamen.forEach((file) => {
            file["_alreadyUploaded"] = true;
            file["_percentUploaded"] = 100;
            file["_guid"] = guid;
        });

        console.log(
            "Auftragscheckliste.uploadSuccess() fileUpload.files:",
            fileUpload.files,
        );

        // in gallery eintragen
        //let newImage: Image = new Image();
        //newImage.title = originalFileName;
        //newImage.thumbnailImageSrc = thisInstance.positionsdatenFotosService.getThumbDownloadUrl(guid, dateiendung);
        //newImage.previewImageSrc = thisInstance.positionsdatenFotosService.getDownloadUrl(guid, dateiendung);
        //thisInstance.positionsdatenFotosGalleryImages.push(newImage);

        // war das das 1. Bild ? dann einmalig auf Gallery switchen (nur beim 1. Mal, danach soll User manuell switchen)
        /*if(thisInstance.positionsdatenFotosAlreadySwitchedToGallery == false && thisInstance.positionsdatenFotosGalleryImages.length == 1) {
      thisInstance.positionsdatenFotosDisplayGalleryOrUpload = 'G';
    }
    thisInstance.positionsdatenFotosAlreadySwitchedToGallery = true;*/

        // 1. Bild ? Dann als Titelbild markieren
        //if (thisInstance.positionsdatenFotosGalleryImages.length == 1) {
        //  console.log("Auftragscheckliste.uploadSuccess() setting positionsdatenFotosTitlePicGuid:", guid);
        //  thisInstance.positionsdatenFotosTitlePicGuid = guid;
        //  thisInstance.positionsdatenFotosUseAsEditorBackground();
        //}

        thisInstance.positionsdatenFotoAktuellUploadingFile = null; // merken für die progress-Rückmeldung

        // jetzt (nachdem 1 File fertig ist) -> das nächste uploaden.
        setTimeout(() => {
            thisInstance.positionsdatenFotoIsUploading = false;
            thisInstance.uploadNextPositionsdatenFoto();
        }, 200);
    }

    onNGFileInputRemove($event) {
        console.log(
            "AuftragsChecklisteDetailComponent.onNGFileInputRemove()   NOT IN USE!",
        );
    }

    posFileUploadUpdate(skipPhotoUpdate?: boolean) {
        // skipPhotoUpdate: wird genutzt beim Start, wo alle Pos geprüft werden (wäre im Browser nicht relevant, aber würde app-performance beeinträchtigen)
        console.log(
            "AuftragsChecklisteDetailComponent.posFileUploadUpdate() posSelected/CRUDItem.positionsdaten[posSelected].positionsdatenFotos:",
            this.posSelected,
            this.CRUDItem.positionsdaten[this.posSelected].positionsdatenFotos,
        );
        this.positionsdatenFotosFileUpload_files_mangel = [];
        this.positionsdatenFotosFileUpload_files_behoben = [];
        this.positionsdatenFotosFileUpload_files_allgemein = [];
        this.CRUDItem.positionsdaten[
            this.posSelected
        ].positionsdatenFotos.forEach((positionsdatenFoto) => {
            let newFile = new File(
                [],
                positionsdatenFoto.dateiname +
                    "." +
                    positionsdatenFoto.dateiendung,
                {
                    type: "image/" + positionsdatenFoto.dateiendung,
                },
            );
            //newFile['objectURL'] = this.positionsdatenFotosService.getThumbDownloadUrl(positionsdatenFoto.guid, positionsdatenFoto.dateiendung);
            //this.positionsdatenFotosService.setThumbDownloadUrl(positionsdatenFoto.guid, positionsdatenFoto.dateiendung, newFile, 'objectURL');
            //console.log("AuftragsChecklisteDetailComponent.posFileUploadUpdate() newFile['objectURL']:", newFile['objectURL']);

            //warum auch immer: das aktuelle primeNG macht auf "objectURL='http://localhost..." -> "blob:http://localhost" -> daher nochmal separat sepeichern:
            //Update: auf 'objectURL' kann man wohl verzichten, nur '_objectURL' reicht!
            //newFile['_objectURL'] = this.positionsdatenFotosService.getThumbDownloadUrl(positionsdatenFoto.guid, positionsdatenFoto.dateiendung);
            if (skipPhotoUpdate != true)
                this.positionsdatenFotosService.setThumbDownloadUrl(
                    positionsdatenFoto.guid,
                    positionsdatenFoto.dateiendung,
                    newFile,
                    "_objectURL",
                );

            //let fileObj = (Object)newFile;
            //fileObj['name'] = positionsdatenFoto.dateiname + "." + positionsdatenFoto.dateiendung;
            newFile["_alreadyUploaded"] = true;
            newFile["_percentUploaded"] = 100;
            newFile["_guid"] = positionsdatenFoto.guid;
            newFile["_positionsdatenFoto"] = positionsdatenFoto; // gleich die entity mit ranhängen, erleichtert das Aktualisieren des CRUDItems bei Save
            //newFile['_bereich'] = positionsdatenFoto.behoben ? "B" : "M";
            newFile["_bereich"] = positionsdatenFoto.bereich;
            console.log(
                "AuftragsChecklisteDetailComponent.posFileUploadUpdate() adding file to positionsdatenFotosFileUpload.files:",
                newFile,
            );
            /*if(positionsdatenFoto.behoben == true) {
        this.positionsdatenFotosFileUpload_files_behoben.push(newFile);  
      }
      else {
        this.positionsdatenFotosFileUpload_files_mangel.push(newFile);
      }*/
            if (positionsdatenFoto.bereich == "M") {
                this.positionsdatenFotosFileUpload_files_mangel.push(newFile);
            } else if (positionsdatenFoto.bereich == "B") {
                this.positionsdatenFotosFileUpload_files_behoben.push(newFile);
            } else if (positionsdatenFoto.bereich == "A") {
                this.positionsdatenFotosFileUpload_files_allgemein.push(
                    newFile,
                );
            } else {
                // kann eigentlich nicht vorkommen, aber sicherheitshalber:
                alert(
                    "Error: Bereich des Bildes ist nicht definiert (Mangel, Behoben, Allgemein)",
                );
            }
        });
    }

    positionenBilderDeleteFile(file, bereich) {
        console.log(
            "AuftragsChecklisteDetailComponent.positionenBilderDeleteFile() file:",
            file,
        );
        //console.log("AuftragsChecklisteDetailComponent.positionenBilderDeleteFile() this:", this);
        //let fileUpload = bereich == 'B' ? this.positionsdatenFotosFileUpload_behoben : this.positionsdatenFotosFileUpload_mangel;
        //let fileUpload_files = bereich == 'B' ? this.positionsdatenFotosFileUpload_files_behoben : this.positionsdatenFotosFileUpload_files_mangel;
        let fileUpload: FileUpload = null;
        let fileUpload_files: File[] = null;
        if (bereich == "B") {
            fileUpload = this.positionsdatenFotosFileUpload_behoben;
            fileUpload_files = this.positionsdatenFotosFileUpload_files_behoben;
        } else if (bereich == "M") {
            fileUpload = this.positionsdatenFotosFileUpload_mangel;
            fileUpload_files = this.positionsdatenFotosFileUpload_files_mangel;
        } else if (bereich == "A") {
            fileUpload = this.positionsdatenFotosFileUpload_allgemein;
            fileUpload_files =
                this.positionsdatenFotosFileUpload_files_allgemein;
        } else {
            // kann eigentlich nicht vorkommen, aber sicherheitshalber:
            alert(
                "Error: Bereich des Bildes ist nicht definiert (Mangel, Behoben, Allgemein)",
            );
        }

        let index = fileUpload_files.findIndex((f) => f == file);
        let indexCrudItem = this.CRUDItem.positionsdaten[
            this.posSelected
        ].positionsdatenFotos.findIndex((f) => f.guid == file._guid);
        if (index >= 0 && indexCrudItem >= 0) {
            console.log(
                "AuftragsChecklisteDetailComponent.positionenBilderDeleteFile() deleting file:",
                file,
            );

            // zuvor: ist das zu löschende Bild das Titelbild ? Dann autom. das 1. verbleibende als Titelbild wählen
            //let titelbidlGeloescht: boolean = this.positionsdatenFotosFileUpload_files[index]['_guid'] == this.artikelBilderTitlePicGuid;

            //delete this.artikelbilderFileUpload.files[index];
            fileUpload_files.splice(index, 1); // im parameter löschen
            fileUpload._files.splice(index, 1); // im primeNg internen Parm auch löschen
            console.log(
                "AuftragsChecklisteDetailComponent.positionenBilderDeleteFile() positionsdatenFotosFileUpload._files:",
                fileUpload._files,
            );
            console.log(
                "AuftragsChecklisteDetailComponent.positionenBilderDeleteFile() positionsdatenFotosFileUpload_files:",
                fileUpload_files,
            );

            // auch direkt im cruditem löschen
            this.CRUDItem.positionsdaten[
                this.posSelected
            ].positionsdatenFotos.splice(indexCrudItem, 1);
            console.log(
                "AuftragsChecklisteDetailComponent.positionenBilderDeleteFile() CRUDItem.positionsdaten[posSelected].positionsdatenFotos:",
                this.CRUDItem.positionsdaten[this.posSelected]
                    .positionsdatenFotos,
            );
            //this.CRUDItem.positionsdaten['_touched'] == true;
            this.posMarkAsTouchedAndReCalc();

            // von Gallery löschen
            //this.artikelBilderGalleryImages.splice(index, 1);

            // NICHT aus CRUDItem löschen - weil:
            // this.artikelbilderFileUpload.files + this.artikelBilderGalleryImages IMMER GLEICHZIEHEN, this.CRUDItem.artikelbilder nur bei getValuesFromForm akualisieren!
            //this.CRUDItem.artikelbilder.splice(index, 1);

            // war das zu löschende Bild das Titelbild ? Dann autom. das 1. verbleibende als Titelbild wählen
            //if (titelbidlGeloescht == true) {
            //  if (this.artikelbilderFileUpload.files.length > 0) this.artikelBilderTitlePicGuid = this.artikelbilderFileUpload.files[0]['_guid'];
            //  else this.artikelBilderTitlePicGuid = "00000000";
            //}
        } else {
            console.log(
                "AuftragsChecklisteDetailComponent.positionenBilderDeleteFile() file to delete NOT FOUND!",
            );
        }
    }

    positionenBilderDebug(file) {
        console.log(
            "AuftragsChecklisteDetailComponent.positionenBilderDebug() file:",
            file,
        );
    }

    getLeistungForAuftrag(auftrag: IAuftragsdaten) {
        let leistung = this.app.leistungen.find(
            (f) => f.leistung == auftrag.leistung,
        );
        //console.log('AuftragsChecklisteDetailComponent.getLeistungForAuftrag() leistung:', leistung);
        return leistung;
    }

    leitfadenClicked() {
        this.messageWrapperService.postTimedMessage({
            severity: "info",
            summary: "Leitfaden",
            detail: "Der Leitfaden wird heruntergeladen.",
        });
        this.dokumenteService.downloadDokumentViaBlob(
            this.checkliste.leitfadenId,
            "D",
        );
    }

    downloadAuftragsDokument(auftragsDokumentId: number) {
        this.messageWrapperService.postTimedMessage({
            severity: "info",
            summary: "Dokument",
            detail: "Das Dokument wird heruntergeladen.",
        });
        this.auftragsDokumentService.downloadDokumentViaBlob(
            auftragsDokumentId,
            "D",
        );
    }

    /*getValidChoiceList_PosDropdown() { // "simuliert" _CHOICELIST, weil wir im dropdown/autocomplete nicht das Objekt der Auswhal speichern wollen, sondern nur den alpha-value, eben wie bei _CHOICELIST, die sonst von der API kommt
    console.log('AuftragsChecklisteDetailComponent.getValidChoiceList_PosDropdown()');
    let options = {
      choiceListEntries: [
        {bezeichnung: 'Auswahl 1', value: 'A1'},
        {bezeichnung: 'Auswahl 2', value: 'A2'},
      ]
    };
    return of(options);
  }*/

    openChecklisteForDebug() {
        this.router.navigate(["/checkliste/" + this.checkliste.id]);
    }
    openLeistungForDebug() {
        this.router.navigate(["/leistung/" + this.leistung.leistung]);
    }

    updatePosFilterAbhaengigkeitenVomAuftragskopf() {
        // für alle Positionen prüfen, ob sie aufgrund einer Abhängigkeit vom Auftragskopf generell ausgefiltert werden können.
        //this.CRUDItem.positionsdaten.forEach(positionsdaten => {
        this.CRUDItem.positionsdaten.forEach(
            (positionsdaten: IPositionsdaten, index: number): void => {
                let abhaengigkeitValid = this.checkAbhaengigkeit(
                    positionsdaten,
                    true,
                    index,
                );
                if (abhaengigkeitValid == false) {
                    if (this.debugMode == true)
                        this.messageWrapperService.postStaticMessage({
                            severity: "info",
                            summary:
                                "DEBUG: " +
                                this.translate.instant(
                                    "Position wurde ausgefiltert",
                                    true,
                                ),
                            detail:
                                "Position " +
                                (index + 1) +
                                " '" +
                                positionsdaten.bezeichnung +
                                "' wurde aufgrund der Auftragsdaten ausgefiltert " +
                                "\n\n",
                        });
                    this.CRUDItem.positionsdaten =
                        this.CRUDItem.positionsdaten.filter(
                            (f) =>
                                f.checklistePositionId !=
                                positionsdaten.checklistePositionId,
                        );
                    this.checkliste.checklistePositionen =
                        this.checkliste.checklistePositionen.filter(
                            (f) => f.id != positionsdaten.checklistePositionId,
                        );
                    positionsdaten = null; // garbage collection
                }
            },
        );
    }
    updatePosEnabled() {
        // für alle Positionen das Kennzeichen '_enabled' aktualisieren // Achtung: zum Start wurden ggf. schon Pos. aufgrund einer Abhängigkeit vom Auftragskopf ausgefiltert
        //this.CRUDItem.positionsdaten.forEach(positionsdaten => {
        this.CRUDItem.positionsdaten.forEach(
            (positionsdaten: IPositionsdaten, index: number): void => {
                let abhaengigkeitValid = this.checkAbhaengigkeit(
                    positionsdaten,
                    false,
                    index,
                );
                positionsdaten["_enabled"] =
                    abhaengigkeitValid == false ? false : true; // nur wenn checkAbhaengigkeit() = false ist es NOT _enabled!, bei true oder null ist es _enabled!
            },
        );
    }

    checkAbhaengigkeitSingle(
        _abhaengigkeitAndOperator: I_Abhaengigkeit,
        thisComponent: AuftragsChecklisteDetailComponent,
    ) {
        //position: IPositionsdaten, auftragsdatenMode: boolean, indexForDebugging?:number) { // prüft eine einzelne Abhängigkeits-condition (da was zw. AND / OR steht) - wird über eval() aufgerufen
        //if(thisComponent.debugMode==true) console.log("AuftragsChecklisteDetailComponent.checkAbhaengigkeitSingle() position.checklistePosition.abhaengigkeit:", position.checklistePosition.abhaengigkeit);
        if (thisComponent.debugMode == true)
            console.log(
                "AuftragsChecklisteDetailComponent.checkAbhaengigkeitSingle() _abhaengigkeitAndOperator/thisComponent:",
                _abhaengigkeitAndOperator,
                thisComponent,
            );
        if (_abhaengigkeitAndOperator != null) {
            let operator = _abhaengigkeitAndOperator.operator;
            //let platzhalterFeld = _abhaengigkeitAndOperator.platzhalterFeld;
            let vergleichswert = _abhaengigkeitAndOperator.vergleichswert;
            //if(thisComponent.debugMode==true) console.log("AuftragsChecklisteDetailComponent.checkAbhaengigkeitSingle(): platzhalterFeld", platzhalterFeld);
            //let eingegebenerWert: string = platzhalterFeld.feldwert;
            let feldwert: string = _abhaengigkeitAndOperator.feldwert;
            let ergebnis: boolean = null;
            let typ = vergleichswert.indexOf("'") >= 0 ? "string" : "number"; // Fix 23.07.25: hier stand ' number'
            if (operator == "=") {
                if (typ == "string")
                    ergebnis = "'" + feldwert + "'" == vergleichswert;
                else ergebnis = "'" + feldwert + "'" == vergleichswert;
            } else if (operator == "<>") {
                if (typ == "string")
                    ergebnis = "'" + feldwert + "'" != vergleichswert;
                else ergebnis = "'" + feldwert + "'" != vergleichswert;
            } else if (operator == ">=") {
                if (typ == "number")
                    ergebnis = parseInt(feldwert) >= parseInt(vergleichswert);
                else ergebnis = feldwert >= vergleichswert;
            } else if (operator == "IN") {
                ergebnis = thisComponent.isInListOf(
                    feldwert,
                    vergleichswert,
                    typ,
                );
            } else if (operator == "NOT IN") {
                ergebnis = !thisComponent.isInListOf(
                    feldwert,
                    vergleichswert,
                    typ,
                );
            }

            //if(thisComponent.debugMode==true) console.log("AuftragsChecklisteDetailComponent.checkAbhaengigkeitSingle() position.bezeichnung/ergebnis/position: ", indexForDebugging != null ? (indexForDebugging+1) +". "+ position.bezeichnung : position.bezeichnung, ergebnis, position);
            return ergebnis;
        }
        return null;
    }

    checkAbhaengigkeit(
        position: IPositionsdaten,
        auftragsdatenMode: boolean,
        indexForDebugging?: number,
    ) {
        if (this.debugMode == true)
            console.log(
                "AuftragsChecklisteDetailComponent.checkAbhaengigkeit() position.checklistePosition.abhaengigkeit:",
                position.checklistePosition.abhaengigkeit,
            );
        let _abhaengigkeitenAndOperator: I_Abhaengigkeit[] =
            this.getAbhaengigkeitPos(position, auftragsdatenMode);
        if (_abhaengigkeitenAndOperator != null) {
            document["_checkAbh_checkAbhaengigkeitSingleFunc"] =
                this.checkAbhaengigkeitSingle;
            document["_checkAbh_abhaengigkeitenAndOperatoren"] = [];
            let evalString = "";
            _abhaengigkeitenAndOperator.forEach(
                (_abhaengigkeitAndOperator, index: number): void => {
                    if (_abhaengigkeitAndOperator.undOder == "AND")
                        evalString += " && ";
                    else if (_abhaengigkeitAndOperator.undOder == "OR")
                        evalString += " || ";

                    document["_checkAbh_abhaengigkeitenAndOperatoren"][index] =
                        _abhaengigkeitAndOperator;

                    evalString +=
                        "document._checkAbh_checkAbhaengigkeitSingleFunc(document._checkAbh_abhaengigkeitenAndOperatoren[" +
                        index +
                        "], this)";
                },
            );
            let retValue = eval(evalString);
            console.log(
                "AuftragsChecklisteDetailComponent.checkAbhaengigkeit() evalString/document._checkAbh_abhaengigkeitenAndOperatoren/returnValue:",
                evalString,
                document["_checkAbh_abhaengigkeitenAndOperatoren"],
                retValue,
            );
            return retValue;
        }
        return null;
    }

    getAbhaengigkeitPos(position: IPositionsdaten, auftragsdatenMode: boolean) {
        //if(this.debugMode==true) console.log("AuftragsChecklisteDetailComponent.getAbhaengigkeitPos() position.checklistePosition.abhaengigkeit:", position.checklistePosition.abhaengigkeit);
        if (position.checklistePosition.abhaengigkeit != null) {
            // 1. ermitteln ob ein AND / Or enthalten ist - ES WIRD NUR 1 AND oder OR unterstützt !!!
            let undOder =
                position.checklistePosition.abhaengigkeit.indexOf(" AND ") >= 0
                    ? "AND"
                    : position.checklistePosition.abhaengigkeit.indexOf(
                            " OR ",
                        ) >= 0
                      ? "OR"
                      : null;
            // 2. ein Array mit den Abhaengigkeiten erstellen (Ergebnis: Array mit 2 oder nur 1 Eintrag)
            let abhaengigkeiten = null;
            if (undOder != null) {
                abhaengigkeiten =
                    position.checklistePosition.abhaengigkeit.split(
                        " " + undOder + " ",
                    );
            } else {
                abhaengigkeiten = [position.checklistePosition.abhaengigkeit];
            }
            // 3. dieses Array abarbeiten
            let retValAbhaengigkeiten: I_Abhaengigkeit[] = [];
            abhaengigkeiten.forEach((abhaengigkeit, index: number): void => {
                //let abhaengigkeit = position.checklistePosition.abhaengigkeit;
                let operator = null;
                if (abhaengigkeit.indexOf(">=") >= 0) operator = ">=";
                else if (abhaengigkeit.indexOf("<>") >= 0) operator = "<>";
                else if (abhaengigkeit.indexOf("=") >= 0) operator = "=";
                else if (abhaengigkeit.indexOf("NOT IN") >= 0)
                    operator = "NOT IN";
                else if (abhaengigkeit.indexOf("IN") >= 0) operator = "IN";
                if (operator != null) {
                    let splits = abhaengigkeit.split(operator);
                    if (splits != null && splits.length == 2) {
                        let vergleichsvariable = splits[0].trim();
                        let vergleichswert = splits[1].trim();
                        //if(this.debugMode==true) console.log("AuftragsChecklisteDetailComponent.getAbhaengigkeitPos(): platzhalter/vergleichswert", platzhalter, vergleichswert);
                        let platzhalterChecklistenFeld: IChecklistePositionenFeld =
                            null;
                        if (auftragsdatenMode != true) {
                            // nur nach Abhängigkeiten von Auftragsdaten suchen!
                            this.checkliste.checklistePositionen.forEach(
                                (checklistePos) => {
                                    let _felder =
                                        checklistePos.checklistePositionenFelder.filter(
                                            (f) =>
                                                f.platzhalter ==
                                                vergleichsvariable,
                                        );
                                    if (
                                        _felder != null &&
                                        _felder.length == 1
                                    ) {
                                        platzhalterChecklistenFeld = _felder[0];
                                    }
                                },
                            );
                        }
                        if (platzhalterChecklistenFeld != null) {
                            // platzhalter-ChecklistenFeld gefunden!
                            //if(this.debugMode==true) console.log("AuftragsChecklisteDetailComponent.getAbhaengigkeitPos(): platzhalterChecklistenFeld", platzhalterChecklistenFeld);
                            let platzhalterFeld: IPositionsdatenFelder = null;
                            let platzhalterPositionsdaten: IPositionsdaten =
                                null;
                            let platzhalterPositionsdatenPositionNr: number =
                                null;
                            for (
                                let i = 0;
                                i < this.CRUDItem.positionsdaten.length;
                                i++
                            ) {
                                let positionsdaten =
                                    this.CRUDItem.positionsdaten[i];
                                let _felder =
                                    positionsdaten.positionsdatenFelder.filter(
                                        (f) =>
                                            f.checklistePositionenFeldId ==
                                            platzhalterChecklistenFeld.id,
                                    );
                                if (_felder != null && _felder.length == 1) {
                                    platzhalterFeld = _felder[0];
                                    platzhalterPositionsdaten = positionsdaten;
                                    platzhalterPositionsdatenPositionNr = i;
                                }
                            }
                            if (platzhalterFeld != null) {
                                // platzhalter-Feld gefunden!
                                //if(this.debugMode==true) console.log("AuftragsChecklisteDetailComponent.getAbhaengigkeitPos(): platzhalterFeld", platzhalterFeld);
                                let retVal: I_Abhaengigkeit = {
                                    undOder: index > 0 ? undOder : null,
                                    operator: operator,
                                    //platzhalterFeld: platzhalterFeld,
                                    feldwert: platzhalterFeld.feldwert,
                                    vergleichswert: vergleichswert,
                                    //summary: platzhalterFeld.checklistePositionenFeld.bezeichnung,
                                    summary:
                                        "Position " +
                                        (platzhalterPositionsdatenPositionNr +
                                            1) +
                                        ": '" +
                                        platzhalterPositionsdaten.bezeichnung +
                                        "'",
                                };

                                //return retVal;
                                retValAbhaengigkeiten.push(retVal);
                            }
                        } else {
                            // platzhalter-Feld (bzw. platzhalterChecklisten-Feld) NICHT gefunden! - Ist es ein Kopffeld ?
                            if (vergleichsvariable == "Verwaltungsdaten") {
                                let retVal: I_Abhaengigkeit = {
                                    undOder: index > 0 ? undOder : null,
                                    operator: operator,
                                    //platzhalterFeld: platzhalterFeld,
                                    feldwert:
                                        this.auftragsdaten.verwaltungsdaten,
                                    vergleichswert: vergleichswert,
                                    summary: "'" + vergleichsvariable + "'",
                                };

                                //return retVal;
                                retValAbhaengigkeiten.push(retVal);
                            }
                        }
                    }
                }
            });
            if (retValAbhaengigkeiten.length > 0) return retValAbhaengigkeiten;
            else return null;
        }
        return null;
    }

    summarizeAbhaengigkeitenSummaries(
        _abhaengigkeitenAndOperator: I_Abhaengigkeit[],
    ) {
        // aus dem Array der Abhaengigkeiten ein lesbares summary Feld erzeugen
        let summary = "";
        _abhaengigkeitenAndOperator.forEach((abhaengigkeit) => {
            summary +=
                (abhaengigkeit.undOder != null
                    ? " " + abhaengigkeit.undOder + " "
                    : "") + abhaengigkeit.summary;
        });
        return summary;
    }

    isInListOf(
        searchFor: any,
        listOfStrings: string,
        type: string /* 'string' / 'number' */,
    ) {
        // z.B. isInListOfStrings("'A1'", "'A0','A1','A2',A3'") -> true
        // dazu bauen wir ein array der Einzelwerte auf, um mit "includes()" arbeiten zu können // https://www.w3schools.com/jsref/jsref_includes_array.asp
        let arrayOfValues: any[] = [];
        let listOfStringsWithoutKlammer = listOfStrings.substring(
            1,
            listOfStrings.length - 1,
        );
        let listOfStringsSplit = listOfStringsWithoutKlammer.split(",");
        listOfStringsSplit.forEach((splitValue) => {
            if (type == "string") arrayOfValues.push(splitValue.trim());
            else if (type == "number")
                arrayOfValues.push(Number(splitValue.trim()));
        });
        let returnValue: boolean = null;
        if (type == "string")
            returnValue = arrayOfValues.includes("'" + searchFor + "'");
        else if (type == "number")
            returnValue = arrayOfValues.includes(searchFor);
        //console.log("AuftragsChecklisteDetailComponent.isInListOf() searchFor/listOfStrings/arrayOfValues/returnValue:", searchFor, listOfStrings, arrayOfValues, returnValue);
        return returnValue;
    }

    progressBarClicked() {
        console.log("AuftragsChecklisteDetailComponent.progressBarClicked()");
        if (this.debug_ProgressbarRefresh == true) location.reload();
    }

    calcLetzteSichtbarePosUndOffeneMaengelExist() {
        //console.log("AuftragsChecklisteDetailComponent.calcLetzteSichtbarePosUndOffeneMaengelExist()");
        this.posLetzteSichtbare = null;
        this.offeneMaengelExist = null;
        for (let i = this.CRUDItem.positionsdaten.length - 1; i >= 0; i--) {
            console.log(
                "AuftragsChecklisteDetailComponent.calcLetzteSichtbarePosUndOffeneMaengelExist() i/this.CRUDItem.positionsdaten[i]['_enabled']:",
                i,
                this.CRUDItem.positionsdaten[i]["_enabled"],
            );
            if (this.CRUDItem.positionsdaten[i]["_enabled"] != false) {
                if (this.posLetzteSichtbare == null)
                    this.posLetzteSichtbare = i;

                if (
                    this.CRUDItem.positionsdaten[i].checklistePosition
                        .bewertung == true &&
                    this.CRUDItem.positionsdaten[i].bewertungNiO == true &&
                    this.CRUDItem.positionsdaten[i].bewertungBehoben != true
                ) {
                    this.offeneMaengelExist = true;

                    break;
                }
            }
        }
        console.log(
            "AuftragsChecklisteDetailComponent.calcLetzteSichtbarePosUndOffeneMaengelExist() offeneMaengelExist/posLetzteSichtbare:",
            this.offeneMaengelExist,
            this.posLetzteSichtbare,
        );
    }

    pruefDatumFocused($event) {
        console.log(
            "AuftragsChecklisteDetailComponent.pruefDatumFocused() $event/pruefdatum:",
            $event,
            this.CRUDForm.value.pruefdatum,
        );
        this.pruefDatumValuePreviousValue = this.CRUDForm.value.pruefdatum;
    }

    pruefDatumChanged($event) {
        console.log(
            "AuftragsChecklisteDetailComponent.pruefDatumChanged() $event:",
            $event,
        );
        // alle Zusatzleistungen anpassen
        let _angepasst: boolean = false;
        let _pruefdatumPreviousString = this.crudItemService.dateToString(
            this.pruefDatumValuePreviousValue,
            true,
        );
        if (this.CRUDItem?.leistungenRueckgemeldet != null) {
            this.CRUDItem.leistungenRueckgemeldet.forEach(
                (leistungRueckgemeldet) => {
                    if (
                        leistungRueckgemeldet.lieferdatum == null ||
                        this.crudItemService.dateToString(
                            leistungRueckgemeldet.lieferdatum,
                            true,
                        ) == _pruefdatumPreviousString
                    ) {
                        if (
                            leistungRueckgemeldet.lieferdatum != null ||
                            this.CRUDForm.value.pruefdatum != null
                        )
                            _angepasst = true; // wenn beides schon null war, keine Meldung ausgeben (passiert z.B. beim Start)
                        leistungRueckgemeldet.lieferdatum =
                            this.CRUDForm.value.pruefdatum;
                    }
                },
            );
        }
        if (_angepasst) {
            this.messageWrapperService.postTimedMessage({
                severity: "info",
                summary: "Zusatzleistungen",
                detail: "Lieferdatum der Zusatzleistungen wurde angepasst.",
            });
        }
    }

    onCrudItemsValueChangeAuftragspositionen($event) {
        // Parent+Child-CRUD
        console.log(
            "Dienstleister.onCrudItemsValueChangeAuftragspositionen() this:",
            this,
        );
        console.log(
            "Dienstleister.onCrudItemsValueChangeAuftragspositionen() $event:",
            $event,
        );
        this.CRUDItem.auftragspositionen = $event;
        this.CRUDForm.markAsDirty();

        this.displayMessageForm = {}; // validity neu prüfen
        this.CRUDForm.updateValueAndValidity(); // validity neu prüfen
    }

    // Fix für das Problem, dass primeNg bei manueller Eingabe (Tastatur) eines Jahres den Wert nicht speichert.
    // primeNg 14 würde das funktionieren - aber nur wenn ngModel=Date - und wir haben: string
    yearpickerBlur(event: Event, feld: IPositionsdatenFelder) {
        console.log(
            "AuftragsChecklisteDetailComponent.yearpickerBlur() event/feld:",
            event,
            feld,
        );
        let inp = event.srcElement;
        //console.log("AuftragsChecklisteDetailComponent.yearpickerBlur() inp:", inp);
        //console.log("AuftragsChecklisteDetailComponent.yearpickerBlur() inp.value:", inp['value']);
        let value: any = inp["value"] + "";
        console.log(
            "AuftragsChecklisteDetailComponent.yearpickerBlur() value:",
            value,
        );
        if (value instanceof Date) {
            console.log(
                "AuftragsChecklisteDetailComponent.yearpickerBlur() value is already instanceOf Date! nothing to do!",
            );
        } else if (value == null || value == "") {
            console.log(
                "AuftragsChecklisteDetailComponent.yearpickerBlur() value is NULL! nothing to do!",
            );
        } else {
            console.log(
                "AuftragsChecklisteDetailComponent.yearpickerBlur() value is NOT instanceOf Date! - converting ...",
            );
            setTimeout(() => {
                let properyName = "feldwert";
                feld[properyName] = new Date(
                    value,
                    0 /*Jan=0!!!*/,
                    1,
                    0,
                    0,
                    0,
                    0,
                );
            }, 1);
        }
        //event.stopPropagation();
    }

    // Callback-Funktion als Parameter an Component übergeben - so das "this" = this des callers: https://stackoverflow.com/questions/35328652/angular-pass-callback-function-to-child-component-as-input-similar-to-angularjs
    autoCompleteFilterBehaelter = (CRUDItems: IBehaelter[]) => {
        if (this.debugMode == true)
            console.log(
                "AuftragsChecklisteDetailComponent.autoCompleteFilterProjekte() CRUDItems:",
                CRUDItems,
            );
        if (this.debugMode == true)
            console.log(
                "AuftragsChecklisteDetailComponent.autoCompleteFilterProjekte() this:",
                this,
            );

        // nur die anzeigen, deren Hersteller auch bekannt ist (sonst kann der Behälter nicht zurückgeschrieben werden nach Auftragsdaten!)
        let ungueltig = CRUDItems.filter((f) => {
            //console.debug("AuftragsChecklisteDetailComponent.autoCompleteFilterProjekte() CRUDItem f:", f);
        });

        return CRUDItems;
    };
    sendCallbackForAutoCompleteFilterBehaelter() {
        //console.log("AuftragsChecklisteDetailComponent.sendCallbackForAutoCompleteFilterBehaelter() ...");
        return this.autoCompleteFilterBehaelter;
    }

    ngOnDestroy(): void {
        console.log("AuftragsChecklisteDetailComponent.ngOnDestroy()");

        try {
            this.app.auftragComponent = null;
        } catch (e) {
            console.log(
                "AuftragsChecklisteDetailComponent.ngOnDestroy() error:",
                e,
            );
        }

        if (this.app.getMapComponent() != null) {
            this.app.iOSFixResizeWebview(
                "AuftragsChecklisteDetail.ngOnDestroy",
            );
        }
    }

    //debugPosFeld(feld) {
    //  console.log("AuftragsChecklisteDetailComponent.debugPosFeld() feld:", feld);
    //}

    toggelDokumenteDialogShow() {
        this.dokumenteDialogShow = true;
    }

    debug(tabView) {
        console.log(
            "AuftragsChecklisteDetailComponent.debug() app.dienstleister:",
            this.app.dienstleister,
        );
        console.log(
            "AuftragsChecklisteDetailComponent.debug() auftragsdaten.dienstleisterId:",
            this.auftragsdaten.dienstleisterId,
        );
        console.log(
            "AuftragsChecklisteDetailComponent.debug() dienstleister:",
            this.dienstleister,
        );
        console.log(
            "AuftragsChecklisteDetailComponent.debug() auftragsdaten:",
            this.auftragsdaten,
        );

        //console.log("AuftragsChecklisteDetailComponent.debug() positionsdatenFotosFileUpload_files_allgemein:", this.positionsdatenFotosFileUpload_files_allgemein);
        //console.log("AuftragsChecklisteDetailComponent.debug() unterschriftKunde:", this.CRUDForm.controls.unterschriftKunde);
        //console.log("AuftragsChecklisteDetailComponent.debug() unterschriftPruefer:", this.CRUDForm.controls.unterschriftPruefer);
        //this.isInListOf("A1", "('A0','A1','A2','A3')", 'string');
        //this.isInListOf(2, "(0,1,2,3)", 'number');
        console.log(
            "AuftragsChecklisteDetailComponent.debug() pos:",
            this.CRUDItem.positionsdaten[this.posSelected],
        );
        //this.checkAbhaengigkeit(this.CRUDItem.positionsdaten[this.posSelected]);
        //console.log("AuftragsChecklisteDetailComponent.debug() tabView:", tabView);
        //console.log("AuftragsChecklisteDetailComponent.debug() positionsdatenFotosFileUpload._files:", this.positionsdatenFotosFileUpload._files);
        //console.log("AuftragsChecklisteDetailComponent.debug() positionsdatenFotosFileUpload_files:", this.positionsdatenFotosFileUpload_files);
        //this.unterschriftOnChangeKunde();
        super.debug(null);
    }
}
